//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ScadsysIntegrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    loadAssessmentData(parameters: LoadAssessmentDataParameters, cancelToken?: CancelToken): Promise<Integration[]> {
        let url_ = this.baseUrl + "/api/Integration/Scadsys/$loadAssessmentData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoadAssessmentData(_response);
        });
    }

    protected processLoadAssessmentData(response: AxiosResponse): Promise<Integration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Integration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Integration[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Integration[]>(null as any);
    }
}

export class IntegrationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    getIntegrations( cancelToken?: CancelToken): Promise<Integration[]> {
        let url_ = this.baseUrl + "/api/Integrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrations(_response);
        });
    }

    protected processGetIntegrations(response: AxiosResponse): Promise<Integration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Integration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Integration[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Integration[]>(null as any);
    }

    postIntegration(integration: CreateIntegrationModel, cancelToken?: CancelToken): Promise<Integration> {
        let url_ = this.baseUrl + "/api/Integrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(integration);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostIntegration(_response);
        });
    }

    protected processPostIntegration(response: AxiosResponse): Promise<Integration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Integration.fromJS(resultData200);
            return Promise.resolve<Integration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Integration>(null as any);
    }

    getIntegration(id: string, cancelToken?: CancelToken): Promise<Integration> {
        let url_ = this.baseUrl + "/api/Integrations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegration(_response);
        });
    }

    protected processGetIntegration(response: AxiosResponse): Promise<Integration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Integration.fromJS(resultData200);
            return Promise.resolve<Integration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Integration>(null as any);
    }

    putIntegration(id: string, integration: UpdateIntegrationModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Integrations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(integration);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutIntegration(_response);
        });
    }

    protected processPutIntegration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteIntegration(id: string, cancelToken?: CancelToken): Promise<Integration> {
        let url_ = this.baseUrl + "/api/Integrations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIntegration(_response);
        });
    }

    protected processDeleteIntegration(response: AxiosResponse): Promise<Integration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Integration.fromJS(resultData200);
            return Promise.resolve<Integration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Integration>(null as any);
    }

    getIntegrations2(typePath: IntegrationType, typeBody: IntegrationType, cancelToken?: CancelToken): Promise<Integration[]> {
        let url_ = this.baseUrl + "/api/Integrations/Types/{type}";
        if (typePath === undefined || typePath === null)
            throw new Error("The parameter 'typePath' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + typePath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(typeBody);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrations2(_response);
        });
    }

    protected processGetIntegrations2(response: AxiosResponse): Promise<Integration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Integration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Integration[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Integration[]>(null as any);
    }

    enableTrigger(id: string, cancelToken?: CancelToken): Promise<Integration> {
        let url_ = this.baseUrl + "/api/Integrations/{id}/Trigger";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnableTrigger(_response);
        });
    }

    protected processEnableTrigger(response: AxiosResponse): Promise<Integration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Integration.fromJS(resultData200);
            return Promise.resolve<Integration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Integration>(null as any);
    }

    disableTrigger(id: string, cancelToken?: CancelToken): Promise<Integration> {
        let url_ = this.baseUrl + "/api/Integrations/{id}/Trigger";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableTrigger(_response);
        });
    }

    protected processDisableTrigger(response: AxiosResponse): Promise<Integration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Integration.fromJS(resultData200);
            return Promise.resolve<Integration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Integration>(null as any);
    }

    startIntegrationRun(id: string, cancelToken?: CancelToken): Promise<Integration[]> {
        let url_ = this.baseUrl + "/api/Integrations/{id}/Runs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartIntegrationRun(_response);
        });
    }

    protected processStartIntegrationRun(response: AxiosResponse): Promise<Integration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Integration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Integration[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Integration[]>(null as any);
    }
}

export class ImmersiveReaderClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    getToken( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ImmersiveReader/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToken(_response);
        });
    }

    protected processGetToken(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AuditClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    query(entityType: string | null | undefined, entityID: string | null | undefined, action: string | null | undefined, actorID: string | null | undefined, from: Date | null | undefined, to: Date | null | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<AuditPageModel> {
        let url_ = this.baseUrl + "/api/assessment/audit?";
        if (entityType !== undefined && entityType !== null)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (entityID !== undefined && entityID !== null)
            url_ += "EntityID=" + encodeURIComponent("" + entityID) + "&";
        if (action !== undefined && action !== null)
            url_ += "Action=" + encodeURIComponent("" + action) + "&";
        if (actorID !== undefined && actorID !== null)
            url_ += "ActorID=" + encodeURIComponent("" + actorID) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<AuditPageModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditPageModel.fromJS(resultData200);
            return Promise.resolve<AuditPageModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditPageModel>(null as any);
    }

    actions( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/assessment/audit/actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActions(_response);
        });
    }

    protected processActions(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class CurriculumTemplatesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    list( cancelToken?: CancelToken): Promise<CurriculumTemplateSummaryModel[]> {
        let url_ = this.baseUrl + "/api/assessment/curriculum-templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<CurriculumTemplateSummaryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CurriculumTemplateSummaryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CurriculumTemplateSummaryModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurriculumTemplateSummaryModel[]>(null as any);
    }

    preview(key: string, cancelToken?: CancelToken): Promise<CurriculumTemplatePreviewModel> {
        let url_ = this.baseUrl + "/api/assessment/curriculum-templates/{key}/preview";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<CurriculumTemplatePreviewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurriculumTemplatePreviewModel.fromJS(resultData200);
            return Promise.resolve<CurriculumTemplatePreviewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurriculumTemplatePreviewModel>(null as any);
    }

    getDraft(key: string, cancelToken?: CancelToken): Promise<CurriculumTemplateDraftModel> {
        let url_ = this.baseUrl + "/api/assessment/curriculum-templates/{key}/draft";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDraft(_response);
        });
    }

    protected processGetDraft(response: AxiosResponse): Promise<CurriculumTemplateDraftModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurriculumTemplateDraftModel.fromJS(resultData200);
            return Promise.resolve<CurriculumTemplateDraftModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurriculumTemplateDraftModel>(null as any);
    }

    saveDraft(key: string, model: CurriculumTemplateDraftWriteModel, cancelToken?: CancelToken): Promise<CurriculumTemplateDraftModel> {
        let url_ = this.baseUrl + "/api/assessment/curriculum-templates/{key}/draft";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDraft(_response);
        });
    }

    protected processSaveDraft(response: AxiosResponse): Promise<CurriculumTemplateDraftModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurriculumTemplateDraftModel.fromJS(resultData200);
            return Promise.resolve<CurriculumTemplateDraftModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurriculumTemplateDraftModel>(null as any);
    }

    discardDraft(key: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/curriculum-templates/{key}/draft";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscardDraft(_response);
        });
    }

    protected processDiscardDraft(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    apply(key: string, options: CurriculumTemplateApplyOptions | undefined, cancelToken?: CancelToken): Promise<CurriculumTemplateApplyResultModel> {
        let url_ = this.baseUrl + "/api/assessment/curriculum-templates/{key}/apply";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApply(_response);
        });
    }

    protected processApply(response: AxiosResponse): Promise<CurriculumTemplateApplyResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurriculumTemplateApplyResultModel.fromJS(resultData200);
            return Promise.resolve<CurriculumTemplateApplyResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurriculumTemplateApplyResultModel>(null as any);
    }
}

export class AssessmentStructureClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    getFaculty(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfFacultyAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/structure/GetFaculty/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFaculty(_response);
        });
    }

    protected processGetFaculty(response: AxiosResponse): Promise<TypedResponseOfFacultyAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfFacultyAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfFacultyAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfFacultyAPIModel>(null as any);
    }

    listFaculties( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfFacultyAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/structure/ListFaculties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListFaculties(_response);
        });
    }

    protected processListFaculties(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfFacultyAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfFacultyAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfFacultyAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfFacultyAPIModel>(null as any);
    }

    createFaculty(model: CreateFacultyRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/CreateFaculty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFaculty(_response);
        });
    }

    protected processCreateFaculty(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteFaculty(facultyID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/DeleteFaculty?";
        if (facultyID !== undefined && facultyID !== null)
            url_ += "facultyID=" + encodeURIComponent("" + facultyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFaculty(_response);
        });
    }

    protected processDeleteFaculty(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateFaculty(model: UpdateFacultyRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/UpdateFaculty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFaculty(_response);
        });
    }

    protected processUpdateFaculty(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    getSchool(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfSchoolAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/structure/GetSchool/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSchool(_response);
        });
    }

    protected processGetSchool(response: AxiosResponse): Promise<TypedResponseOfSchoolAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfSchoolAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfSchoolAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfSchoolAPIModel>(null as any);
    }

    listSchools( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfSchoolAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/structure/ListSchools";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSchools(_response);
        });
    }

    protected processListSchools(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfSchoolAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfSchoolAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfSchoolAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfSchoolAPIModel>(null as any);
    }

    createSchool(model: CreateSchoolRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/CreateSchool";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSchool(_response);
        });
    }

    protected processCreateSchool(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteSchool(schoolID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/DeleteSchool?";
        if (schoolID !== undefined && schoolID !== null)
            url_ += "schoolID=" + encodeURIComponent("" + schoolID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSchool(_response);
        });
    }

    protected processDeleteSchool(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateSchool(model: UpdateSchoolRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/UpdateSchool";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSchool(_response);
        });
    }

    protected processUpdateSchool(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    getQualification(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfQualificationAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/structure/GetQualification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualification(_response);
        });
    }

    protected processGetQualification(response: AxiosResponse): Promise<TypedResponseOfQualificationAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfQualificationAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfQualificationAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfQualificationAPIModel>(null as any);
    }

    listQualifications( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfQualificationAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/structure/ListQualifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListQualifications(_response);
        });
    }

    protected processListQualifications(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfQualificationAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfQualificationAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfQualificationAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfQualificationAPIModel>(null as any);
    }

    createQualification(model: CreateQualificationRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/CreateQualification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQualification(_response);
        });
    }

    protected processCreateQualification(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteQualification(qualificationID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/DeleteQualification?";
        if (qualificationID !== undefined && qualificationID !== null)
            url_ += "qualificationID=" + encodeURIComponent("" + qualificationID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQualification(_response);
        });
    }

    protected processDeleteQualification(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateQualification(model: UpdateQualificationRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/UpdateQualification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQualification(_response);
        });
    }

    protected processUpdateQualification(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    getQualificationLevel(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfQualificationLevelAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/structure/GetQualificationLevel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualificationLevel(_response);
        });
    }

    protected processGetQualificationLevel(response: AxiosResponse): Promise<TypedResponseOfQualificationLevelAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfQualificationLevelAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfQualificationLevelAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfQualificationLevelAPIModel>(null as any);
    }

    listQualificationLevels( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfQualificationLevelAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/structure/ListQualificationLevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListQualificationLevels(_response);
        });
    }

    protected processListQualificationLevels(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfQualificationLevelAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfQualificationLevelAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfQualificationLevelAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfQualificationLevelAPIModel>(null as any);
    }

    createQualificationLevel(model: CreateQualificationLevelRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/CreateQualificationLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQualificationLevel(_response);
        });
    }

    protected processCreateQualificationLevel(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteQualificationLevel(qualificationLevelID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/DeleteQualificationLevel?";
        if (qualificationLevelID !== undefined && qualificationLevelID !== null)
            url_ += "qualificationLevelID=" + encodeURIComponent("" + qualificationLevelID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQualificationLevel(_response);
        });
    }

    protected processDeleteQualificationLevel(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateQualificationLevel(model: UpdateQualificationLevelRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/UpdateQualificationLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQualificationLevel(_response);
        });
    }

    protected processUpdateQualificationLevel(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    getModule(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfModuleAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/structure/GetModule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModule(_response);
        });
    }

    protected processGetModule(response: AxiosResponse): Promise<TypedResponseOfModuleAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfModuleAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfModuleAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfModuleAPIModel>(null as any);
    }

    listModules( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfModuleAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/structure/ListModules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListModules(_response);
        });
    }

    protected processListModules(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfModuleAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfModuleAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfModuleAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfModuleAPIModel>(null as any);
    }

    createModule(model: CreateModuleRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/CreateModule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateModule(_response);
        });
    }

    protected processCreateModule(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteModule(moduleID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/DeleteModule?";
        if (moduleID !== undefined && moduleID !== null)
            url_ += "moduleID=" + encodeURIComponent("" + moduleID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteModule(_response);
        });
    }

    protected processDeleteModule(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateModule(model: UpdateModuleRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/structure/UpdateModule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateModule(_response);
        });
    }

    protected processUpdateModule(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }
}

export class ReportsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    list(includeArchived: boolean | undefined, cancelToken?: CancelToken): Promise<ReportTemplateModel[]> {
        let url_ = this.baseUrl + "/api/assessment/reports/templates?";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ReportTemplateModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportTemplateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReportTemplateModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportTemplateModel[]>(null as any);
    }

    create(model: ReportTemplateWriteModel, cancelToken?: CancelToken): Promise<ReportTemplateModel> {
        let url_ = this.baseUrl + "/api/assessment/reports/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ReportTemplateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportTemplateModel.fromJS(resultData200);
            return Promise.resolve<ReportTemplateModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportTemplateModel>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<ReportTemplateModel> {
        let url_ = this.baseUrl + "/api/assessment/reports/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ReportTemplateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportTemplateModel.fromJS(resultData200);
            return Promise.resolve<ReportTemplateModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportTemplateModel>(null as any);
    }

    update(id: string, model: ReportTemplateWriteModel, cancelToken?: CancelToken): Promise<ReportTemplateModel> {
        let url_ = this.baseUrl + "/api/assessment/reports/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ReportTemplateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportTemplateModel.fromJS(resultData200);
            return Promise.resolve<ReportTemplateModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportTemplateModel>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/reports/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    archive(id: string, cancelToken?: CancelToken): Promise<ReportTemplateModel> {
        let url_ = this.baseUrl + "/api/assessment/reports/templates/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchive(_response);
        });
    }

    protected processArchive(response: AxiosResponse): Promise<ReportTemplateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportTemplateModel.fromJS(resultData200);
            return Promise.resolve<ReportTemplateModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportTemplateModel>(null as any);
    }

    preview(request: ReportRenderRequest, cancelToken?: CancelToken): Promise<ReportDataSet> {
        let url_ = this.baseUrl + "/api/assessment/reports/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<ReportDataSet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDataSet.fromJS(resultData200);
            return Promise.resolve<ReportDataSet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDataSet>(null as any);
    }

    renderHtml(request: ReportRenderRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/assessment/reports/render/html";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderHtml(_response);
        });
    }

    protected processRenderHtml(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    renderPdf(request: ReportRenderRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/assessment/reports/render/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderPdf(_response);
        });
    }

    protected processRenderPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CalculationFindingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    get(severity: string | null | undefined, code: string | null | undefined, qualificationModuleID: string | null | undefined, assignmentID: string | null | undefined, studentID: string | null | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<CalculationFindingPageModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-findings?";
        if (severity !== undefined && severity !== null)
            url_ += "Severity=" + encodeURIComponent("" + severity) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (qualificationModuleID !== undefined && qualificationModuleID !== null)
            url_ += "QualificationModuleID=" + encodeURIComponent("" + qualificationModuleID) + "&";
        if (assignmentID !== undefined && assignmentID !== null)
            url_ += "AssignmentID=" + encodeURIComponent("" + assignmentID) + "&";
        if (studentID !== undefined && studentID !== null)
            url_ += "StudentID=" + encodeURIComponent("" + studentID) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CalculationFindingPageModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculationFindingPageModel.fromJS(resultData200);
            return Promise.resolve<CalculationFindingPageModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculationFindingPageModel>(null as any);
    }
}

export class CalculationProceduresClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    create(model: CreateCalculationProcedureModel, cancelToken?: CancelToken): Promise<ProcedureLifecycleModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ProcedureLifecycleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcedureLifecycleModel.fromJS(resultData200);
            return Promise.resolve<ProcedureLifecycleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcedureLifecycleModel>(null as any);
    }

    list(includeArchived: boolean | undefined, cancelToken?: CancelToken): Promise<ProcedureModel[]> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures?";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ProcedureModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcedureModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProcedureModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcedureModel[]>(null as any);
    }

    rename(procedureID: string, model: RenameCalculationProcedureModel, cancelToken?: CancelToken): Promise<ProcedureModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures/{procedureID}";
        if (procedureID === undefined || procedureID === null)
            throw new Error("The parameter 'procedureID' must be defined.");
        url_ = url_.replace("{procedureID}", encodeURIComponent("" + procedureID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRename(_response);
        });
    }

    protected processRename(response: AxiosResponse): Promise<ProcedureModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcedureModel.fromJS(resultData200);
            return Promise.resolve<ProcedureModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcedureModel>(null as any);
    }

    archive(procedureID: string, cancelToken?: CancelToken): Promise<ProcedureModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures/{procedureID}/archive";
        if (procedureID === undefined || procedureID === null)
            throw new Error("The parameter 'procedureID' must be defined.");
        url_ = url_.replace("{procedureID}", encodeURIComponent("" + procedureID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchive(_response);
        });
    }

    protected processArchive(response: AxiosResponse): Promise<ProcedureModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcedureModel.fromJS(resultData200);
            return Promise.resolve<ProcedureModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcedureModel>(null as any);
    }

    listVersions(procedureID: string, cancelToken?: CancelToken): Promise<ProcedureVersionSummaryModel[]> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures/{procedureID}/versions";
        if (procedureID === undefined || procedureID === null)
            throw new Error("The parameter 'procedureID' must be defined.");
        url_ = url_.replace("{procedureID}", encodeURIComponent("" + procedureID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListVersions(_response);
        });
    }

    protected processListVersions(response: AxiosResponse): Promise<ProcedureVersionSummaryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcedureVersionSummaryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProcedureVersionSummaryModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcedureVersionSummaryModel[]>(null as any);
    }

    getVersion(versionID: string, cancelToken?: CancelToken): Promise<ProcedureVersionModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures/versions/{versionID}";
        if (versionID === undefined || versionID === null)
            throw new Error("The parameter 'versionID' must be defined.");
        url_ = url_.replace("{versionID}", encodeURIComponent("" + versionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersion(_response);
        });
    }

    protected processGetVersion(response: AxiosResponse): Promise<ProcedureVersionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcedureVersionModel.fromJS(resultData200);
            return Promise.resolve<ProcedureVersionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcedureVersionModel>(null as any);
    }

    saveDraft(procedureID: string, model: ProcedureDraftWriteModel, cancelToken?: CancelToken): Promise<ProcedureVersionModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures/{procedureID}/draft";
        if (procedureID === undefined || procedureID === null)
            throw new Error("The parameter 'procedureID' must be defined.");
        url_ = url_.replace("{procedureID}", encodeURIComponent("" + procedureID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDraft(_response);
        });
    }

    protected processSaveDraft(response: AxiosResponse): Promise<ProcedureVersionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcedureVersionModel.fromJS(resultData200);
            return Promise.resolve<ProcedureVersionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcedureVersionModel>(null as any);
    }

    discardDraft(procedureID: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures/{procedureID}/draft";
        if (procedureID === undefined || procedureID === null)
            throw new Error("The parameter 'procedureID' must be defined.");
        url_ = url_.replace("{procedureID}", encodeURIComponent("" + procedureID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscardDraft(_response);
        });
    }

    protected processDiscardDraft(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    validateDraft(procedureID: string, cancelToken?: CancelToken): Promise<ProcedureVersionModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures/{procedureID}/draft/validate";
        if (procedureID === undefined || procedureID === null)
            throw new Error("The parameter 'procedureID' must be defined.");
        url_ = url_.replace("{procedureID}", encodeURIComponent("" + procedureID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateDraft(_response);
        });
    }

    protected processValidateDraft(response: AxiosResponse): Promise<ProcedureVersionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcedureVersionModel.fromJS(resultData200);
            return Promise.resolve<ProcedureVersionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcedureVersionModel>(null as any);
    }

    publish(procedureID: string, cancelToken?: CancelToken): Promise<ProcedureVersionModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures/{procedureID}/draft/publish";
        if (procedureID === undefined || procedureID === null)
            throw new Error("The parameter 'procedureID' must be defined.");
        url_ = url_.replace("{procedureID}", encodeURIComponent("" + procedureID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublish(_response);
        });
    }

    protected processPublish(response: AxiosResponse): Promise<ProcedureVersionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcedureVersionModel.fromJS(resultData200);
            return Promise.resolve<ProcedureVersionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcedureVersionModel>(null as any);
    }

    copyToDraft(procedureID: string, versionID: string, cancelToken?: CancelToken): Promise<ProcedureVersionModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures/{procedureID}/versions/{versionID}/copy-to-draft";
        if (procedureID === undefined || procedureID === null)
            throw new Error("The parameter 'procedureID' must be defined.");
        url_ = url_.replace("{procedureID}", encodeURIComponent("" + procedureID));
        if (versionID === undefined || versionID === null)
            throw new Error("The parameter 'versionID' must be defined.");
        url_ = url_.replace("{versionID}", encodeURIComponent("" + versionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyToDraft(_response);
        });
    }

    protected processCopyToDraft(response: AxiosResponse): Promise<ProcedureVersionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcedureVersionModel.fromJS(resultData200);
            return Promise.resolve<ProcedureVersionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcedureVersionModel>(null as any);
    }

    resolveExactSelectors(versionID: string, model: ResolveExactSelectorsModel, cancelToken?: CancelToken): Promise<ExactSelectorResolutionModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedures/versions/{versionID}/resolve-exact-selectors";
        if (versionID === undefined || versionID === null)
            throw new Error("The parameter 'versionID' must be defined.");
        url_ = url_.replace("{versionID}", encodeURIComponent("" + versionID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveExactSelectors(_response);
        });
    }

    protected processResolveExactSelectors(response: AxiosResponse): Promise<ExactSelectorResolutionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExactSelectorResolutionModel.fromJS(resultData200);
            return Promise.resolve<ExactSelectorResolutionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExactSelectorResolutionModel>(null as any);
    }
}

export class CalculationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    run(request: ScopedCalculationRequest, cancelToken?: CancelToken): Promise<CalculationRunSummaryModel> {
        let url_ = this.baseUrl + "/api/assessment/calculations/run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRun(_response);
        });
    }

    protected processRun(response: AxiosResponse): Promise<CalculationRunSummaryModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculationRunSummaryModel.fromJS(resultData200);
            return Promise.resolve<CalculationRunSummaryModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculationRunSummaryModel>(null as any);
    }

    preview(request: CalculationPreviewPageRequest, cancelToken?: CancelToken): Promise<CalculationPreviewPageModel> {
        let url_ = this.baseUrl + "/api/assessment/calculations/preview-results";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<CalculationPreviewPageModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculationPreviewPageModel.fromJS(resultData200);
            return Promise.resolve<CalculationPreviewPageModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculationPreviewPageModel>(null as any);
    }
}

export class ProcedureAssignmentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    list(qualificationModuleID: string | null | undefined, procedureID: string | null | undefined, cancelToken?: CancelToken): Promise<ProcedureAssignmentListItemModel[]> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedure-assignments?";
        if (qualificationModuleID !== undefined && qualificationModuleID !== null)
            url_ += "qualificationModuleID=" + encodeURIComponent("" + qualificationModuleID) + "&";
        if (procedureID !== undefined && procedureID !== null)
            url_ += "procedureID=" + encodeURIComponent("" + procedureID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ProcedureAssignmentListItemModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcedureAssignmentListItemModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProcedureAssignmentListItemModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcedureAssignmentListItemModel[]>(null as any);
    }

    create(model: CreateProcedureAssignmentModel, cancelToken?: CancelToken): Promise<AssignmentGenerationModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedure-assignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<AssignmentGenerationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssignmentGenerationModel.fromJS(resultData200);
            return Promise.resolve<AssignmentGenerationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssignmentGenerationModel>(null as any);
    }

    regenerate(id: string, cancelToken?: CancelToken): Promise<AssignmentGenerationModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedure-assignments/{id}/regenerate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegenerate(_response);
        });
    }

    protected processRegenerate(response: AxiosResponse): Promise<AssignmentGenerationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssignmentGenerationModel.fromJS(resultData200);
            return Promise.resolve<AssignmentGenerationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssignmentGenerationModel>(null as any);
    }

    activate(id: string, cancelToken?: CancelToken): Promise<AssignmentGenerationModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedure-assignments/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<AssignmentGenerationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssignmentGenerationModel.fromJS(resultData200);
            return Promise.resolve<AssignmentGenerationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssignmentGenerationModel>(null as any);
    }

    deactivate(id: string, cancelToken?: CancelToken): Promise<AssignmentGenerationModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedure-assignments/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<AssignmentGenerationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssignmentGenerationModel.fromJS(resultData200);
            return Promise.resolve<AssignmentGenerationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssignmentGenerationModel>(null as any);
    }

    upgrade(id: string, model: UpgradeProcedureAssignmentModel, cancelToken?: CancelToken): Promise<AssignmentGenerationModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedure-assignments/{id}/upgrade";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpgrade(_response);
        });
    }

    protected processUpgrade(response: AxiosResponse): Promise<AssignmentGenerationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssignmentGenerationModel.fromJS(resultData200);
            return Promise.resolve<AssignmentGenerationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssignmentGenerationModel>(null as any);
    }

    preview(id: string, cancelToken?: CancelToken): Promise<CalculationPreviewModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedure-assignments/{id}/preview";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<CalculationPreviewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculationPreviewModel.fromJS(resultData200);
            return Promise.resolve<CalculationPreviewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculationPreviewModel>(null as any);
    }

    calculate(id: string, model: CalculationRunModel, cancelToken?: CancelToken): Promise<CalculationExecutionModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedure-assignments/{id}/calculate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculate(_response);
        });
    }

    protected processCalculate(response: AxiosResponse): Promise<CalculationExecutionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculationExecutionModel.fromJS(resultData200);
            return Promise.resolve<CalculationExecutionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculationExecutionModel>(null as any);
    }

    calculateGraph(model: CalculationGraphRunModel, cancelToken?: CancelToken): Promise<CalculationGraphExecutionModel> {
        let url_ = this.baseUrl + "/api/assessment/calculation-procedure-assignments/calculate-graph";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateGraph(_response);
        });
    }

    protected processCalculateGraph(response: AxiosResponse): Promise<CalculationGraphExecutionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculationGraphExecutionModel.fromJS(resultData200);
            return Promise.resolve<CalculationGraphExecutionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculationGraphExecutionModel>(null as any);
    }
}

export class AssessmentManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    getAssessmentCycle(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfAssessmentCycleAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/GetAssessmentCycle/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessmentCycle(_response);
        });
    }

    protected processGetAssessmentCycle(response: AxiosResponse): Promise<TypedResponseOfAssessmentCycleAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfAssessmentCycleAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfAssessmentCycleAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfAssessmentCycleAPIModel>(null as any);
    }

    listAssessmentCycles( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfAssessmentCycleAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/ListAssessmentCycles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAssessmentCycles(_response);
        });
    }

    protected processListAssessmentCycles(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfAssessmentCycleAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfAssessmentCycleAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfAssessmentCycleAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfAssessmentCycleAPIModel>(null as any);
    }

    createAssessmentCycle(model: CreateAssessmentCycleRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/CreateAssessmentCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAssessmentCycle(_response);
        });
    }

    protected processCreateAssessmentCycle(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateAssessmentCycle(model: UpdateAssessmentCycleRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/UpdateAssessmentCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAssessmentCycle(_response);
        });
    }

    protected processUpdateAssessmentCycle(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteAssessmentCycle(assessmentCycleID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/DeleteAssessmentCycle?";
        if (assessmentCycleID !== undefined && assessmentCycleID !== null)
            url_ += "assessmentCycleID=" + encodeURIComponent("" + assessmentCycleID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAssessmentCycle(_response);
        });
    }

    protected processDeleteAssessmentCycle(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    getAcademicProgram(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfAcademicProgramAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/GetAcademicProgram/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAcademicProgram(_response);
        });
    }

    protected processGetAcademicProgram(response: AxiosResponse): Promise<TypedResponseOfAcademicProgramAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfAcademicProgramAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfAcademicProgramAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfAcademicProgramAPIModel>(null as any);
    }

    listAcademicPrograms( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfAcademicProgramAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/ListAcademicPrograms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAcademicPrograms(_response);
        });
    }

    protected processListAcademicPrograms(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfAcademicProgramAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfAcademicProgramAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfAcademicProgramAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfAcademicProgramAPIModel>(null as any);
    }

    createAcademicProgram(model: CreateAcademicProgramRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/CreateAcademicProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAcademicProgram(_response);
        });
    }

    protected processCreateAcademicProgram(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateAcademicProgram(model: UpdateAcademicProgramRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/UpdateAcademicProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAcademicProgram(_response);
        });
    }

    protected processUpdateAcademicProgram(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteAcademicProgram(academicProgramID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/DeleteAcademicProgram?";
        if (academicProgramID !== undefined && academicProgramID !== null)
            url_ += "AcademicProgramID=" + encodeURIComponent("" + academicProgramID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAcademicProgram(_response);
        });
    }

    protected processDeleteAcademicProgram(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    getAcademicYear(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfAcademicYearAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/GetAcademicYear/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAcademicYear(_response);
        });
    }

    protected processGetAcademicYear(response: AxiosResponse): Promise<TypedResponseOfAcademicYearAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfAcademicYearAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfAcademicYearAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfAcademicYearAPIModel>(null as any);
    }

    listAcademicYears( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfAcademicYearAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/ListAcademicYears";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAcademicYears(_response);
        });
    }

    protected processListAcademicYears(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfAcademicYearAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfAcademicYearAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfAcademicYearAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfAcademicYearAPIModel>(null as any);
    }

    createAcademicYear(model: CreateAcademicYearRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/CreateAcademicYear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAcademicYear(_response);
        });
    }

    protected processCreateAcademicYear(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateAcademicYear(model: UpdateAcademicYearRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/UpdateAcademicYear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAcademicYear(_response);
        });
    }

    protected processUpdateAcademicYear(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteAcademicYear(academicYearID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/DeleteAcademicYear?";
        if (academicYearID !== undefined && academicYearID !== null)
            url_ += "AcademicYearID=" + encodeURIComponent("" + academicYearID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAcademicYear(_response);
        });
    }

    protected processDeleteAcademicYear(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    getQualificationModule(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfQualificationModuleAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/GetQualificationModule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualificationModule(_response);
        });
    }

    protected processGetQualificationModule(response: AxiosResponse): Promise<TypedResponseOfQualificationModuleAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfQualificationModuleAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfQualificationModuleAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfQualificationModuleAPIModel>(null as any);
    }

    listQualificationModules( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfQualificationModuleAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/ListQualificationModules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListQualificationModules(_response);
        });
    }

    protected processListQualificationModules(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfQualificationModuleAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfQualificationModuleAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfQualificationModuleAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfQualificationModuleAPIModel>(null as any);
    }

    createQualificationModule(model: CreateQualificationModuleRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/CreateQualificationModule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQualificationModule(_response);
        });
    }

    protected processCreateQualificationModule(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateQualificationModule(model: UpdateQualificationModuleRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/UpdateQualificationModule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQualificationModule(_response);
        });
    }

    protected processUpdateQualificationModule(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteQualificationModule(qualificationModuleID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/DeleteQualificationModule?";
        if (qualificationModuleID !== undefined && qualificationModuleID !== null)
            url_ += "QualificationModuleID=" + encodeURIComponent("" + qualificationModuleID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQualificationModule(_response);
        });
    }

    protected processDeleteQualificationModule(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    getQualificationProgramLevel(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfQualificationProgramLevelAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/GetQualificationProgramLevel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualificationProgramLevel(_response);
        });
    }

    protected processGetQualificationProgramLevel(response: AxiosResponse): Promise<TypedResponseOfQualificationProgramLevelAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfQualificationProgramLevelAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfQualificationProgramLevelAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfQualificationProgramLevelAPIModel>(null as any);
    }

    listQualificationProgramLevels( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfQualificationProgramLevelAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/ListQualificationProgramLevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListQualificationProgramLevels(_response);
        });
    }

    protected processListQualificationProgramLevels(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfQualificationProgramLevelAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfQualificationProgramLevelAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfQualificationProgramLevelAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfQualificationProgramLevelAPIModel>(null as any);
    }

    createQualificationProgramLevel(model: CreateQualificationProgramLevelRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/CreateQualificationProgramLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQualificationProgramLevel(_response);
        });
    }

    protected processCreateQualificationProgramLevel(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateQualificationProgramLevel(model: UpdateQualificationProgramLevelRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/UpdateQualificationProgramLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQualificationProgramLevel(_response);
        });
    }

    protected processUpdateQualificationProgramLevel(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteQualificationProgramLevel(qualificationProgramLevelID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/DeleteQualificationProgramLevel?";
        if (qualificationProgramLevelID !== undefined && qualificationProgramLevelID !== null)
            url_ += "QualificationProgramLevelID=" + encodeURIComponent("" + qualificationProgramLevelID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQualificationProgramLevel(_response);
        });
    }

    protected processDeleteQualificationProgramLevel(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    getTeachingGroup(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfTeachingGroupAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/GetTeachingGroup/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeachingGroup(_response);
        });
    }

    protected processGetTeachingGroup(response: AxiosResponse): Promise<TypedResponseOfTeachingGroupAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfTeachingGroupAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfTeachingGroupAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfTeachingGroupAPIModel>(null as any);
    }

    listTeachingGroups( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfTeachingGroupAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/management/ListTeachingGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListTeachingGroups(_response);
        });
    }

    protected processListTeachingGroups(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfTeachingGroupAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfTeachingGroupAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfTeachingGroupAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfTeachingGroupAPIModel>(null as any);
    }

    createTeachingGroup(model: CreateTeachingGroupRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/CreateTeachingGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTeachingGroup(_response);
        });
    }

    protected processCreateTeachingGroup(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateTeachingGroup(model: UpdateTeachingGroupRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/UpdateTeachingGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTeachingGroup(_response);
        });
    }

    protected processUpdateTeachingGroup(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteTeachingGroup(teachingGroupID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/management/DeleteTeachingGroup?";
        if (teachingGroupID !== undefined && teachingGroupID !== null)
            url_ += "TeachingGroupID=" + encodeURIComponent("" + teachingGroupID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTeachingGroup(_response);
        });
    }

    protected processDeleteTeachingGroup(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }
}

export class GradeScalesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    list(includeArchived: boolean | undefined, cancelToken?: CancelToken): Promise<GradeScaleModel[]> {
        let url_ = this.baseUrl + "/api/assessment/grade-scales?";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GradeScaleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GradeScaleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GradeScaleModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GradeScaleModel[]>(null as any);
    }

    create(model: GradeScaleWriteModel, cancelToken?: CancelToken): Promise<GradeScaleModel> {
        let url_ = this.baseUrl + "/api/assessment/grade-scales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<GradeScaleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GradeScaleModel.fromJS(resultData200);
            return Promise.resolve<GradeScaleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GradeScaleModel>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<GradeScaleModel> {
        let url_ = this.baseUrl + "/api/assessment/grade-scales/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<GradeScaleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GradeScaleModel.fromJS(resultData200);
            return Promise.resolve<GradeScaleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GradeScaleModel>(null as any);
    }

    update(id: string, model: GradeScaleWriteModel, cancelToken?: CancelToken): Promise<GradeScaleModel> {
        let url_ = this.baseUrl + "/api/assessment/grade-scales/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<GradeScaleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GradeScaleModel.fromJS(resultData200);
            return Promise.resolve<GradeScaleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GradeScaleModel>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/grade-scales/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    archive(id: string, cancelToken?: CancelToken): Promise<GradeScaleModel> {
        let url_ = this.baseUrl + "/api/assessment/grade-scales/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchive(_response);
        });
    }

    protected processArchive(response: AxiosResponse): Promise<GradeScaleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GradeScaleModel.fromJS(resultData200);
            return Promise.resolve<GradeScaleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GradeScaleModel>(null as any);
    }

    setMarkTypeDefault(markTypeID: string, model: SetMarkTypeGradeScaleModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/grade-scales/mark-types/{markTypeID}";
        if (markTypeID === undefined || markTypeID === null)
            throw new Error("The parameter 'markTypeID' must be defined.");
        url_ = url_.replace("{markTypeID}", encodeURIComponent("" + markTypeID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMarkTypeDefault(_response);
        });
    }

    protected processSetMarkTypeDefault(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    evaluate(model: EvaluateGradeModel, cancelToken?: CancelToken): Promise<GradeEvaluationModel> {
        let url_ = this.baseUrl + "/api/assessment/grade-scales/evaluate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEvaluate(_response);
        });
    }

    protected processEvaluate(response: AxiosResponse): Promise<GradeEvaluationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GradeEvaluationModel.fromJS(resultData200);
            return Promise.resolve<GradeEvaluationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GradeEvaluationModel>(null as any);
    }
}

export class AssessmentEnrollmentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    getQualificationLevelEnrollment(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfQualificationLevelEnrollmentAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/QualificationLevelEnrollment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualificationLevelEnrollment(_response);
        });
    }

    protected processGetQualificationLevelEnrollment(response: AxiosResponse): Promise<TypedResponseOfQualificationLevelEnrollmentAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfQualificationLevelEnrollmentAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfQualificationLevelEnrollmentAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfQualificationLevelEnrollmentAPIModel>(null as any);
    }

    listQualificationLevelEnrollments( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfQualificationLevelEnrollmentAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/ListQualificationLevelEnrollments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListQualificationLevelEnrollments(_response);
        });
    }

    protected processListQualificationLevelEnrollments(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfQualificationLevelEnrollmentAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfQualificationLevelEnrollmentAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfQualificationLevelEnrollmentAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfQualificationLevelEnrollmentAPIModel>(null as any);
    }

    createQualificationLevelEnrollment(model: CreateQualificationLevelEnrollmentRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/CreateQualificationLevelEnrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQualificationLevelEnrollment(_response);
        });
    }

    protected processCreateQualificationLevelEnrollment(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateQualificationLevelEnrollment(model: UpdateQualificationLevelEnrollmentRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/UpdateQualificationLevelEnrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQualificationLevelEnrollment(_response);
        });
    }

    protected processUpdateQualificationLevelEnrollment(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteQualificationLevelEnrollment(qualificationLevelEnrollmentID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/DeleteQualificationLevelEnrollment?";
        if (qualificationLevelEnrollmentID !== undefined && qualificationLevelEnrollmentID !== null)
            url_ += "qualificationLevelEnrollmentID=" + encodeURIComponent("" + qualificationLevelEnrollmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQualificationLevelEnrollment(_response);
        });
    }

    protected processDeleteQualificationLevelEnrollment(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    getStudentModuleEnrollment(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfStudentModuleEnrollmentAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/GetStudentModuleEnrollment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudentModuleEnrollment(_response);
        });
    }

    protected processGetStudentModuleEnrollment(response: AxiosResponse): Promise<TypedResponseOfStudentModuleEnrollmentAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfStudentModuleEnrollmentAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfStudentModuleEnrollmentAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfStudentModuleEnrollmentAPIModel>(null as any);
    }

    listStudentModuleEnrollments( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfStudentModuleEnrollmentAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/ListStudentModuleEnrollments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListStudentModuleEnrollments(_response);
        });
    }

    protected processListStudentModuleEnrollments(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfStudentModuleEnrollmentAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfStudentModuleEnrollmentAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfStudentModuleEnrollmentAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfStudentModuleEnrollmentAPIModel>(null as any);
    }

    listStudentModuleEnrollmentsForSync(request: EnrollmentSyncRequest, cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfStudentModuleEnrollmentSyncModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/ListStudentModuleEnrollmentsForSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListStudentModuleEnrollmentsForSync(_response);
        });
    }

    protected processListStudentModuleEnrollmentsForSync(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfStudentModuleEnrollmentSyncModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfStudentModuleEnrollmentSyncModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfStudentModuleEnrollmentSyncModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfStudentModuleEnrollmentSyncModel>(null as any);
    }

    ensureStudentModuleEnrollment(model: EnsureStudentModuleEnrollmentRequest, cancelToken?: CancelToken): Promise<TypedResponseOfString> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/EnsureStudentModuleEnrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnsureStudentModuleEnrollment(_response);
        });
    }

    protected processEnsureStudentModuleEnrollment(response: AxiosResponse): Promise<TypedResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfString.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfString>(null as any);
    }

    createStudentModuleEnrollment(model: CreateStudentModuleEnrollmentRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/CreateStudentModuleEnrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStudentModuleEnrollment(_response);
        });
    }

    protected processCreateStudentModuleEnrollment(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    updateStudentModuleEnrollment(model: UpdateStudentModuleEnrollmentRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/UpdateStudentModuleEnrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStudentModuleEnrollment(_response);
        });
    }

    protected processUpdateStudentModuleEnrollment(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteStudentModuleEnrollment(studentModuleEnrollmentID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/DeleteStudentModuleEnrollment?";
        if (studentModuleEnrollmentID !== undefined && studentModuleEnrollmentID !== null)
            url_ += "studentModuleEnrollmentID=" + encodeURIComponent("" + studentModuleEnrollmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStudentModuleEnrollment(_response);
        });
    }

    protected processDeleteStudentModuleEnrollment(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    getTeachingGroupEnrollment(id: string, cancelToken?: CancelToken): Promise<TypedResponseOfTeachingGroupEnrollmentAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/GetTeachingGroupEnrollment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeachingGroupEnrollment(_response);
        });
    }

    protected processGetTeachingGroupEnrollment(response: AxiosResponse): Promise<TypedResponseOfTeachingGroupEnrollmentAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfTeachingGroupEnrollmentAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfTeachingGroupEnrollmentAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfTeachingGroupEnrollmentAPIModel>(null as any);
    }

    listTeachingGroupEnrollments( cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfTeachingGroupEnrollmentAPIModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/ListTeachingGroupEnrollments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListTeachingGroupEnrollments(_response);
        });
    }

    protected processListTeachingGroupEnrollments(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfTeachingGroupEnrollmentAPIModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfTeachingGroupEnrollmentAPIModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfTeachingGroupEnrollmentAPIModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfTeachingGroupEnrollmentAPIModel>(null as any);
    }

    listTeachingGroupEnrollmentsForSync(request: EnrollmentSyncRequest, cancelToken?: CancelToken): Promise<TypedResponseOfIEnumerableOfTeachingGroupEnrollmentSyncModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/ListTeachingGroupEnrollmentsForSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListTeachingGroupEnrollmentsForSync(_response);
        });
    }

    protected processListTeachingGroupEnrollmentsForSync(response: AxiosResponse): Promise<TypedResponseOfIEnumerableOfTeachingGroupEnrollmentSyncModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TypedResponseOfIEnumerableOfTeachingGroupEnrollmentSyncModel.fromJS(resultData200);
            return Promise.resolve<TypedResponseOfIEnumerableOfTeachingGroupEnrollmentSyncModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypedResponseOfIEnumerableOfTeachingGroupEnrollmentSyncModel>(null as any);
    }

    createTeachingGroupEnrollment(model: CreateTeachingGroupEnrollmentRequest, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/CreateTeachingGroupEnrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTeachingGroupEnrollment(_response);
        });
    }

    protected processCreateTeachingGroupEnrollment(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }

    deleteTeachingGroupEnrollment(teachingGroupEnrollmentID: string | null | undefined, cancelToken?: CancelToken): Promise<DefaultResponse> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/DeleteTeachingGroupEnrollment?";
        if (teachingGroupEnrollmentID !== undefined && teachingGroupEnrollmentID !== null)
            url_ += "teachingGroupEnrollmentID=" + encodeURIComponent("" + teachingGroupEnrollmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTeachingGroupEnrollment(_response);
        });
    }

    protected processDeleteTeachingGroupEnrollment(response: AxiosResponse): Promise<DefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultResponse.fromJS(resultData200);
            return Promise.resolve<DefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultResponse>(null as any);
    }
}

export class EnrollmentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    getProgress(studentID: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Enrollment/Progress/{studentID}";
        if (studentID === undefined || studentID === null)
            throw new Error("The parameter 'studentID' must be defined.");
        url_ = url_.replace("{studentID}", encodeURIComponent("" + studentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProgress(_response);
        });
    }

    protected processGetProgress(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAvailability(studentID: string, cycle: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Enrollment/Availability/{studentID}?";
        if (studentID === undefined || studentID === null)
            throw new Error("The parameter 'studentID' must be defined.");
        url_ = url_.replace("{studentID}", encodeURIComponent("" + studentID));
        if (cycle === null)
            throw new Error("The parameter 'cycle' cannot be null.");
        else if (cycle !== undefined)
            url_ += "cycle=" + encodeURIComponent("" + cycle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailability(_response);
        });
    }

    protected processGetAvailability(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createEnrollment(studentID: string, subjectChoice: SubjectChoice, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Enrollment/{studentID}";
        if (studentID === undefined || studentID === null)
            throw new Error("The parameter 'studentID' must be defined.");
        url_ = url_.replace("{studentID}", encodeURIComponent("" + studentID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subjectChoice);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEnrollment(_response);
        });
    }

    protected processCreateEnrollment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SubjectChoiceRulesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    list(qualificationID: string | null | undefined, qualificationLevelID: string | null | undefined, cancelToken?: CancelToken): Promise<SubjectChoiceRuleModel[]> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/subject-choice-rules?";
        if (qualificationID !== undefined && qualificationID !== null)
            url_ += "qualificationID=" + encodeURIComponent("" + qualificationID) + "&";
        if (qualificationLevelID !== undefined && qualificationLevelID !== null)
            url_ += "qualificationLevelID=" + encodeURIComponent("" + qualificationLevelID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<SubjectChoiceRuleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubjectChoiceRuleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubjectChoiceRuleModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubjectChoiceRuleModel[]>(null as any);
    }

    create(model: SubjectChoiceRuleWriteModel, cancelToken?: CancelToken): Promise<SubjectChoiceRuleModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/subject-choice-rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SubjectChoiceRuleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubjectChoiceRuleModel.fromJS(resultData200);
            return Promise.resolve<SubjectChoiceRuleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubjectChoiceRuleModel>(null as any);
    }

    update(ruleID: string, model: SubjectChoiceRuleWriteModel, cancelToken?: CancelToken): Promise<SubjectChoiceRuleModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/subject-choice-rules/{ruleID}";
        if (ruleID === undefined || ruleID === null)
            throw new Error("The parameter 'ruleID' must be defined.");
        url_ = url_.replace("{ruleID}", encodeURIComponent("" + ruleID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<SubjectChoiceRuleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubjectChoiceRuleModel.fromJS(resultData200);
            return Promise.resolve<SubjectChoiceRuleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubjectChoiceRuleModel>(null as any);
    }

    delete(ruleID: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/subject-choice-rules/{ruleID}";
        if (ruleID === undefined || ruleID === null)
            throw new Error("The parameter 'ruleID' must be defined.");
        url_ = url_.replace("{ruleID}", encodeURIComponent("" + ruleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    reorder(qualificationID: string | null | undefined, qualificationLevelID: string | null | undefined, model: ReorderSubjectChoiceRulesModel, cancelToken?: CancelToken): Promise<SubjectChoiceRuleModel[]> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/subject-choice-rules/order?";
        if (qualificationID !== undefined && qualificationID !== null)
            url_ += "qualificationID=" + encodeURIComponent("" + qualificationID) + "&";
        if (qualificationLevelID !== undefined && qualificationLevelID !== null)
            url_ += "qualificationLevelID=" + encodeURIComponent("" + qualificationLevelID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReorder(_response);
        });
    }

    protected processReorder(response: AxiosResponse): Promise<SubjectChoiceRuleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubjectChoiceRuleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubjectChoiceRuleModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubjectChoiceRuleModel[]>(null as any);
    }
}

export class SubjectChoicesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    get(programLevelID: string, cancelToken?: CancelToken): Promise<SubjectChoiceGridModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/subject-choices/{programLevelID}";
        if (programLevelID === undefined || programLevelID === null)
            throw new Error("The parameter 'programLevelID' must be defined.");
        url_ = url_.replace("{programLevelID}", encodeURIComponent("" + programLevelID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SubjectChoiceGridModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubjectChoiceGridModel.fromJS(resultData200);
            return Promise.resolve<SubjectChoiceGridModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubjectChoiceGridModel>(null as any);
    }

    save(programLevelID: string, model: SaveSubjectChoicesModel, cancelToken?: CancelToken): Promise<SubjectChoiceSaveResultModel> {
        let url_ = this.baseUrl + "/api/assessment/enrollment/subject-choices/{programLevelID}";
        if (programLevelID === undefined || programLevelID === null)
            throw new Error("The parameter 'programLevelID' must be defined.");
        url_ = url_.replace("{programLevelID}", encodeURIComponent("" + programLevelID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<SubjectChoiceSaveResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubjectChoiceSaveResultModel.fromJS(resultData200);
            return Promise.resolve<SubjectChoiceSaveResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubjectChoiceSaveResultModel>(null as any);
    }
}

export class AssessmentActivitiesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    getModuleStructure(qualificationModuleID: string, cancelToken?: CancelToken): Promise<AssessmentStructureTreeModel> {
        let url_ = this.baseUrl + "/api/assessment/activities/modules/{qualificationModuleID}/structure";
        if (qualificationModuleID === undefined || qualificationModuleID === null)
            throw new Error("The parameter 'qualificationModuleID' must be defined.");
        url_ = url_.replace("{qualificationModuleID}", encodeURIComponent("" + qualificationModuleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModuleStructure(_response);
        });
    }

    protected processGetModuleStructure(response: AxiosResponse): Promise<AssessmentStructureTreeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentStructureTreeModel.fromJS(resultData200);
            return Promise.resolve<AssessmentStructureTreeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentStructureTreeModel>(null as any);
    }

    getGroup(id: string, cancelToken?: CancelToken): Promise<AssessmentGroupModel> {
        let url_ = this.baseUrl + "/api/assessment/activities/assessment-groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroup(_response);
        });
    }

    protected processGetGroup(response: AxiosResponse): Promise<AssessmentGroupModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentGroupModel.fromJS(resultData200);
            return Promise.resolve<AssessmentGroupModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentGroupModel>(null as any);
    }

    updateGroup(id: string, model: AssessmentGroupUpdateModel, cancelToken?: CancelToken): Promise<AssessmentGroupModel> {
        let url_ = this.baseUrl + "/api/assessment/activities/assessment-groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGroup(_response);
        });
    }

    protected processUpdateGroup(response: AxiosResponse): Promise<AssessmentGroupModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentGroupModel.fromJS(resultData200);
            return Promise.resolve<AssessmentGroupModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentGroupModel>(null as any);
    }

    deleteGroup(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/activities/assessment-groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGroup(_response);
        });
    }

    protected processDeleteGroup(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    createGroup(model: AssessmentGroupWriteModel, cancelToken?: CancelToken): Promise<AssessmentGroupModel> {
        let url_ = this.baseUrl + "/api/assessment/activities/assessment-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGroup(_response);
        });
    }

    protected processCreateGroup(response: AxiosResponse): Promise<AssessmentGroupModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentGroupModel.fromJS(resultData200);
            return Promise.resolve<AssessmentGroupModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentGroupModel>(null as any);
    }

    moveGroup(id: string, model: MoveAssessmentGroupModel, cancelToken?: CancelToken): Promise<AssessmentGroupModel> {
        let url_ = this.baseUrl + "/api/assessment/activities/assessment-groups/{id}/move";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveGroup(_response);
        });
    }

    protected processMoveGroup(response: AxiosResponse): Promise<AssessmentGroupModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentGroupModel.fromJS(resultData200);
            return Promise.resolve<AssessmentGroupModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentGroupModel>(null as any);
    }

    getAssessment(id: string, cancelToken?: CancelToken): Promise<AssessmentModel> {
        let url_ = this.baseUrl + "/api/assessment/activities/assessments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessment(_response);
        });
    }

    protected processGetAssessment(response: AxiosResponse): Promise<AssessmentModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentModel.fromJS(resultData200);
            return Promise.resolve<AssessmentModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentModel>(null as any);
    }

    updateAssessment(id: string, model: AssessmentWriteModel, cancelToken?: CancelToken): Promise<AssessmentModel> {
        let url_ = this.baseUrl + "/api/assessment/activities/assessments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAssessment(_response);
        });
    }

    protected processUpdateAssessment(response: AxiosResponse): Promise<AssessmentModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentModel.fromJS(resultData200);
            return Promise.resolve<AssessmentModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentModel>(null as any);
    }

    deleteAssessment(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/activities/assessments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAssessment(_response);
        });
    }

    protected processDeleteAssessment(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    createAssessment(model: AssessmentWriteModel, cancelToken?: CancelToken): Promise<AssessmentModel> {
        let url_ = this.baseUrl + "/api/assessment/activities/assessments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAssessment(_response);
        });
    }

    protected processCreateAssessment(response: AxiosResponse): Promise<AssessmentModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentModel.fromJS(resultData200);
            return Promise.resolve<AssessmentModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentModel>(null as any);
    }
}

export class AssessmentTypesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    listAssessmentTypes(includeArchived: boolean | undefined, cancelToken?: CancelToken): Promise<AssessmentTypeModel[]> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessment-types?";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAssessmentTypes(_response);
        });
    }

    protected processListAssessmentTypes(response: AxiosResponse): Promise<AssessmentTypeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AssessmentTypeModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentTypeModel[]>(null as any);
    }

    createAssessmentType(model: AssessmentTypeWriteModel, cancelToken?: CancelToken): Promise<AssessmentTypeModel> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessment-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAssessmentType(_response);
        });
    }

    protected processCreateAssessmentType(response: AxiosResponse): Promise<AssessmentTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentTypeModel.fromJS(resultData200);
            return Promise.resolve<AssessmentTypeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentTypeModel>(null as any);
    }

    listGroupTypes(includeArchived: boolean | undefined, cancelToken?: CancelToken): Promise<AssessmentTypeModel[]> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessment-group-types?";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListGroupTypes(_response);
        });
    }

    protected processListGroupTypes(response: AxiosResponse): Promise<AssessmentTypeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AssessmentTypeModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentTypeModel[]>(null as any);
    }

    createGroupType(model: AssessmentTypeWriteModel, cancelToken?: CancelToken): Promise<AssessmentTypeModel> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessment-group-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGroupType(_response);
        });
    }

    protected processCreateGroupType(response: AxiosResponse): Promise<AssessmentTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentTypeModel.fromJS(resultData200);
            return Promise.resolve<AssessmentTypeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentTypeModel>(null as any);
    }

    updateAssessmentType(id: string, model: AssessmentTypeWriteModel, cancelToken?: CancelToken): Promise<AssessmentTypeModel> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessment-types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAssessmentType(_response);
        });
    }

    protected processUpdateAssessmentType(response: AxiosResponse): Promise<AssessmentTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentTypeModel.fromJS(resultData200);
            return Promise.resolve<AssessmentTypeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentTypeModel>(null as any);
    }

    deleteAssessmentType(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessment-types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAssessmentType(_response);
        });
    }

    protected processDeleteAssessmentType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateGroupType(id: string, model: AssessmentTypeWriteModel, cancelToken?: CancelToken): Promise<AssessmentTypeModel> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessment-group-types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGroupType(_response);
        });
    }

    protected processUpdateGroupType(response: AxiosResponse): Promise<AssessmentTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentTypeModel.fromJS(resultData200);
            return Promise.resolve<AssessmentTypeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentTypeModel>(null as any);
    }

    deleteGroupType(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessment-group-types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGroupType(_response);
        });
    }

    protected processDeleteGroupType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    archiveAssessmentType(id: string, cancelToken?: CancelToken): Promise<AssessmentTypeModel> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessment-types/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveAssessmentType(_response);
        });
    }

    protected processArchiveAssessmentType(response: AxiosResponse): Promise<AssessmentTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentTypeModel.fromJS(resultData200);
            return Promise.resolve<AssessmentTypeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentTypeModel>(null as any);
    }

    archiveGroupType(id: string, cancelToken?: CancelToken): Promise<AssessmentTypeModel> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessment-group-types/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveGroupType(_response);
        });
    }

    protected processArchiveGroupType(response: AxiosResponse): Promise<AssessmentTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentTypeModel.fromJS(resultData200);
            return Promise.resolve<AssessmentTypeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentTypeModel>(null as any);
    }

    setAssessmentType(id: string, model: SetAssessmentTypeModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessments/{id}/type";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetAssessmentType(_response);
        });
    }

    protected processSetAssessmentType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    setGroupType(id: string, model: SetAssessmentTypeModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/configuration/assessment-groups/{id}/type";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetGroupType(_response);
        });
    }

    protected processSetGroupType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    listMarkTypes( cancelToken?: CancelToken): Promise<MarkTypeModel[]> {
        let url_ = this.baseUrl + "/api/assessment/configuration/mark-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListMarkTypes(_response);
        });
    }

    protected processListMarkTypes(response: AxiosResponse): Promise<MarkTypeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarkTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MarkTypeModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkTypeModel[]>(null as any);
    }

    createMarkType(model: MarkTypeWriteModel, cancelToken?: CancelToken): Promise<MarkTypeModel> {
        let url_ = this.baseUrl + "/api/assessment/configuration/mark-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMarkType(_response);
        });
    }

    protected processCreateMarkType(response: AxiosResponse): Promise<MarkTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkTypeModel.fromJS(resultData200);
            return Promise.resolve<MarkTypeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkTypeModel>(null as any);
    }

    updateMarkType(id: string, model: MarkTypeWriteModel, cancelToken?: CancelToken): Promise<MarkTypeModel> {
        let url_ = this.baseUrl + "/api/assessment/configuration/mark-types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMarkType(_response);
        });
    }

    protected processUpdateMarkType(response: AxiosResponse): Promise<MarkTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkTypeModel.fromJS(resultData200);
            return Promise.resolve<MarkTypeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkTypeModel>(null as any);
    }

    deleteMarkType(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/configuration/mark-types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMarkType(_response);
        });
    }

    protected processDeleteMarkType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CommentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    listTypes( cancelToken?: CancelToken): Promise<CommentTypeModel[]> {
        let url_ = this.baseUrl + "/api/assessment/comments/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListTypes(_response);
        });
    }

    protected processListTypes(response: AxiosResponse): Promise<CommentTypeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CommentTypeModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommentTypeModel[]>(null as any);
    }

    createType(model: CommentTypeWriteModel, cancelToken?: CancelToken): Promise<CommentTypeModel> {
        let url_ = this.baseUrl + "/api/assessment/comments/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateType(_response);
        });
    }

    protected processCreateType(response: AxiosResponse): Promise<CommentTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommentTypeModel.fromJS(resultData200);
            return Promise.resolve<CommentTypeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommentTypeModel>(null as any);
    }

    updateType(id: string, model: CommentTypeWriteModel, cancelToken?: CancelToken): Promise<CommentTypeModel> {
        let url_ = this.baseUrl + "/api/assessment/comments/types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateType(_response);
        });
    }

    protected processUpdateType(response: AxiosResponse): Promise<CommentTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommentTypeModel.fromJS(resultData200);
            return Promise.resolve<CommentTypeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommentTypeModel>(null as any);
    }

    deleteType(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/assessment/comments/types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteType(_response);
        });
    }

    protected processDeleteType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    list(targetEntityID: string | null | undefined, commentTypeID: string | null | undefined, cancelToken?: CancelToken): Promise<CommentResultModel[]> {
        let url_ = this.baseUrl + "/api/assessment/comments?";
        if (targetEntityID !== undefined && targetEntityID !== null)
            url_ += "targetEntityID=" + encodeURIComponent("" + targetEntityID) + "&";
        if (commentTypeID !== undefined && commentTypeID !== null)
            url_ += "commentTypeID=" + encodeURIComponent("" + commentTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<CommentResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CommentResultModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommentResultModel[]>(null as any);
    }

    enter(model: CommentBatchModel, cancelToken?: CancelToken): Promise<CommentResultModel[]> {
        let url_ = this.baseUrl + "/api/assessment/comments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnter(_response);
        });
    }

    protected processEnter(response: AxiosResponse): Promise<CommentResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CommentResultModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommentResultModel[]>(null as any);
    }
}

export class ManualMarksClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    enter(model: ManualMarkBatchModel, cancelToken?: CancelToken): Promise<ManualMarkBatchResultModel> {
        let url_ = this.baseUrl + "/api/assessment/manual-marks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnter(_response);
        });
    }

    protected processEnter(response: AxiosResponse): Promise<ManualMarkBatchResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ManualMarkBatchResultModel.fromJS(resultData200);
            return Promise.resolve<ManualMarkBatchResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManualMarkBatchResultModel>(null as any);
    }
}

export class MarkEntrySheetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    explanation(markResultID: string, cancelToken?: CancelToken): Promise<MarkExplanationModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-entry/explanation/{markResultID}";
        if (markResultID === undefined || markResultID === null)
            throw new Error("The parameter 'markResultID' must be defined.");
        url_ = url_.replace("{markResultID}", encodeURIComponent("" + markResultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExplanation(_response);
        });
    }

    protected processExplanation(response: AxiosResponse): Promise<MarkExplanationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkExplanationModel.fromJS(resultData200);
            return Promise.resolve<MarkExplanationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkExplanationModel>(null as any);
    }

    sheet(request: MarkEntrySheetRequest, cancelToken?: CancelToken): Promise<MarkEntrySheetModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-entry/sheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSheet(_response);
        });
    }

    protected processSheet(response: AxiosResponse): Promise<MarkEntrySheetModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkEntrySheetModel.fromJS(resultData200);
            return Promise.resolve<MarkEntrySheetModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkEntrySheetModel>(null as any);
    }
}

export class MarkGridClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    deleteAssessment(assessmentID: string, removeMarks: boolean | undefined, cancelToken?: CancelToken): Promise<MarkGridDeletedModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-grid/assessments/{assessmentID}?";
        if (assessmentID === undefined || assessmentID === null)
            throw new Error("The parameter 'assessmentID' must be defined.");
        url_ = url_.replace("{assessmentID}", encodeURIComponent("" + assessmentID));
        if (removeMarks === null)
            throw new Error("The parameter 'removeMarks' cannot be null.");
        else if (removeMarks !== undefined)
            url_ += "removeMarks=" + encodeURIComponent("" + removeMarks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAssessment(_response);
        });
    }

    protected processDeleteAssessment(response: AxiosResponse): Promise<MarkGridDeletedModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkGridDeletedModel.fromJS(resultData200);
            return Promise.resolve<MarkGridDeletedModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkGridDeletedModel>(null as any);
    }

    subjects(all: boolean | undefined, cancelToken?: CancelToken): Promise<MarkGridSubjectListModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-grid/subjects?";
        if (all === null)
            throw new Error("The parameter 'all' cannot be null.");
        else if (all !== undefined)
            url_ += "all=" + encodeURIComponent("" + all) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubjects(_response);
        });
    }

    protected processSubjects(response: AxiosResponse): Promise<MarkGridSubjectListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkGridSubjectListModel.fromJS(resultData200);
            return Promise.resolve<MarkGridSubjectListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkGridSubjectListModel>(null as any);
    }

    comments(qualificationModuleID: string, teachingGroupID: string | null | undefined, cancelToken?: CancelToken): Promise<MarkGridCommentsModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-grid/modules/{qualificationModuleID}/comments?";
        if (qualificationModuleID === undefined || qualificationModuleID === null)
            throw new Error("The parameter 'qualificationModuleID' must be defined.");
        url_ = url_.replace("{qualificationModuleID}", encodeURIComponent("" + qualificationModuleID));
        if (teachingGroupID !== undefined && teachingGroupID !== null)
            url_ += "teachingGroupID=" + encodeURIComponent("" + teachingGroupID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComments(_response);
        });
    }

    protected processComments(response: AxiosResponse): Promise<MarkGridCommentsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkGridCommentsModel.fromJS(resultData200);
            return Promise.resolve<MarkGridCommentsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkGridCommentsModel>(null as any);
    }

    saveComments(request: MarkGridCommentSaveRequest, cancelToken?: CancelToken): Promise<MarkGridCommentSaveResultModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-grid/comments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveComments(_response);
        });
    }

    protected processSaveComments(response: AxiosResponse): Promise<MarkGridCommentSaveResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkGridCommentSaveResultModel.fromJS(resultData200);
            return Promise.resolve<MarkGridCommentSaveResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkGridCommentSaveResultModel>(null as any);
    }

    overview(qualificationModuleID: string, groupID: string | null | undefined, teachingGroupID: string | null | undefined, cancelToken?: CancelToken): Promise<MarkGridOverviewModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-grid/modules/{qualificationModuleID}/overview?";
        if (qualificationModuleID === undefined || qualificationModuleID === null)
            throw new Error("The parameter 'qualificationModuleID' must be defined.");
        url_ = url_.replace("{qualificationModuleID}", encodeURIComponent("" + qualificationModuleID));
        if (groupID !== undefined && groupID !== null)
            url_ += "groupID=" + encodeURIComponent("" + groupID) + "&";
        if (teachingGroupID !== undefined && teachingGroupID !== null)
            url_ += "teachingGroupID=" + encodeURIComponent("" + teachingGroupID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOverview(_response);
        });
    }

    protected processOverview(response: AxiosResponse): Promise<MarkGridOverviewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkGridOverviewModel.fromJS(resultData200);
            return Promise.resolve<MarkGridOverviewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkGridOverviewModel>(null as any);
    }

    groupTypeCoverage(qualificationModuleID: string, cancelToken?: CancelToken): Promise<MarkGridGroupTypeCoverageModel[]> {
        let url_ = this.baseUrl + "/api/assessment/mark-grid/modules/{qualificationModuleID}/group-type-coverage";
        if (qualificationModuleID === undefined || qualificationModuleID === null)
            throw new Error("The parameter 'qualificationModuleID' must be defined.");
        url_ = url_.replace("{qualificationModuleID}", encodeURIComponent("" + qualificationModuleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGroupTypeCoverage(_response);
        });
    }

    protected processGroupTypeCoverage(response: AxiosResponse): Promise<MarkGridGroupTypeCoverageModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarkGridGroupTypeCoverageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MarkGridGroupTypeCoverageModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkGridGroupTypeCoverageModel[]>(null as any);
    }

    sheet(request: MarkGridSheetRequest, cancelToken?: CancelToken): Promise<MarkGridSheetModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-grid/sheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSheet(_response);
        });
    }

    protected processSheet(response: AxiosResponse): Promise<MarkGridSheetModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkGridSheetModel.fromJS(resultData200);
            return Promise.resolve<MarkGridSheetModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkGridSheetModel>(null as any);
    }

    save(request: MarkGridSaveRequest, cancelToken?: CancelToken): Promise<MarkGridSaveResultModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-grid/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<MarkGridSaveResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkGridSaveResultModel.fromJS(resultData200);
            return Promise.resolve<MarkGridSaveResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkGridSaveResultModel>(null as any);
    }

    createAssessment(model: AssessmentWriteModel, cancelToken?: CancelToken): Promise<MarkGridCreatedModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-grid/assessments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAssessment(_response);
        });
    }

    protected processCreateAssessment(response: AxiosResponse): Promise<MarkGridCreatedModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkGridCreatedModel.fromJS(resultData200);
            return Promise.resolve<MarkGridCreatedModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkGridCreatedModel>(null as any);
    }

    createGroup(model: AssessmentGroupWriteModel, cancelToken?: CancelToken): Promise<MarkGridCreatedModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-grid/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGroup(_response);
        });
    }

    protected processCreateGroup(response: AxiosResponse): Promise<MarkGridCreatedModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkGridCreatedModel.fromJS(resultData200);
            return Promise.resolve<MarkGridCreatedModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkGridCreatedModel>(null as any);
    }
}

export class MarkRemovalClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    preview(request: MarkRemovalRequest, cancelToken?: CancelToken): Promise<MarkRemovalResultModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-removal/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<MarkRemovalResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkRemovalResultModel.fromJS(resultData200);
            return Promise.resolve<MarkRemovalResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkRemovalResultModel>(null as any);
    }

    remove(request: MarkRemovalRequest, cancelToken?: CancelToken): Promise<MarkRemovalResultModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-removal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<MarkRemovalResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkRemovalResultModel.fromJS(resultData200);
            return Promise.resolve<MarkRemovalResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkRemovalResultModel>(null as any);
    }
}

export class MarkWorkflowClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    apply(request: MarkWorkflowRequest, cancelToken?: CancelToken): Promise<MarkWorkflowResultModel> {
        let url_ = this.baseUrl + "/api/assessment/mark-workflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApply(_response);
        });
    }

    protected processApply(response: AxiosResponse): Promise<MarkWorkflowResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkWorkflowResultModel.fromJS(resultData200);
            return Promise.resolve<MarkWorkflowResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkWorkflowResultModel>(null as any);
    }
}

export class AccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:45623";

    }

    signIn(redirectUrl: string | null | undefined, select: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Account/SignIn?";
        if (redirectUrl !== undefined && redirectUrl !== null)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignIn(_response);
        });
    }

    protected processSignIn(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    signOut( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Account/SignOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignOut(_response);
        });
    }

    protected processSignOut(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    signedOut( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Account/SignedOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignedOut(_response);
        });
    }

    protected processSignedOut(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    me( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Account/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class Integration implements IIntegration {
    id?: string | undefined;
    integrationType?: IntegrationType | undefined;
    organizationID?: string | undefined;
    name?: string | undefined;
    triggerEnabled?: boolean;
    triggerLastRun?: Date;
    config?: string | undefined;
    integrationRuns?: IntegrationRun[] | undefined;

    constructor(data?: IIntegration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.integrationType = _data["integrationType"] ? IntegrationType.fromJS(_data["integrationType"]) : <any>undefined;
            this.organizationID = _data["organizationID"];
            this.name = _data["name"];
            this.triggerEnabled = _data["triggerEnabled"];
            this.triggerLastRun = _data["triggerLastRun"] ? new Date(_data["triggerLastRun"].toString()) : <any>undefined;
            this.config = _data["config"];
            if (Array.isArray(_data["integrationRuns"])) {
                this.integrationRuns = [] as any;
                for (let item of _data["integrationRuns"])
                    this.integrationRuns!.push(IntegrationRun.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Integration {
        data = typeof data === 'object' ? data : {};
        let result = new Integration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["integrationType"] = this.integrationType ? this.integrationType.toJSON() : <any>undefined;
        data["organizationID"] = this.organizationID;
        data["name"] = this.name;
        data["triggerEnabled"] = this.triggerEnabled;
        data["triggerLastRun"] = this.triggerLastRun ? this.triggerLastRun.toISOString() : <any>undefined;
        data["config"] = this.config;
        if (Array.isArray(this.integrationRuns)) {
            data["integrationRuns"] = [];
            for (let item of this.integrationRuns)
                data["integrationRuns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIntegration {
    id?: string | undefined;
    integrationType?: IntegrationType | undefined;
    organizationID?: string | undefined;
    name?: string | undefined;
    triggerEnabled?: boolean;
    triggerLastRun?: Date;
    config?: string | undefined;
    integrationRuns?: IntegrationRun[] | undefined;
}

export abstract class Enumeration implements IEnumeration {
    name?: string | undefined;
    displayName?: string | undefined;
    value?: number;

    constructor(data?: IEnumeration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Enumeration {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Enumeration' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["value"] = this.value;
        return data;
    }
}

export interface IEnumeration {
    name?: string | undefined;
    displayName?: string | undefined;
    value?: number;
}

export class IntegrationType extends Enumeration implements IIntegrationType {

    constructor(data?: IIntegrationType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): IntegrationType {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIntegrationType extends IEnumeration {
}

export class IntegrationRun implements IIntegrationRun {
    id?: string | undefined;
    created?: Date;
    updated?: Date;
    status?: IntegrationStatus | undefined;
    integrationID?: string | undefined;
    integration?: Integration | undefined;
    data?: string | undefined;

    constructor(data?: IIntegrationRun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.status = _data["status"] ? IntegrationStatus.fromJS(_data["status"]) : <any>undefined;
            this.integrationID = _data["integrationID"];
            this.integration = _data["integration"] ? Integration.fromJS(_data["integration"]) : <any>undefined;
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): IntegrationRun {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationRun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["integrationID"] = this.integrationID;
        data["integration"] = this.integration ? this.integration.toJSON() : <any>undefined;
        data["data"] = this.data;
        return data;
    }
}

export interface IIntegrationRun {
    id?: string | undefined;
    created?: Date;
    updated?: Date;
    status?: IntegrationStatus | undefined;
    integrationID?: string | undefined;
    integration?: Integration | undefined;
    data?: string | undefined;
}

export class IntegrationStatus extends Enumeration implements IIntegrationStatus {

    constructor(data?: IIntegrationStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): IntegrationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIntegrationStatus extends IEnumeration {
}

export class LoadAssessmentDataParameters implements ILoadAssessmentDataParameters {
    url?: string | undefined;
    schoolID?: string | undefined;
    includeAssessmentStructure?: boolean;

    constructor(data?: ILoadAssessmentDataParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.schoolID = _data["schoolID"];
            this.includeAssessmentStructure = _data["includeAssessmentStructure"];
        }
    }

    static fromJS(data: any): LoadAssessmentDataParameters {
        data = typeof data === 'object' ? data : {};
        let result = new LoadAssessmentDataParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["schoolID"] = this.schoolID;
        data["includeAssessmentStructure"] = this.includeAssessmentStructure;
        return data;
    }
}

export interface ILoadAssessmentDataParameters {
    url?: string | undefined;
    schoolID?: string | undefined;
    includeAssessmentStructure?: boolean;
}

export class UpdateIntegrationModel implements IUpdateIntegrationModel {
    id?: string | undefined;
    name?: string | undefined;
    config?: { [key: string]: any; } | undefined;

    constructor(data?: IUpdateIntegrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (_data["config"]) {
                this.config = {} as any;
                for (let key in _data["config"]) {
                    if (_data["config"].hasOwnProperty(key))
                        (<any>this.config)![key] = _data["config"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdateIntegrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIntegrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.config) {
            data["config"] = {};
            for (let key in this.config) {
                if (this.config.hasOwnProperty(key))
                    (<any>data["config"])[key] = (<any>this.config)[key];
            }
        }
        return data;
    }
}

export interface IUpdateIntegrationModel {
    id?: string | undefined;
    name?: string | undefined;
    config?: { [key: string]: any; } | undefined;
}

export class CreateIntegrationModel implements ICreateIntegrationModel {
    integrationType?: string | undefined;
    config?: { [key: string]: any; } | undefined;

    constructor(data?: ICreateIntegrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationType = _data["integrationType"];
            if (_data["config"]) {
                this.config = {} as any;
                for (let key in _data["config"]) {
                    if (_data["config"].hasOwnProperty(key))
                        (<any>this.config)![key] = _data["config"][key];
                }
            }
        }
    }

    static fromJS(data: any): CreateIntegrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIntegrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        if (this.config) {
            data["config"] = {};
            for (let key in this.config) {
                if (this.config.hasOwnProperty(key))
                    (<any>data["config"])[key] = (<any>this.config)[key];
            }
        }
        return data;
    }
}

export interface ICreateIntegrationModel {
    integrationType?: string | undefined;
    config?: { [key: string]: any; } | undefined;
}

export class AuditPageModel implements IAuditPageModel {
    page?: number;
    pageSize?: number;
    totalCount?: number;
    entries?: AuditEntryModel[] | undefined;

    constructor(data?: IAuditPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(AuditEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuditPageModel {
    page?: number;
    pageSize?: number;
    totalCount?: number;
    entries?: AuditEntryModel[] | undefined;
}

export class AuditEntryModel implements IAuditEntryModel {
    id?: string | undefined;
    entityType?: string | undefined;
    entityID?: string | undefined;
    action?: string | undefined;
    actorID?: string | undefined;
    occurredAt?: Date;
    beforeJson?: string | undefined;
    afterJson?: string | undefined;

    constructor(data?: IAuditEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityType = _data["entityType"];
            this.entityID = _data["entityID"];
            this.action = _data["action"];
            this.actorID = _data["actorID"];
            this.occurredAt = _data["occurredAt"] ? new Date(_data["occurredAt"].toString()) : <any>undefined;
            this.beforeJson = _data["beforeJson"];
            this.afterJson = _data["afterJson"];
        }
    }

    static fromJS(data: any): AuditEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["entityID"] = this.entityID;
        data["action"] = this.action;
        data["actorID"] = this.actorID;
        data["occurredAt"] = this.occurredAt ? this.occurredAt.toISOString() : <any>undefined;
        data["beforeJson"] = this.beforeJson;
        data["afterJson"] = this.afterJson;
        return data;
    }
}

export interface IAuditEntryModel {
    id?: string | undefined;
    entityType?: string | undefined;
    entityID?: string | undefined;
    action?: string | undefined;
    actorID?: string | undefined;
    occurredAt?: Date;
    beforeJson?: string | undefined;
    afterJson?: string | undefined;
}

export class CurriculumTemplateSummaryModel implements ICurriculumTemplateSummaryModel {
    key?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    hasSeedData?: boolean;
    applications?: CurriculumTemplateApplicationModel[] | undefined;
    draft?: CurriculumTemplateDraftSummaryModel | undefined;

    constructor(data?: ICurriculumTemplateSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.hasSeedData = _data["hasSeedData"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(CurriculumTemplateApplicationModel.fromJS(item));
            }
            this.draft = _data["draft"] ? CurriculumTemplateDraftSummaryModel.fromJS(_data["draft"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CurriculumTemplateSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["hasSeedData"] = this.hasSeedData;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        data["draft"] = this.draft ? this.draft.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICurriculumTemplateSummaryModel {
    key?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    hasSeedData?: boolean;
    applications?: CurriculumTemplateApplicationModel[] | undefined;
    draft?: CurriculumTemplateDraftSummaryModel | undefined;
}

export class CurriculumTemplateApplicationModel implements ICurriculumTemplateApplicationModel {
    id?: string | undefined;
    templateVersion?: number;
    appliedAt?: Date;
    appliedByUserID?: string | undefined;

    constructor(data?: ICurriculumTemplateApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateVersion = _data["templateVersion"];
            this.appliedAt = _data["appliedAt"] ? new Date(_data["appliedAt"].toString()) : <any>undefined;
            this.appliedByUserID = _data["appliedByUserID"];
        }
    }

    static fromJS(data: any): CurriculumTemplateApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateVersion"] = this.templateVersion;
        data["appliedAt"] = this.appliedAt ? this.appliedAt.toISOString() : <any>undefined;
        data["appliedByUserID"] = this.appliedByUserID;
        return data;
    }
}

export interface ICurriculumTemplateApplicationModel {
    id?: string | undefined;
    templateVersion?: number;
    appliedAt?: Date;
    appliedByUserID?: string | undefined;
}

export class CurriculumTemplateDraftSummaryModel implements ICurriculumTemplateDraftSummaryModel {
    currentStep?: string | undefined;
    updatedAt?: Date;
    updatedByUserID?: string | undefined;

    constructor(data?: ICurriculumTemplateDraftSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentStep = _data["currentStep"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedByUserID = _data["updatedByUserID"];
        }
    }

    static fromJS(data: any): CurriculumTemplateDraftSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateDraftSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentStep"] = this.currentStep;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedByUserID"] = this.updatedByUserID;
        return data;
    }
}

export interface ICurriculumTemplateDraftSummaryModel {
    currentStep?: string | undefined;
    updatedAt?: Date;
    updatedByUserID?: string | undefined;
}

export class CurriculumTemplatePreviewModel implements ICurriculumTemplatePreviewModel {
    key?: string | undefined;
    displayName?: string | undefined;
    hasSeedData?: boolean;
    subjects?: CurriculumTemplatePreviewItemModel[] | undefined;
    assessmentTypes?: CurriculumTemplatePreviewItemModel[] | undefined;
    markTypes?: CurriculumTemplatePreviewItemModel[] | undefined;
    cycles?: CurriculumTemplatePreviewItemModel[] | undefined;
    divisions?: CurriculumTemplateDivisionPreviewModel[] | undefined;
    divisionMethod?: string | undefined;
    procedures?: CurriculumTemplatePreviewItemModel[] | undefined;
    structure?: CurriculumTemplateStructurePreviewModel | undefined;

    constructor(data?: ICurriculumTemplatePreviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.hasSeedData = _data["hasSeedData"];
            if (Array.isArray(_data["subjects"])) {
                this.subjects = [] as any;
                for (let item of _data["subjects"])
                    this.subjects!.push(CurriculumTemplatePreviewItemModel.fromJS(item));
            }
            if (Array.isArray(_data["assessmentTypes"])) {
                this.assessmentTypes = [] as any;
                for (let item of _data["assessmentTypes"])
                    this.assessmentTypes!.push(CurriculumTemplatePreviewItemModel.fromJS(item));
            }
            if (Array.isArray(_data["markTypes"])) {
                this.markTypes = [] as any;
                for (let item of _data["markTypes"])
                    this.markTypes!.push(CurriculumTemplatePreviewItemModel.fromJS(item));
            }
            if (Array.isArray(_data["cycles"])) {
                this.cycles = [] as any;
                for (let item of _data["cycles"])
                    this.cycles!.push(CurriculumTemplatePreviewItemModel.fromJS(item));
            }
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(CurriculumTemplateDivisionPreviewModel.fromJS(item));
            }
            this.divisionMethod = _data["divisionMethod"];
            if (Array.isArray(_data["procedures"])) {
                this.procedures = [] as any;
                for (let item of _data["procedures"])
                    this.procedures!.push(CurriculumTemplatePreviewItemModel.fromJS(item));
            }
            this.structure = _data["structure"] ? CurriculumTemplateStructurePreviewModel.fromJS(_data["structure"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CurriculumTemplatePreviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplatePreviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["hasSeedData"] = this.hasSeedData;
        if (Array.isArray(this.subjects)) {
            data["subjects"] = [];
            for (let item of this.subjects)
                data["subjects"].push(item.toJSON());
        }
        if (Array.isArray(this.assessmentTypes)) {
            data["assessmentTypes"] = [];
            for (let item of this.assessmentTypes)
                data["assessmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.markTypes)) {
            data["markTypes"] = [];
            for (let item of this.markTypes)
                data["markTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.cycles)) {
            data["cycles"] = [];
            for (let item of this.cycles)
                data["cycles"].push(item.toJSON());
        }
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item.toJSON());
        }
        data["divisionMethod"] = this.divisionMethod;
        if (Array.isArray(this.procedures)) {
            data["procedures"] = [];
            for (let item of this.procedures)
                data["procedures"].push(item.toJSON());
        }
        data["structure"] = this.structure ? this.structure.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICurriculumTemplatePreviewModel {
    key?: string | undefined;
    displayName?: string | undefined;
    hasSeedData?: boolean;
    subjects?: CurriculumTemplatePreviewItemModel[] | undefined;
    assessmentTypes?: CurriculumTemplatePreviewItemModel[] | undefined;
    markTypes?: CurriculumTemplatePreviewItemModel[] | undefined;
    cycles?: CurriculumTemplatePreviewItemModel[] | undefined;
    divisions?: CurriculumTemplateDivisionPreviewModel[] | undefined;
    divisionMethod?: string | undefined;
    procedures?: CurriculumTemplatePreviewItemModel[] | undefined;
    structure?: CurriculumTemplateStructurePreviewModel | undefined;
}

export class CurriculumTemplatePreviewItemModel implements ICurriculumTemplatePreviewItemModel {
    name?: string | undefined;
    willCreate?: boolean;

    constructor(data?: ICurriculumTemplatePreviewItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.willCreate = _data["willCreate"];
        }
    }

    static fromJS(data: any): CurriculumTemplatePreviewItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplatePreviewItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["willCreate"] = this.willCreate;
        return data;
    }
}

export interface ICurriculumTemplatePreviewItemModel {
    name?: string | undefined;
    willCreate?: boolean;
}

export class CurriculumTemplateDivisionPreviewModel implements ICurriculumTemplateDivisionPreviewModel {
    name?: string | undefined;
    weight?: number;
    willCreate?: boolean;

    constructor(data?: ICurriculumTemplateDivisionPreviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.weight = _data["weight"];
            this.willCreate = _data["willCreate"];
        }
    }

    static fromJS(data: any): CurriculumTemplateDivisionPreviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateDivisionPreviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["weight"] = this.weight;
        data["willCreate"] = this.willCreate;
        return data;
    }
}

export interface ICurriculumTemplateDivisionPreviewModel {
    name?: string | undefined;
    weight?: number;
    willCreate?: boolean;
}

export class CurriculumTemplateStructurePreviewModel implements ICurriculumTemplateStructurePreviewModel {
    defaultFacultyName?: string | undefined;
    defaultSchoolName?: string | undefined;
    qualificationName?: string | undefined;
    levels?: CurriculumTemplatePreviewItemModel[] | undefined;
    existingFaculties?: string[] | undefined;
    existingSchools?: string[] | undefined;
    existingQualificationCount?: number;
    qualificationModuleCount?: number;
    choiceRuleNames?: string[] | undefined;

    constructor(data?: ICurriculumTemplateStructurePreviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFacultyName = _data["defaultFacultyName"];
            this.defaultSchoolName = _data["defaultSchoolName"];
            this.qualificationName = _data["qualificationName"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(CurriculumTemplatePreviewItemModel.fromJS(item));
            }
            if (Array.isArray(_data["existingFaculties"])) {
                this.existingFaculties = [] as any;
                for (let item of _data["existingFaculties"])
                    this.existingFaculties!.push(item);
            }
            if (Array.isArray(_data["existingSchools"])) {
                this.existingSchools = [] as any;
                for (let item of _data["existingSchools"])
                    this.existingSchools!.push(item);
            }
            this.existingQualificationCount = _data["existingQualificationCount"];
            this.qualificationModuleCount = _data["qualificationModuleCount"];
            if (Array.isArray(_data["choiceRuleNames"])) {
                this.choiceRuleNames = [] as any;
                for (let item of _data["choiceRuleNames"])
                    this.choiceRuleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CurriculumTemplateStructurePreviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateStructurePreviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFacultyName"] = this.defaultFacultyName;
        data["defaultSchoolName"] = this.defaultSchoolName;
        data["qualificationName"] = this.qualificationName;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        if (Array.isArray(this.existingFaculties)) {
            data["existingFaculties"] = [];
            for (let item of this.existingFaculties)
                data["existingFaculties"].push(item);
        }
        if (Array.isArray(this.existingSchools)) {
            data["existingSchools"] = [];
            for (let item of this.existingSchools)
                data["existingSchools"].push(item);
        }
        data["existingQualificationCount"] = this.existingQualificationCount;
        data["qualificationModuleCount"] = this.qualificationModuleCount;
        if (Array.isArray(this.choiceRuleNames)) {
            data["choiceRuleNames"] = [];
            for (let item of this.choiceRuleNames)
                data["choiceRuleNames"].push(item);
        }
        return data;
    }
}

export interface ICurriculumTemplateStructurePreviewModel {
    defaultFacultyName?: string | undefined;
    defaultSchoolName?: string | undefined;
    qualificationName?: string | undefined;
    levels?: CurriculumTemplatePreviewItemModel[] | undefined;
    existingFaculties?: string[] | undefined;
    existingSchools?: string[] | undefined;
    existingQualificationCount?: number;
    qualificationModuleCount?: number;
    choiceRuleNames?: string[] | undefined;
}

export class CurriculumTemplateDraftModel implements ICurriculumTemplateDraftModel {
    templateKey?: string | undefined;
    templateVersion?: number;
    isSaved?: boolean;
    isStale?: boolean;
    currentStep?: string | undefined;
    updatedAt?: Date | undefined;
    updatedByUserID?: string | undefined;
    options?: CurriculumTemplateApplyOptions | undefined;
    validationError?: string | undefined;

    constructor(data?: ICurriculumTemplateDraftModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateKey = _data["templateKey"];
            this.templateVersion = _data["templateVersion"];
            this.isSaved = _data["isSaved"];
            this.isStale = _data["isStale"];
            this.currentStep = _data["currentStep"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedByUserID = _data["updatedByUserID"];
            this.options = _data["options"] ? CurriculumTemplateApplyOptions.fromJS(_data["options"]) : <any>undefined;
            this.validationError = _data["validationError"];
        }
    }

    static fromJS(data: any): CurriculumTemplateDraftModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateDraftModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateKey"] = this.templateKey;
        data["templateVersion"] = this.templateVersion;
        data["isSaved"] = this.isSaved;
        data["isStale"] = this.isStale;
        data["currentStep"] = this.currentStep;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedByUserID"] = this.updatedByUserID;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        data["validationError"] = this.validationError;
        return data;
    }
}

export interface ICurriculumTemplateDraftModel {
    templateKey?: string | undefined;
    templateVersion?: number;
    isSaved?: boolean;
    isStale?: boolean;
    currentStep?: string | undefined;
    updatedAt?: Date | undefined;
    updatedByUserID?: string | undefined;
    options?: CurriculumTemplateApplyOptions | undefined;
    validationError?: string | undefined;
}

export class CurriculumTemplateApplyOptions implements ICurriculumTemplateApplyOptions {
    createStructure?: boolean;
    assignProcedure?: boolean;
    facultyName?: string | undefined;
    schoolName?: string | undefined;
    levelNames?: string[] | undefined;
    excludedSubjects?: string[] | undefined;
    additionalSubjects?: string[] | undefined;
    cycles?: CurriculumTemplateCycleOption[] | undefined;
    divisionWeights?: { [key: string]: number; } | undefined;
    excludedChoiceRules?: string[] | undefined;
    assessmentPlan?: CurriculumTemplatePlannedAssessmentOption[] | undefined;

    constructor(data?: ICurriculumTemplateApplyOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createStructure = _data["createStructure"];
            this.assignProcedure = _data["assignProcedure"];
            this.facultyName = _data["facultyName"];
            this.schoolName = _data["schoolName"];
            if (Array.isArray(_data["levelNames"])) {
                this.levelNames = [] as any;
                for (let item of _data["levelNames"])
                    this.levelNames!.push(item);
            }
            if (Array.isArray(_data["excludedSubjects"])) {
                this.excludedSubjects = [] as any;
                for (let item of _data["excludedSubjects"])
                    this.excludedSubjects!.push(item);
            }
            if (Array.isArray(_data["additionalSubjects"])) {
                this.additionalSubjects = [] as any;
                for (let item of _data["additionalSubjects"])
                    this.additionalSubjects!.push(item);
            }
            if (Array.isArray(_data["cycles"])) {
                this.cycles = [] as any;
                for (let item of _data["cycles"])
                    this.cycles!.push(CurriculumTemplateCycleOption.fromJS(item));
            }
            if (_data["divisionWeights"]) {
                this.divisionWeights = {} as any;
                for (let key in _data["divisionWeights"]) {
                    if (_data["divisionWeights"].hasOwnProperty(key))
                        (<any>this.divisionWeights)![key] = _data["divisionWeights"][key];
                }
            }
            if (Array.isArray(_data["excludedChoiceRules"])) {
                this.excludedChoiceRules = [] as any;
                for (let item of _data["excludedChoiceRules"])
                    this.excludedChoiceRules!.push(item);
            }
            if (Array.isArray(_data["assessmentPlan"])) {
                this.assessmentPlan = [] as any;
                for (let item of _data["assessmentPlan"])
                    this.assessmentPlan!.push(CurriculumTemplatePlannedAssessmentOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CurriculumTemplateApplyOptions {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateApplyOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createStructure"] = this.createStructure;
        data["assignProcedure"] = this.assignProcedure;
        data["facultyName"] = this.facultyName;
        data["schoolName"] = this.schoolName;
        if (Array.isArray(this.levelNames)) {
            data["levelNames"] = [];
            for (let item of this.levelNames)
                data["levelNames"].push(item);
        }
        if (Array.isArray(this.excludedSubjects)) {
            data["excludedSubjects"] = [];
            for (let item of this.excludedSubjects)
                data["excludedSubjects"].push(item);
        }
        if (Array.isArray(this.additionalSubjects)) {
            data["additionalSubjects"] = [];
            for (let item of this.additionalSubjects)
                data["additionalSubjects"].push(item);
        }
        if (Array.isArray(this.cycles)) {
            data["cycles"] = [];
            for (let item of this.cycles)
                data["cycles"].push(item.toJSON());
        }
        if (this.divisionWeights) {
            data["divisionWeights"] = {};
            for (let key in this.divisionWeights) {
                if (this.divisionWeights.hasOwnProperty(key))
                    (<any>data["divisionWeights"])[key] = (<any>this.divisionWeights)[key];
            }
        }
        if (Array.isArray(this.excludedChoiceRules)) {
            data["excludedChoiceRules"] = [];
            for (let item of this.excludedChoiceRules)
                data["excludedChoiceRules"].push(item);
        }
        if (Array.isArray(this.assessmentPlan)) {
            data["assessmentPlan"] = [];
            for (let item of this.assessmentPlan)
                data["assessmentPlan"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICurriculumTemplateApplyOptions {
    createStructure?: boolean;
    assignProcedure?: boolean;
    facultyName?: string | undefined;
    schoolName?: string | undefined;
    levelNames?: string[] | undefined;
    excludedSubjects?: string[] | undefined;
    additionalSubjects?: string[] | undefined;
    cycles?: CurriculumTemplateCycleOption[] | undefined;
    divisionWeights?: { [key: string]: number; } | undefined;
    excludedChoiceRules?: string[] | undefined;
    assessmentPlan?: CurriculumTemplatePlannedAssessmentOption[] | undefined;
}

export class CurriculumTemplateCycleOption implements ICurriculumTemplateCycleOption {
    name?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: ICurriculumTemplateCycleOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CurriculumTemplateCycleOption {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateCycleOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICurriculumTemplateCycleOption {
    name?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class CurriculumTemplatePlannedAssessmentOption implements ICurriculumTemplatePlannedAssessmentOption {
    division?: string | undefined;
    name?: string | undefined;
    assessmentType?: string | undefined;
    total?: number;
    terms?: number[] | undefined;

    constructor(data?: ICurriculumTemplatePlannedAssessmentOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.division = _data["division"];
            this.name = _data["name"];
            this.assessmentType = _data["assessmentType"];
            this.total = _data["total"];
            if (Array.isArray(_data["terms"])) {
                this.terms = [] as any;
                for (let item of _data["terms"])
                    this.terms!.push(item);
            }
        }
    }

    static fromJS(data: any): CurriculumTemplatePlannedAssessmentOption {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplatePlannedAssessmentOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        data["name"] = this.name;
        data["assessmentType"] = this.assessmentType;
        data["total"] = this.total;
        if (Array.isArray(this.terms)) {
            data["terms"] = [];
            for (let item of this.terms)
                data["terms"].push(item);
        }
        return data;
    }
}

export interface ICurriculumTemplatePlannedAssessmentOption {
    division?: string | undefined;
    name?: string | undefined;
    assessmentType?: string | undefined;
    total?: number;
    terms?: number[] | undefined;
}

export class CurriculumTemplateDraftWriteModel implements ICurriculumTemplateDraftWriteModel {
    currentStep?: string | undefined;
    options?: CurriculumTemplateApplyOptions | undefined;

    constructor(data?: ICurriculumTemplateDraftWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentStep = _data["currentStep"];
            this.options = _data["options"] ? CurriculumTemplateApplyOptions.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CurriculumTemplateDraftWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateDraftWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentStep"] = this.currentStep;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICurriculumTemplateDraftWriteModel {
    currentStep?: string | undefined;
    options?: CurriculumTemplateApplyOptions | undefined;
}

export class CurriculumTemplateApplyResultModel implements ICurriculumTemplateApplyResultModel {
    key?: string | undefined;
    templateVersion?: number;
    createdSubjects?: string[] | undefined;
    skippedSubjects?: string[] | undefined;
    createdAssessmentTypes?: string[] | undefined;
    skippedAssessmentTypes?: string[] | undefined;
    createdMarkTypes?: string[] | undefined;
    skippedMarkTypes?: string[] | undefined;
    createdCycles?: string[] | undefined;
    skippedCycles?: string[] | undefined;
    createdDivisions?: string[] | undefined;
    skippedDivisions?: string[] | undefined;
    procedures?: CurriculumTemplateProcedureResultModel[] | undefined;
    structure?: CurriculumTemplateStructureResultModel | undefined;

    constructor(data?: ICurriculumTemplateApplyResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.templateVersion = _data["templateVersion"];
            if (Array.isArray(_data["createdSubjects"])) {
                this.createdSubjects = [] as any;
                for (let item of _data["createdSubjects"])
                    this.createdSubjects!.push(item);
            }
            if (Array.isArray(_data["skippedSubjects"])) {
                this.skippedSubjects = [] as any;
                for (let item of _data["skippedSubjects"])
                    this.skippedSubjects!.push(item);
            }
            if (Array.isArray(_data["createdAssessmentTypes"])) {
                this.createdAssessmentTypes = [] as any;
                for (let item of _data["createdAssessmentTypes"])
                    this.createdAssessmentTypes!.push(item);
            }
            if (Array.isArray(_data["skippedAssessmentTypes"])) {
                this.skippedAssessmentTypes = [] as any;
                for (let item of _data["skippedAssessmentTypes"])
                    this.skippedAssessmentTypes!.push(item);
            }
            if (Array.isArray(_data["createdMarkTypes"])) {
                this.createdMarkTypes = [] as any;
                for (let item of _data["createdMarkTypes"])
                    this.createdMarkTypes!.push(item);
            }
            if (Array.isArray(_data["skippedMarkTypes"])) {
                this.skippedMarkTypes = [] as any;
                for (let item of _data["skippedMarkTypes"])
                    this.skippedMarkTypes!.push(item);
            }
            if (Array.isArray(_data["createdCycles"])) {
                this.createdCycles = [] as any;
                for (let item of _data["createdCycles"])
                    this.createdCycles!.push(item);
            }
            if (Array.isArray(_data["skippedCycles"])) {
                this.skippedCycles = [] as any;
                for (let item of _data["skippedCycles"])
                    this.skippedCycles!.push(item);
            }
            if (Array.isArray(_data["createdDivisions"])) {
                this.createdDivisions = [] as any;
                for (let item of _data["createdDivisions"])
                    this.createdDivisions!.push(item);
            }
            if (Array.isArray(_data["skippedDivisions"])) {
                this.skippedDivisions = [] as any;
                for (let item of _data["skippedDivisions"])
                    this.skippedDivisions!.push(item);
            }
            if (Array.isArray(_data["procedures"])) {
                this.procedures = [] as any;
                for (let item of _data["procedures"])
                    this.procedures!.push(CurriculumTemplateProcedureResultModel.fromJS(item));
            }
            this.structure = _data["structure"] ? CurriculumTemplateStructureResultModel.fromJS(_data["structure"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CurriculumTemplateApplyResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateApplyResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["templateVersion"] = this.templateVersion;
        if (Array.isArray(this.createdSubjects)) {
            data["createdSubjects"] = [];
            for (let item of this.createdSubjects)
                data["createdSubjects"].push(item);
        }
        if (Array.isArray(this.skippedSubjects)) {
            data["skippedSubjects"] = [];
            for (let item of this.skippedSubjects)
                data["skippedSubjects"].push(item);
        }
        if (Array.isArray(this.createdAssessmentTypes)) {
            data["createdAssessmentTypes"] = [];
            for (let item of this.createdAssessmentTypes)
                data["createdAssessmentTypes"].push(item);
        }
        if (Array.isArray(this.skippedAssessmentTypes)) {
            data["skippedAssessmentTypes"] = [];
            for (let item of this.skippedAssessmentTypes)
                data["skippedAssessmentTypes"].push(item);
        }
        if (Array.isArray(this.createdMarkTypes)) {
            data["createdMarkTypes"] = [];
            for (let item of this.createdMarkTypes)
                data["createdMarkTypes"].push(item);
        }
        if (Array.isArray(this.skippedMarkTypes)) {
            data["skippedMarkTypes"] = [];
            for (let item of this.skippedMarkTypes)
                data["skippedMarkTypes"].push(item);
        }
        if (Array.isArray(this.createdCycles)) {
            data["createdCycles"] = [];
            for (let item of this.createdCycles)
                data["createdCycles"].push(item);
        }
        if (Array.isArray(this.skippedCycles)) {
            data["skippedCycles"] = [];
            for (let item of this.skippedCycles)
                data["skippedCycles"].push(item);
        }
        if (Array.isArray(this.createdDivisions)) {
            data["createdDivisions"] = [];
            for (let item of this.createdDivisions)
                data["createdDivisions"].push(item);
        }
        if (Array.isArray(this.skippedDivisions)) {
            data["skippedDivisions"] = [];
            for (let item of this.skippedDivisions)
                data["skippedDivisions"].push(item);
        }
        if (Array.isArray(this.procedures)) {
            data["procedures"] = [];
            for (let item of this.procedures)
                data["procedures"].push(item.toJSON());
        }
        data["structure"] = this.structure ? this.structure.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICurriculumTemplateApplyResultModel {
    key?: string | undefined;
    templateVersion?: number;
    createdSubjects?: string[] | undefined;
    skippedSubjects?: string[] | undefined;
    createdAssessmentTypes?: string[] | undefined;
    skippedAssessmentTypes?: string[] | undefined;
    createdMarkTypes?: string[] | undefined;
    skippedMarkTypes?: string[] | undefined;
    createdCycles?: string[] | undefined;
    skippedCycles?: string[] | undefined;
    createdDivisions?: string[] | undefined;
    skippedDivisions?: string[] | undefined;
    procedures?: CurriculumTemplateProcedureResultModel[] | undefined;
    structure?: CurriculumTemplateStructureResultModel | undefined;
}

export class CurriculumTemplateProcedureResultModel implements ICurriculumTemplateProcedureResultModel {
    name?: string | undefined;
    procedureID?: string | undefined;
    procedureVersionID?: string | undefined;
    alreadyExisted?: boolean;

    constructor(data?: ICurriculumTemplateProcedureResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.procedureID = _data["procedureID"];
            this.procedureVersionID = _data["procedureVersionID"];
            this.alreadyExisted = _data["alreadyExisted"];
        }
    }

    static fromJS(data: any): CurriculumTemplateProcedureResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateProcedureResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["procedureID"] = this.procedureID;
        data["procedureVersionID"] = this.procedureVersionID;
        data["alreadyExisted"] = this.alreadyExisted;
        return data;
    }
}

export interface ICurriculumTemplateProcedureResultModel {
    name?: string | undefined;
    procedureID?: string | undefined;
    procedureVersionID?: string | undefined;
    alreadyExisted?: boolean;
}

export class CurriculumTemplateStructureResultModel implements ICurriculumTemplateStructureResultModel {
    facultyName?: string | undefined;
    facultyCreated?: boolean;
    schoolName?: string | undefined;
    schoolCreated?: boolean;
    qualificationName?: string | undefined;
    qualificationCreated?: boolean;
    createdLevels?: string[] | undefined;
    skippedLevels?: string[] | undefined;
    createdProgramLevels?: number;
    createdQualificationModules?: number;
    skippedQualificationModules?: number;
    createdDivisionGroups?: number;
    createdAssignments?: number;
    skippedAssignments?: number;
    createdChoiceRules?: number;
    createdAssessments?: number;

    constructor(data?: ICurriculumTemplateStructureResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facultyName = _data["facultyName"];
            this.facultyCreated = _data["facultyCreated"];
            this.schoolName = _data["schoolName"];
            this.schoolCreated = _data["schoolCreated"];
            this.qualificationName = _data["qualificationName"];
            this.qualificationCreated = _data["qualificationCreated"];
            if (Array.isArray(_data["createdLevels"])) {
                this.createdLevels = [] as any;
                for (let item of _data["createdLevels"])
                    this.createdLevels!.push(item);
            }
            if (Array.isArray(_data["skippedLevels"])) {
                this.skippedLevels = [] as any;
                for (let item of _data["skippedLevels"])
                    this.skippedLevels!.push(item);
            }
            this.createdProgramLevels = _data["createdProgramLevels"];
            this.createdQualificationModules = _data["createdQualificationModules"];
            this.skippedQualificationModules = _data["skippedQualificationModules"];
            this.createdDivisionGroups = _data["createdDivisionGroups"];
            this.createdAssignments = _data["createdAssignments"];
            this.skippedAssignments = _data["skippedAssignments"];
            this.createdChoiceRules = _data["createdChoiceRules"];
            this.createdAssessments = _data["createdAssessments"];
        }
    }

    static fromJS(data: any): CurriculumTemplateStructureResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurriculumTemplateStructureResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facultyName"] = this.facultyName;
        data["facultyCreated"] = this.facultyCreated;
        data["schoolName"] = this.schoolName;
        data["schoolCreated"] = this.schoolCreated;
        data["qualificationName"] = this.qualificationName;
        data["qualificationCreated"] = this.qualificationCreated;
        if (Array.isArray(this.createdLevels)) {
            data["createdLevels"] = [];
            for (let item of this.createdLevels)
                data["createdLevels"].push(item);
        }
        if (Array.isArray(this.skippedLevels)) {
            data["skippedLevels"] = [];
            for (let item of this.skippedLevels)
                data["skippedLevels"].push(item);
        }
        data["createdProgramLevels"] = this.createdProgramLevels;
        data["createdQualificationModules"] = this.createdQualificationModules;
        data["skippedQualificationModules"] = this.skippedQualificationModules;
        data["createdDivisionGroups"] = this.createdDivisionGroups;
        data["createdAssignments"] = this.createdAssignments;
        data["skippedAssignments"] = this.skippedAssignments;
        data["createdChoiceRules"] = this.createdChoiceRules;
        data["createdAssessments"] = this.createdAssessments;
        return data;
    }
}

export interface ICurriculumTemplateStructureResultModel {
    facultyName?: string | undefined;
    facultyCreated?: boolean;
    schoolName?: string | undefined;
    schoolCreated?: boolean;
    qualificationName?: string | undefined;
    qualificationCreated?: boolean;
    createdLevels?: string[] | undefined;
    skippedLevels?: string[] | undefined;
    createdProgramLevels?: number;
    createdQualificationModules?: number;
    skippedQualificationModules?: number;
    createdDivisionGroups?: number;
    createdAssignments?: number;
    skippedAssignments?: number;
    createdChoiceRules?: number;
    createdAssessments?: number;
}

export class DefaultResponse implements IDefaultResponse {
    success?: boolean;
    errors?: ErrorCollection | undefined;
    message?: string | undefined;

    constructor(data?: IDefaultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errors = _data["errors"] ? ErrorCollection.fromJS(_data["errors"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DefaultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errors"] = this.errors ? this.errors.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IDefaultResponse {
    success?: boolean;
    errors?: ErrorCollection | undefined;
    message?: string | undefined;
}

export class TypedResponseOfFacultyAPIModel extends DefaultResponse implements ITypedResponseOfFacultyAPIModel {
    value?: FacultyAPIModel | undefined;

    constructor(data?: ITypedResponseOfFacultyAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? FacultyAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfFacultyAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfFacultyAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfFacultyAPIModel extends IDefaultResponse {
    value?: FacultyAPIModel | undefined;
}

export class FacultyAPIModel implements IFacultyAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    schools?: SchoolAPIModel[] | undefined;
    organizationID?: string | undefined;

    constructor(data?: IFacultyAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.sourceID = _data["sourceID"];
            if (Array.isArray(_data["schools"])) {
                this.schools = [] as any;
                for (let item of _data["schools"])
                    this.schools!.push(SchoolAPIModel.fromJS(item));
            }
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): FacultyAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new FacultyAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["source"] = this.source;
        data["sourceID"] = this.sourceID;
        if (Array.isArray(this.schools)) {
            data["schools"] = [];
            for (let item of this.schools)
                data["schools"].push(item.toJSON());
        }
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IFacultyAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    schools?: SchoolAPIModel[] | undefined;
    organizationID?: string | undefined;
}

export class SchoolAPIModel implements ISchoolAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    facultyID?: string | undefined;
    faculty?: FacultyAPIModel | undefined;
    qualifications?: QualificationAPIModel[] | undefined;
    organizationID?: string | undefined;

    constructor(data?: ISchoolAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.sourceID = _data["sourceID"];
            this.facultyID = _data["facultyID"];
            this.faculty = _data["faculty"] ? FacultyAPIModel.fromJS(_data["faculty"]) : <any>undefined;
            if (Array.isArray(_data["qualifications"])) {
                this.qualifications = [] as any;
                for (let item of _data["qualifications"])
                    this.qualifications!.push(QualificationAPIModel.fromJS(item));
            }
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): SchoolAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["source"] = this.source;
        data["sourceID"] = this.sourceID;
        data["facultyID"] = this.facultyID;
        data["faculty"] = this.faculty ? this.faculty.toJSON() : <any>undefined;
        if (Array.isArray(this.qualifications)) {
            data["qualifications"] = [];
            for (let item of this.qualifications)
                data["qualifications"].push(item.toJSON());
        }
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface ISchoolAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    facultyID?: string | undefined;
    faculty?: FacultyAPIModel | undefined;
    qualifications?: QualificationAPIModel[] | undefined;
    organizationID?: string | undefined;
}

export class QualificationAPIModel implements IQualificationAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    schoolID?: string | undefined;
    school?: SchoolAPIModel | undefined;
    organizationID?: string | undefined;

    constructor(data?: IQualificationAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.sourceID = _data["sourceID"];
            this.schoolID = _data["schoolID"];
            this.school = _data["school"] ? SchoolAPIModel.fromJS(_data["school"]) : <any>undefined;
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): QualificationAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["source"] = this.source;
        data["sourceID"] = this.sourceID;
        data["schoolID"] = this.schoolID;
        data["school"] = this.school ? this.school.toJSON() : <any>undefined;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IQualificationAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    schoolID?: string | undefined;
    school?: SchoolAPIModel | undefined;
    organizationID?: string | undefined;
}

export class ErrorCollection implements IErrorCollection {
    errors?: ErrorItem[] | undefined;
    hasErrors?: boolean;

    constructor(data?: IErrorCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorItem.fromJS(item));
            }
            this.hasErrors = _data["hasErrors"];
        }
    }

    static fromJS(data: any): ErrorCollection {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["hasErrors"] = this.hasErrors;
        return data;
    }
}

export interface IErrorCollection {
    errors?: ErrorItem[] | undefined;
    hasErrors?: boolean;
}

export class ErrorItem implements IErrorItem {
    message?: string | undefined;
    error?: string | undefined;
    exception?: Exception | undefined;

    constructor(data?: IErrorItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.error = _data["error"];
            this.exception = _data["exception"] ? Exception.fromJS(_data["exception"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ErrorItem {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["error"] = this.error;
        data["exception"] = this.exception ? this.exception.toJSON() : <any>undefined;
        return data;
    }
}

export interface IErrorItem {
    message?: string | undefined;
    error?: string | undefined;
    exception?: Exception | undefined;
}

export class Exception implements IException {
    message?: string;
    innerException?: Exception | undefined;
    source?: string | undefined;
    stackTrace?: string | undefined;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["Message"];
            this.innerException = _data["InnerException"] ? Exception.fromJS(_data["InnerException"]) : <any>undefined;
            this.source = _data["Source"];
            this.stackTrace = _data["StackTrace"];
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message;
        data["InnerException"] = this.innerException ? this.innerException.toJSON() : <any>undefined;
        data["Source"] = this.source;
        data["StackTrace"] = this.stackTrace;
        return data;
    }
}

export interface IException {
    message?: string;
    innerException?: Exception | undefined;
    source?: string | undefined;
    stackTrace?: string | undefined;
}

export class TypedResponseOfIEnumerableOfFacultyAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfFacultyAPIModel {
    value?: FacultyAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfFacultyAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(FacultyAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfFacultyAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfFacultyAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfFacultyAPIModel extends IDefaultResponse {
    value?: FacultyAPIModel[] | undefined;
}

export class CreateFacultyRequest implements ICreateFacultyRequest {
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICreateFacultyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateFacultyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFacultyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateFacultyRequest {
    name?: string | undefined;
    description?: string | undefined;
}

export class UpdateFacultyRequest implements IUpdateFacultyRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUpdateFacultyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateFacultyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFacultyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateFacultyRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class TypedResponseOfSchoolAPIModel extends DefaultResponse implements ITypedResponseOfSchoolAPIModel {
    value?: SchoolAPIModel | undefined;

    constructor(data?: ITypedResponseOfSchoolAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? SchoolAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfSchoolAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfSchoolAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfSchoolAPIModel extends IDefaultResponse {
    value?: SchoolAPIModel | undefined;
}

export class TypedResponseOfIEnumerableOfSchoolAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfSchoolAPIModel {
    value?: SchoolAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfSchoolAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(SchoolAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfSchoolAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfSchoolAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfSchoolAPIModel extends IDefaultResponse {
    value?: SchoolAPIModel[] | undefined;
}

export class CreateSchoolRequest implements ICreateSchoolRequest {
    name?: string | undefined;
    description?: string | undefined;
    facultyID?: string | undefined;

    constructor(data?: ICreateSchoolRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.facultyID = _data["facultyID"];
        }
    }

    static fromJS(data: any): CreateSchoolRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSchoolRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["facultyID"] = this.facultyID;
        return data;
    }
}

export interface ICreateSchoolRequest {
    name?: string | undefined;
    description?: string | undefined;
    facultyID?: string | undefined;
}

export class UpdateSchoolRequest implements IUpdateSchoolRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    facultyID?: string | undefined;

    constructor(data?: IUpdateSchoolRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.facultyID = _data["facultyID"];
        }
    }

    static fromJS(data: any): UpdateSchoolRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSchoolRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["facultyID"] = this.facultyID;
        return data;
    }
}

export interface IUpdateSchoolRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    facultyID?: string | undefined;
}

export class TypedResponseOfQualificationAPIModel extends DefaultResponse implements ITypedResponseOfQualificationAPIModel {
    value?: QualificationAPIModel | undefined;

    constructor(data?: ITypedResponseOfQualificationAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? QualificationAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfQualificationAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfQualificationAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfQualificationAPIModel extends IDefaultResponse {
    value?: QualificationAPIModel | undefined;
}

export class TypedResponseOfIEnumerableOfQualificationAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfQualificationAPIModel {
    value?: QualificationAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfQualificationAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(QualificationAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfQualificationAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfQualificationAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfQualificationAPIModel extends IDefaultResponse {
    value?: QualificationAPIModel[] | undefined;
}

export class CreateQualificationRequest implements ICreateQualificationRequest {
    name?: string | undefined;
    description?: string | undefined;
    schoolID?: string | undefined;

    constructor(data?: ICreateQualificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.schoolID = _data["schoolID"];
        }
    }

    static fromJS(data: any): CreateQualificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQualificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["schoolID"] = this.schoolID;
        return data;
    }
}

export interface ICreateQualificationRequest {
    name?: string | undefined;
    description?: string | undefined;
    schoolID?: string | undefined;
}

export class UpdateQualificationRequest implements IUpdateQualificationRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    schoolID?: string | undefined;

    constructor(data?: IUpdateQualificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.schoolID = _data["schoolID"];
        }
    }

    static fromJS(data: any): UpdateQualificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQualificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["schoolID"] = this.schoolID;
        return data;
    }
}

export interface IUpdateQualificationRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    schoolID?: string | undefined;
}

export class TypedResponseOfQualificationLevelAPIModel extends DefaultResponse implements ITypedResponseOfQualificationLevelAPIModel {
    value?: QualificationLevelAPIModel | undefined;

    constructor(data?: ITypedResponseOfQualificationLevelAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? QualificationLevelAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfQualificationLevelAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfQualificationLevelAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfQualificationLevelAPIModel extends IDefaultResponse {
    value?: QualificationLevelAPIModel | undefined;
}

export class QualificationLevelAPIModel implements IQualificationLevelAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    organizationID?: string | undefined;
    qualificationPrograms?: QualificationProgramLevelAPIModel[] | undefined;

    constructor(data?: IQualificationLevelAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.sourceID = _data["sourceID"];
            this.organizationID = _data["organizationID"];
            if (Array.isArray(_data["qualificationPrograms"])) {
                this.qualificationPrograms = [] as any;
                for (let item of _data["qualificationPrograms"])
                    this.qualificationPrograms!.push(QualificationProgramLevelAPIModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QualificationLevelAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationLevelAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["source"] = this.source;
        data["sourceID"] = this.sourceID;
        data["organizationID"] = this.organizationID;
        if (Array.isArray(this.qualificationPrograms)) {
            data["qualificationPrograms"] = [];
            for (let item of this.qualificationPrograms)
                data["qualificationPrograms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQualificationLevelAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    organizationID?: string | undefined;
    qualificationPrograms?: QualificationProgramLevelAPIModel[] | undefined;
}

export class QualificationProgramLevelAPIModel implements IQualificationProgramLevelAPIModel {
    id?: string | undefined;
    qualificationLevelID?: string | undefined;
    qualificationLevel?: QualificationLevelAPIModel | undefined;
    qualificationID?: string | undefined;
    qualification?: QualificationAPIModel | undefined;
    academicProgramID?: string | undefined;
    academicProgram?: AcademicProgramAPIModel | undefined;
    academicYearID?: string | undefined;
    academicYear?: AcademicYearAPIModel | undefined;
    organizationID?: string | undefined;
    modules?: QualificationModuleAPIModel[] | undefined;

    constructor(data?: IQualificationProgramLevelAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationLevelID = _data["qualificationLevelID"];
            this.qualificationLevel = _data["qualificationLevel"] ? QualificationLevelAPIModel.fromJS(_data["qualificationLevel"]) : <any>undefined;
            this.qualificationID = _data["qualificationID"];
            this.qualification = _data["qualification"] ? QualificationAPIModel.fromJS(_data["qualification"]) : <any>undefined;
            this.academicProgramID = _data["academicProgramID"];
            this.academicProgram = _data["academicProgram"] ? AcademicProgramAPIModel.fromJS(_data["academicProgram"]) : <any>undefined;
            this.academicYearID = _data["academicYearID"];
            this.academicYear = _data["academicYear"] ? AcademicYearAPIModel.fromJS(_data["academicYear"]) : <any>undefined;
            this.organizationID = _data["organizationID"];
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(QualificationModuleAPIModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QualificationProgramLevelAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationProgramLevelAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationLevelID"] = this.qualificationLevelID;
        data["qualificationLevel"] = this.qualificationLevel ? this.qualificationLevel.toJSON() : <any>undefined;
        data["qualificationID"] = this.qualificationID;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["academicProgramID"] = this.academicProgramID;
        data["academicProgram"] = this.academicProgram ? this.academicProgram.toJSON() : <any>undefined;
        data["academicYearID"] = this.academicYearID;
        data["academicYear"] = this.academicYear ? this.academicYear.toJSON() : <any>undefined;
        data["organizationID"] = this.organizationID;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQualificationProgramLevelAPIModel {
    id?: string | undefined;
    qualificationLevelID?: string | undefined;
    qualificationLevel?: QualificationLevelAPIModel | undefined;
    qualificationID?: string | undefined;
    qualification?: QualificationAPIModel | undefined;
    academicProgramID?: string | undefined;
    academicProgram?: AcademicProgramAPIModel | undefined;
    academicYearID?: string | undefined;
    academicYear?: AcademicYearAPIModel | undefined;
    organizationID?: string | undefined;
    modules?: QualificationModuleAPIModel[] | undefined;
}

export class AcademicProgramAPIModel implements IAcademicProgramAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    organizationID?: string | undefined;

    constructor(data?: IAcademicProgramAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): AcademicProgramAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicProgramAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IAcademicProgramAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    organizationID?: string | undefined;
}

export class AcademicYearAPIModel implements IAcademicYearAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    assessmentCycles?: AssessmentCycleAPIModel[] | undefined;
    organizationID?: string | undefined;

    constructor(data?: IAcademicYearAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["assessmentCycles"])) {
                this.assessmentCycles = [] as any;
                for (let item of _data["assessmentCycles"])
                    this.assessmentCycles!.push(AssessmentCycleAPIModel.fromJS(item));
            }
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): AcademicYearAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicYearAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.assessmentCycles)) {
            data["assessmentCycles"] = [];
            for (let item of this.assessmentCycles)
                data["assessmentCycles"].push(item.toJSON());
        }
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IAcademicYearAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    assessmentCycles?: AssessmentCycleAPIModel[] | undefined;
    organizationID?: string | undefined;
}

export class AssessmentCycleAPIModel implements IAssessmentCycleAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    rank?: number;
    academicYearID?: string | undefined;
    academicYear?: AcademicYearAPIModel | undefined;
    organizationID?: string | undefined;

    constructor(data?: IAssessmentCycleAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.rank = _data["rank"];
            this.academicYearID = _data["academicYearID"];
            this.academicYear = _data["academicYear"] ? AcademicYearAPIModel.fromJS(_data["academicYear"]) : <any>undefined;
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): AssessmentCycleAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentCycleAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["rank"] = this.rank;
        data["academicYearID"] = this.academicYearID;
        data["academicYear"] = this.academicYear ? this.academicYear.toJSON() : <any>undefined;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IAssessmentCycleAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    rank?: number;
    academicYearID?: string | undefined;
    academicYear?: AcademicYearAPIModel | undefined;
    organizationID?: string | undefined;
}

export class QualificationModuleAPIModel implements IQualificationModuleAPIModel {
    id?: string | undefined;
    qualificationProgramLevelID?: string | undefined;
    qualificationProgramLevel?: QualificationProgramLevelAPIModel | undefined;
    moduleID?: string | undefined;
    module?: ModuleAPIModel | undefined;
    assessmentCycleID?: string | undefined;
    assessmentCycle?: AssessmentCycleAPIModel | undefined;
    organizationID?: string | undefined;

    constructor(data?: IQualificationModuleAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationProgramLevelID = _data["qualificationProgramLevelID"];
            this.qualificationProgramLevel = _data["qualificationProgramLevel"] ? QualificationProgramLevelAPIModel.fromJS(_data["qualificationProgramLevel"]) : <any>undefined;
            this.moduleID = _data["moduleID"];
            this.module = _data["module"] ? ModuleAPIModel.fromJS(_data["module"]) : <any>undefined;
            this.assessmentCycleID = _data["assessmentCycleID"];
            this.assessmentCycle = _data["assessmentCycle"] ? AssessmentCycleAPIModel.fromJS(_data["assessmentCycle"]) : <any>undefined;
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): QualificationModuleAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationModuleAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationProgramLevelID"] = this.qualificationProgramLevelID;
        data["qualificationProgramLevel"] = this.qualificationProgramLevel ? this.qualificationProgramLevel.toJSON() : <any>undefined;
        data["moduleID"] = this.moduleID;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["assessmentCycleID"] = this.assessmentCycleID;
        data["assessmentCycle"] = this.assessmentCycle ? this.assessmentCycle.toJSON() : <any>undefined;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IQualificationModuleAPIModel {
    id?: string | undefined;
    qualificationProgramLevelID?: string | undefined;
    qualificationProgramLevel?: QualificationProgramLevelAPIModel | undefined;
    moduleID?: string | undefined;
    module?: ModuleAPIModel | undefined;
    assessmentCycleID?: string | undefined;
    assessmentCycle?: AssessmentCycleAPIModel | undefined;
    organizationID?: string | undefined;
}

export class ModuleAPIModel implements IModuleAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    credits?: number | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    qualificationID?: string | undefined;
    qualification?: QualificationAPIModel | undefined;
    organizationID?: string | undefined;

    constructor(data?: IModuleAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.credits = _data["credits"];
            this.source = _data["source"];
            this.sourceID = _data["sourceID"];
            this.qualificationID = _data["qualificationID"];
            this.qualification = _data["qualification"] ? QualificationAPIModel.fromJS(_data["qualification"]) : <any>undefined;
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): ModuleAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["credits"] = this.credits;
        data["source"] = this.source;
        data["sourceID"] = this.sourceID;
        data["qualificationID"] = this.qualificationID;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IModuleAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    credits?: number | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    qualificationID?: string | undefined;
    qualification?: QualificationAPIModel | undefined;
    organizationID?: string | undefined;
}

export class TypedResponseOfIEnumerableOfQualificationLevelAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfQualificationLevelAPIModel {
    value?: QualificationLevelAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfQualificationLevelAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(QualificationLevelAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfQualificationLevelAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfQualificationLevelAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfQualificationLevelAPIModel extends IDefaultResponse {
    value?: QualificationLevelAPIModel[] | undefined;
}

export class CreateQualificationLevelRequest implements ICreateQualificationLevelRequest {
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICreateQualificationLevelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateQualificationLevelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQualificationLevelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateQualificationLevelRequest {
    name?: string | undefined;
    description?: string | undefined;
}

export class UpdateQualificationLevelRequest implements IUpdateQualificationLevelRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUpdateQualificationLevelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateQualificationLevelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQualificationLevelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateQualificationLevelRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class TypedResponseOfModuleAPIModel extends DefaultResponse implements ITypedResponseOfModuleAPIModel {
    value?: ModuleAPIModel | undefined;

    constructor(data?: ITypedResponseOfModuleAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ModuleAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfModuleAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfModuleAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfModuleAPIModel extends IDefaultResponse {
    value?: ModuleAPIModel | undefined;
}

export class TypedResponseOfIEnumerableOfModuleAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfModuleAPIModel {
    value?: ModuleAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfModuleAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ModuleAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfModuleAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfModuleAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfModuleAPIModel extends IDefaultResponse {
    value?: ModuleAPIModel[] | undefined;
}

export class CreateModuleRequest implements ICreateModuleRequest {
    name?: string | undefined;
    description?: string | undefined;
    credits?: number | undefined;
    qualificationID?: string | undefined;

    constructor(data?: ICreateModuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.credits = _data["credits"];
            this.qualificationID = _data["qualificationID"];
        }
    }

    static fromJS(data: any): CreateModuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateModuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["credits"] = this.credits;
        data["qualificationID"] = this.qualificationID;
        return data;
    }
}

export interface ICreateModuleRequest {
    name?: string | undefined;
    description?: string | undefined;
    credits?: number | undefined;
    qualificationID?: string | undefined;
}

export class UpdateModuleRequest implements IUpdateModuleRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    credits?: number | undefined;
    qualificationID?: string | undefined;

    constructor(data?: IUpdateModuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.credits = _data["credits"];
            this.qualificationID = _data["qualificationID"];
        }
    }

    static fromJS(data: any): UpdateModuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateModuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["credits"] = this.credits;
        data["qualificationID"] = this.qualificationID;
        return data;
    }
}

export interface IUpdateModuleRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    credits?: number | undefined;
    qualificationID?: string | undefined;
}

export class ReportTemplateModel implements IReportTemplateModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    bodyHtml?: string | undefined;
    styles?: string | undefined;
    paperSize?: string | undefined;
    landscape?: boolean;
    isArchived?: boolean;
    updatedAt?: Date;

    constructor(data?: IReportTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.bodyHtml = _data["bodyHtml"];
            this.styles = _data["styles"];
            this.paperSize = _data["paperSize"];
            this.landscape = _data["landscape"];
            this.isArchived = _data["isArchived"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["bodyHtml"] = this.bodyHtml;
        data["styles"] = this.styles;
        data["paperSize"] = this.paperSize;
        data["landscape"] = this.landscape;
        data["isArchived"] = this.isArchived;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReportTemplateModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    bodyHtml?: string | undefined;
    styles?: string | undefined;
    paperSize?: string | undefined;
    landscape?: boolean;
    isArchived?: boolean;
    updatedAt?: Date;
}

export class ReportTemplateWriteModel implements IReportTemplateWriteModel {
    name?: string | undefined;
    description?: string | undefined;
    bodyHtml?: string | undefined;
    styles?: string | undefined;
    paperSize?: string | undefined;
    landscape?: boolean;

    constructor(data?: IReportTemplateWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.bodyHtml = _data["bodyHtml"];
            this.styles = _data["styles"];
            this.paperSize = _data["paperSize"];
            this.landscape = _data["landscape"];
        }
    }

    static fromJS(data: any): ReportTemplateWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTemplateWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["bodyHtml"] = this.bodyHtml;
        data["styles"] = this.styles;
        data["paperSize"] = this.paperSize;
        data["landscape"] = this.landscape;
        return data;
    }
}

export interface IReportTemplateWriteModel {
    name?: string | undefined;
    description?: string | undefined;
    bodyHtml?: string | undefined;
    styles?: string | undefined;
    paperSize?: string | undefined;
    landscape?: boolean;
}

export class ReportDataSet implements IReportDataSet {
    qualificationModuleID?: string | undefined;
    moduleName?: string | undefined;
    cycleName?: string | undefined;
    generatedAt?: Date;
    students?: ReportStudentSection[] | undefined;

    constructor(data?: IReportDataSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.moduleName = _data["moduleName"];
            this.cycleName = _data["cycleName"];
            this.generatedAt = _data["generatedAt"] ? new Date(_data["generatedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["students"])) {
                this.students = [] as any;
                for (let item of _data["students"])
                    this.students!.push(ReportStudentSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportDataSet {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDataSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["moduleName"] = this.moduleName;
        data["cycleName"] = this.cycleName;
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.students)) {
            data["students"] = [];
            for (let item of this.students)
                data["students"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportDataSet {
    qualificationModuleID?: string | undefined;
    moduleName?: string | undefined;
    cycleName?: string | undefined;
    generatedAt?: Date;
    students?: ReportStudentSection[] | undefined;
}

export class ReportStudentSection implements IReportStudentSection {
    studentID?: string | undefined;
    studentName?: string | undefined;
    results?: ReportResultRow[] | undefined;

    constructor(data?: IReportStudentSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            this.studentName = _data["studentName"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ReportResultRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportStudentSection {
        data = typeof data === 'object' ? data : {};
        let result = new ReportStudentSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        data["studentName"] = this.studentName;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportStudentSection {
    studentID?: string | undefined;
    studentName?: string | undefined;
    results?: ReportResultRow[] | undefined;
}

export class ReportResultRow implements IReportResultRow {
    entityType?: string | undefined;
    entityID?: string | undefined;
    entityName?: string | undefined;
    markTypeID?: string | undefined;
    markTypeName?: string | undefined;
    result?: number;
    total?: number;
    gradeCode?: string | undefined;
    gradeName?: string | undefined;
    resultOrigin?: string | undefined;
    finalizationStatus?: string | undefined;
    moderationStatus?: string | undefined;

    constructor(data?: IReportResultRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.entityID = _data["entityID"];
            this.entityName = _data["entityName"];
            this.markTypeID = _data["markTypeID"];
            this.markTypeName = _data["markTypeName"];
            this.result = _data["result"];
            this.total = _data["total"];
            this.gradeCode = _data["gradeCode"];
            this.gradeName = _data["gradeName"];
            this.resultOrigin = _data["resultOrigin"];
            this.finalizationStatus = _data["finalizationStatus"];
            this.moderationStatus = _data["moderationStatus"];
        }
    }

    static fromJS(data: any): ReportResultRow {
        data = typeof data === 'object' ? data : {};
        let result = new ReportResultRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["entityID"] = this.entityID;
        data["entityName"] = this.entityName;
        data["markTypeID"] = this.markTypeID;
        data["markTypeName"] = this.markTypeName;
        data["result"] = this.result;
        data["total"] = this.total;
        data["gradeCode"] = this.gradeCode;
        data["gradeName"] = this.gradeName;
        data["resultOrigin"] = this.resultOrigin;
        data["finalizationStatus"] = this.finalizationStatus;
        data["moderationStatus"] = this.moderationStatus;
        return data;
    }
}

export interface IReportResultRow {
    entityType?: string | undefined;
    entityID?: string | undefined;
    entityName?: string | undefined;
    markTypeID?: string | undefined;
    markTypeName?: string | undefined;
    result?: number;
    total?: number;
    gradeCode?: string | undefined;
    gradeName?: string | undefined;
    resultOrigin?: string | undefined;
    finalizationStatus?: string | undefined;
    moderationStatus?: string | undefined;
}

export class ReportRenderRequest implements IReportRenderRequest {
    templateID?: string | undefined;
    qualificationModuleID?: string | undefined;
    studentIDs?: string[] | undefined;
    teachingGroupID?: string | undefined;
    finalizedOnly?: boolean;

    constructor(data?: IReportRenderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateID = _data["templateID"];
            this.qualificationModuleID = _data["qualificationModuleID"];
            if (Array.isArray(_data["studentIDs"])) {
                this.studentIDs = [] as any;
                for (let item of _data["studentIDs"])
                    this.studentIDs!.push(item);
            }
            this.teachingGroupID = _data["teachingGroupID"];
            this.finalizedOnly = _data["finalizedOnly"];
        }
    }

    static fromJS(data: any): ReportRenderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRenderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateID"] = this.templateID;
        data["qualificationModuleID"] = this.qualificationModuleID;
        if (Array.isArray(this.studentIDs)) {
            data["studentIDs"] = [];
            for (let item of this.studentIDs)
                data["studentIDs"].push(item);
        }
        data["teachingGroupID"] = this.teachingGroupID;
        data["finalizedOnly"] = this.finalizedOnly;
        return data;
    }
}

export interface IReportRenderRequest {
    templateID?: string | undefined;
    qualificationModuleID?: string | undefined;
    studentIDs?: string[] | undefined;
    teachingGroupID?: string | undefined;
    finalizedOnly?: boolean;
}

export class CalculationFindingPageModel implements ICalculationFindingPageModel {
    page?: number;
    pageSize?: number;
    totalCount?: number;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: ICalculationFindingPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationFindingPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationFindingPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalculationFindingPageModel {
    page?: number;
    pageSize?: number;
    totalCount?: number;
    findings?: CalculationFinding[] | undefined;
}

export class CalculationFinding implements ICalculationFinding {
    code?: string | undefined;
    severity?: CalculationFindingSeverity;
    message?: string | undefined;
    ruleID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    assignmentID?: string | undefined;
    qualificationModuleID?: string | undefined;
    studentID?: string | undefined;
    procedureVersionID?: string | undefined;
    markResultID?: string | undefined;
    parameters?: { [key: string]: any; } | undefined;

    constructor(data?: ICalculationFinding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.severity = _data["severity"];
            this.message = _data["message"];
            this.ruleID = _data["ruleID"];
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.assignmentID = _data["assignmentID"];
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.studentID = _data["studentID"];
            this.procedureVersionID = _data["procedureVersionID"];
            this.markResultID = _data["markResultID"];
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
        }
    }

    static fromJS(data: any): CalculationFinding {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationFinding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["severity"] = this.severity;
        data["message"] = this.message;
        data["ruleID"] = this.ruleID;
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["assignmentID"] = this.assignmentID;
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["studentID"] = this.studentID;
        data["procedureVersionID"] = this.procedureVersionID;
        data["markResultID"] = this.markResultID;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        return data;
    }
}

export interface ICalculationFinding {
    code?: string | undefined;
    severity?: CalculationFindingSeverity;
    message?: string | undefined;
    ruleID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    assignmentID?: string | undefined;
    qualificationModuleID?: string | undefined;
    studentID?: string | undefined;
    procedureVersionID?: string | undefined;
    markResultID?: string | undefined;
    parameters?: { [key: string]: any; } | undefined;
}

export enum CalculationFindingSeverity {
    Information = 0,
    Warning = 1,
    Error = 2,
}

export class ProcedureLifecycleModel implements IProcedureLifecycleModel {
    procedure?: ProcedureModel | undefined;
    draft?: ProcedureVersionModel | undefined;

    constructor(data?: IProcedureLifecycleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.procedure = _data["procedure"] ? ProcedureModel.fromJS(_data["procedure"]) : <any>undefined;
            this.draft = _data["draft"] ? ProcedureVersionModel.fromJS(_data["draft"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcedureLifecycleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureLifecycleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["procedure"] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data["draft"] = this.draft ? this.draft.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProcedureLifecycleModel {
    procedure?: ProcedureModel | undefined;
    draft?: ProcedureVersionModel | undefined;
}

export class ProcedureModel implements IProcedureModel {
    id?: string | undefined;
    name?: string | undefined;
    isArchived?: boolean;

    constructor(data?: IProcedureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): ProcedureModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IProcedureModel {
    id?: string | undefined;
    name?: string | undefined;
    isArchived?: boolean;
}

export class ProcedureVersionModel implements IProcedureVersionModel {
    id?: string | undefined;
    status?: string | undefined;
    versionNumber?: number | undefined;
    targetMarkTypeID?: string | undefined;
    targetMarkType?: ResolvedReference | undefined;
    calculationMethod?: string | undefined;
    missingMarkPolicy?: string | undefined;
    gradeScaleID?: string | undefined;
    gradeScale?: ResolvedReference | undefined;
    targetSelectorKind?: string | undefined;
    targetPath?: ResolvedReference[] | undefined;
    rules?: ProcedureRuleModel[] | undefined;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: IProcedureVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.versionNumber = _data["versionNumber"];
            this.targetMarkTypeID = _data["targetMarkTypeID"];
            this.targetMarkType = _data["targetMarkType"] ? ResolvedReference.fromJS(_data["targetMarkType"]) : <any>undefined;
            this.calculationMethod = _data["calculationMethod"];
            this.missingMarkPolicy = _data["missingMarkPolicy"];
            this.gradeScaleID = _data["gradeScaleID"];
            this.gradeScale = _data["gradeScale"] ? ResolvedReference.fromJS(_data["gradeScale"]) : <any>undefined;
            this.targetSelectorKind = _data["targetSelectorKind"];
            if (Array.isArray(_data["targetPath"])) {
                this.targetPath = [] as any;
                for (let item of _data["targetPath"])
                    this.targetPath!.push(ResolvedReference.fromJS(item));
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(ProcedureRuleModel.fromJS(item));
            }
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcedureVersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureVersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["versionNumber"] = this.versionNumber;
        data["targetMarkTypeID"] = this.targetMarkTypeID;
        data["targetMarkType"] = this.targetMarkType ? this.targetMarkType.toJSON() : <any>undefined;
        data["calculationMethod"] = this.calculationMethod;
        data["missingMarkPolicy"] = this.missingMarkPolicy;
        data["gradeScaleID"] = this.gradeScaleID;
        data["gradeScale"] = this.gradeScale ? this.gradeScale.toJSON() : <any>undefined;
        data["targetSelectorKind"] = this.targetSelectorKind;
        if (Array.isArray(this.targetPath)) {
            data["targetPath"] = [];
            for (let item of this.targetPath)
                data["targetPath"].push(item.toJSON());
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProcedureVersionModel {
    id?: string | undefined;
    status?: string | undefined;
    versionNumber?: number | undefined;
    targetMarkTypeID?: string | undefined;
    targetMarkType?: ResolvedReference | undefined;
    calculationMethod?: string | undefined;
    missingMarkPolicy?: string | undefined;
    gradeScaleID?: string | undefined;
    gradeScale?: ResolvedReference | undefined;
    targetSelectorKind?: string | undefined;
    targetPath?: ResolvedReference[] | undefined;
    rules?: ProcedureRuleModel[] | undefined;
    findings?: CalculationFinding[] | undefined;
}

export class ResolvedReference implements IResolvedReference {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IResolvedReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ResolvedReference {
        data = typeof data === 'object' ? data : {};
        let result = new ResolvedReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IResolvedReference {
    id?: string | undefined;
    name?: string | undefined;
}

export class ProcedureRuleModel implements IProcedureRuleModel {
    id?: string | undefined;
    componentMarkTypeID?: string | undefined;
    componentMarkType?: ResolvedReference | undefined;
    weight?: number | undefined;
    sourceModuleSelectorKind?: string | undefined;
    sourceModule?: ResolvedReference | undefined;
    inputAnchor?: string | undefined;
    inputSelectorKind?: string | undefined;
    groupPath?: ResolvedReference[] | undefined;
    assessmentType?: ResolvedReference | undefined;
    assessmentGroupType?: ResolvedReference | undefined;
    concreteEntityType?: string | undefined;
    concreteEntityID?: string | undefined;

    constructor(data?: IProcedureRuleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.componentMarkTypeID = _data["componentMarkTypeID"];
            this.componentMarkType = _data["componentMarkType"] ? ResolvedReference.fromJS(_data["componentMarkType"]) : <any>undefined;
            this.weight = _data["weight"];
            this.sourceModuleSelectorKind = _data["sourceModuleSelectorKind"];
            this.sourceModule = _data["sourceModule"] ? ResolvedReference.fromJS(_data["sourceModule"]) : <any>undefined;
            this.inputAnchor = _data["inputAnchor"];
            this.inputSelectorKind = _data["inputSelectorKind"];
            if (Array.isArray(_data["groupPath"])) {
                this.groupPath = [] as any;
                for (let item of _data["groupPath"])
                    this.groupPath!.push(ResolvedReference.fromJS(item));
            }
            this.assessmentType = _data["assessmentType"] ? ResolvedReference.fromJS(_data["assessmentType"]) : <any>undefined;
            this.assessmentGroupType = _data["assessmentGroupType"] ? ResolvedReference.fromJS(_data["assessmentGroupType"]) : <any>undefined;
            this.concreteEntityType = _data["concreteEntityType"];
            this.concreteEntityID = _data["concreteEntityID"];
        }
    }

    static fromJS(data: any): ProcedureRuleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureRuleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["componentMarkTypeID"] = this.componentMarkTypeID;
        data["componentMarkType"] = this.componentMarkType ? this.componentMarkType.toJSON() : <any>undefined;
        data["weight"] = this.weight;
        data["sourceModuleSelectorKind"] = this.sourceModuleSelectorKind;
        data["sourceModule"] = this.sourceModule ? this.sourceModule.toJSON() : <any>undefined;
        data["inputAnchor"] = this.inputAnchor;
        data["inputSelectorKind"] = this.inputSelectorKind;
        if (Array.isArray(this.groupPath)) {
            data["groupPath"] = [];
            for (let item of this.groupPath)
                data["groupPath"].push(item.toJSON());
        }
        data["assessmentType"] = this.assessmentType ? this.assessmentType.toJSON() : <any>undefined;
        data["assessmentGroupType"] = this.assessmentGroupType ? this.assessmentGroupType.toJSON() : <any>undefined;
        data["concreteEntityType"] = this.concreteEntityType;
        data["concreteEntityID"] = this.concreteEntityID;
        return data;
    }
}

export interface IProcedureRuleModel {
    id?: string | undefined;
    componentMarkTypeID?: string | undefined;
    componentMarkType?: ResolvedReference | undefined;
    weight?: number | undefined;
    sourceModuleSelectorKind?: string | undefined;
    sourceModule?: ResolvedReference | undefined;
    inputAnchor?: string | undefined;
    inputSelectorKind?: string | undefined;
    groupPath?: ResolvedReference[] | undefined;
    assessmentType?: ResolvedReference | undefined;
    assessmentGroupType?: ResolvedReference | undefined;
    concreteEntityType?: string | undefined;
    concreteEntityID?: string | undefined;
}

export class CreateCalculationProcedureModel implements ICreateCalculationProcedureModel {
    name?: string | undefined;

    constructor(data?: ICreateCalculationProcedureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCalculationProcedureModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCalculationProcedureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateCalculationProcedureModel {
    name?: string | undefined;
}

export class RenameCalculationProcedureModel implements IRenameCalculationProcedureModel {
    name?: string | undefined;

    constructor(data?: IRenameCalculationProcedureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameCalculationProcedureModel {
        data = typeof data === 'object' ? data : {};
        let result = new RenameCalculationProcedureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IRenameCalculationProcedureModel {
    name?: string | undefined;
}

export class ProcedureVersionSummaryModel implements IProcedureVersionSummaryModel {
    id?: string | undefined;
    status?: string | undefined;
    versionNumber?: number | undefined;

    constructor(data?: IProcedureVersionSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): ProcedureVersionSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureVersionSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IProcedureVersionSummaryModel {
    id?: string | undefined;
    status?: string | undefined;
    versionNumber?: number | undefined;
}

export class ProcedureDraftWriteModel implements IProcedureDraftWriteModel {
    targetMarkTypeID?: string | undefined;
    calculationMethod?: string | undefined;
    missingMarkPolicy?: string | undefined;
    gradeScaleID?: string | undefined;
    targetSelector?: ProcedureTargetSelectorWriteModel | undefined;
    rules?: ProcedureRuleWriteModel[] | undefined;

    constructor(data?: IProcedureDraftWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetMarkTypeID = _data["targetMarkTypeID"];
            this.calculationMethod = _data["calculationMethod"];
            this.missingMarkPolicy = _data["missingMarkPolicy"];
            this.gradeScaleID = _data["gradeScaleID"];
            this.targetSelector = _data["targetSelector"] ? ProcedureTargetSelectorWriteModel.fromJS(_data["targetSelector"]) : <any>undefined;
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(ProcedureRuleWriteModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcedureDraftWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureDraftWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetMarkTypeID"] = this.targetMarkTypeID;
        data["calculationMethod"] = this.calculationMethod;
        data["missingMarkPolicy"] = this.missingMarkPolicy;
        data["gradeScaleID"] = this.gradeScaleID;
        data["targetSelector"] = this.targetSelector ? this.targetSelector.toJSON() : <any>undefined;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProcedureDraftWriteModel {
    targetMarkTypeID?: string | undefined;
    calculationMethod?: string | undefined;
    missingMarkPolicy?: string | undefined;
    gradeScaleID?: string | undefined;
    targetSelector?: ProcedureTargetSelectorWriteModel | undefined;
    rules?: ProcedureRuleWriteModel[] | undefined;
}

export class ProcedureTargetSelectorWriteModel implements IProcedureTargetSelectorWriteModel {
    kind?: string | undefined;
    path?: string[] | undefined;

    constructor(data?: IProcedureTargetSelectorWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcedureTargetSelectorWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureTargetSelectorWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item);
        }
        return data;
    }
}

export interface IProcedureTargetSelectorWriteModel {
    kind?: string | undefined;
    path?: string[] | undefined;
}

export class ProcedureRuleWriteModel implements IProcedureRuleWriteModel {
    id?: string | undefined;
    componentMarkTypeID?: string | undefined;
    weight?: number | undefined;
    sourceModuleSelector?: ProcedureSourceModuleSelectorWriteModel | undefined;
    inputSelector?: ProcedureInputSelectorWriteModel | undefined;

    constructor(data?: IProcedureRuleWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.componentMarkTypeID = _data["componentMarkTypeID"];
            this.weight = _data["weight"];
            this.sourceModuleSelector = _data["sourceModuleSelector"] ? ProcedureSourceModuleSelectorWriteModel.fromJS(_data["sourceModuleSelector"]) : <any>undefined;
            this.inputSelector = _data["inputSelector"] ? ProcedureInputSelectorWriteModel.fromJS(_data["inputSelector"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcedureRuleWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureRuleWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["componentMarkTypeID"] = this.componentMarkTypeID;
        data["weight"] = this.weight;
        data["sourceModuleSelector"] = this.sourceModuleSelector ? this.sourceModuleSelector.toJSON() : <any>undefined;
        data["inputSelector"] = this.inputSelector ? this.inputSelector.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProcedureRuleWriteModel {
    id?: string | undefined;
    componentMarkTypeID?: string | undefined;
    weight?: number | undefined;
    sourceModuleSelector?: ProcedureSourceModuleSelectorWriteModel | undefined;
    inputSelector?: ProcedureInputSelectorWriteModel | undefined;
}

export class ProcedureSourceModuleSelectorWriteModel implements IProcedureSourceModuleSelectorWriteModel {
    kind?: string | undefined;
    moduleID?: string | undefined;

    constructor(data?: IProcedureSourceModuleSelectorWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.moduleID = _data["moduleID"];
        }
    }

    static fromJS(data: any): ProcedureSourceModuleSelectorWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureSourceModuleSelectorWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["moduleID"] = this.moduleID;
        return data;
    }
}

export interface IProcedureSourceModuleSelectorWriteModel {
    kind?: string | undefined;
    moduleID?: string | undefined;
}

export class ProcedureInputSelectorWriteModel implements IProcedureInputSelectorWriteModel {
    anchor?: string | undefined;
    kind?: string | undefined;
    groupPath?: string[] | undefined;
    assessmentTypeID?: string | undefined;
    assessmentGroupTypeID?: string | undefined;
    concreteEntityType?: string | undefined;
    concreteEntityID?: string | undefined;

    constructor(data?: IProcedureInputSelectorWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anchor = _data["anchor"];
            this.kind = _data["kind"];
            if (Array.isArray(_data["groupPath"])) {
                this.groupPath = [] as any;
                for (let item of _data["groupPath"])
                    this.groupPath!.push(item);
            }
            this.assessmentTypeID = _data["assessmentTypeID"];
            this.assessmentGroupTypeID = _data["assessmentGroupTypeID"];
            this.concreteEntityType = _data["concreteEntityType"];
            this.concreteEntityID = _data["concreteEntityID"];
        }
    }

    static fromJS(data: any): ProcedureInputSelectorWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureInputSelectorWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anchor"] = this.anchor;
        data["kind"] = this.kind;
        if (Array.isArray(this.groupPath)) {
            data["groupPath"] = [];
            for (let item of this.groupPath)
                data["groupPath"].push(item);
        }
        data["assessmentTypeID"] = this.assessmentTypeID;
        data["assessmentGroupTypeID"] = this.assessmentGroupTypeID;
        data["concreteEntityType"] = this.concreteEntityType;
        data["concreteEntityID"] = this.concreteEntityID;
        return data;
    }
}

export interface IProcedureInputSelectorWriteModel {
    anchor?: string | undefined;
    kind?: string | undefined;
    groupPath?: string[] | undefined;
    assessmentTypeID?: string | undefined;
    assessmentGroupTypeID?: string | undefined;
    concreteEntityType?: string | undefined;
    concreteEntityID?: string | undefined;
}

export class ExactSelectorResolutionModel implements IExactSelectorResolutionModel {
    targets?: ResolvedTargetCandidate[] | undefined;
    inputs?: ResolvedInputCandidate[] | undefined;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: IExactSelectorResolutionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["targets"])) {
                this.targets = [] as any;
                for (let item of _data["targets"])
                    this.targets!.push(ResolvedTargetCandidate.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(ResolvedInputCandidate.fromJS(item));
            }
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExactSelectorResolutionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExactSelectorResolutionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.targets)) {
            data["targets"] = [];
            for (let item of this.targets)
                data["targets"].push(item.toJSON());
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExactSelectorResolutionModel {
    targets?: ResolvedTargetCandidate[] | undefined;
    inputs?: ResolvedInputCandidate[] | undefined;
    findings?: CalculationFinding[] | undefined;
}

export class ResolvedTargetCandidate implements IResolvedTargetCandidate {
    entityType?: string | undefined;
    entityID?: string | undefined;

    constructor(data?: IResolvedTargetCandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.entityID = _data["entityID"];
        }
    }

    static fromJS(data: any): ResolvedTargetCandidate {
        data = typeof data === 'object' ? data : {};
        let result = new ResolvedTargetCandidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["entityID"] = this.entityID;
        return data;
    }
}

export interface IResolvedTargetCandidate {
    entityType?: string | undefined;
    entityID?: string | undefined;
}

export class ResolvedInputCandidate implements IResolvedInputCandidate {
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    ruleID?: string | undefined;
    componentEntityType?: string | undefined;
    componentEntityID?: string | undefined;
    componentMarkTypeID?: string | undefined;

    constructor(data?: IResolvedInputCandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.ruleID = _data["ruleID"];
            this.componentEntityType = _data["componentEntityType"];
            this.componentEntityID = _data["componentEntityID"];
            this.componentMarkTypeID = _data["componentMarkTypeID"];
        }
    }

    static fromJS(data: any): ResolvedInputCandidate {
        data = typeof data === 'object' ? data : {};
        let result = new ResolvedInputCandidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["ruleID"] = this.ruleID;
        data["componentEntityType"] = this.componentEntityType;
        data["componentEntityID"] = this.componentEntityID;
        data["componentMarkTypeID"] = this.componentMarkTypeID;
        return data;
    }
}

export interface IResolvedInputCandidate {
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    ruleID?: string | undefined;
    componentEntityType?: string | undefined;
    componentEntityID?: string | undefined;
    componentMarkTypeID?: string | undefined;
}

export class ResolveExactSelectorsModel implements IResolveExactSelectorsModel {
    qualificationModuleID?: string | undefined;

    constructor(data?: IResolveExactSelectorsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
        }
    }

    static fromJS(data: any): ResolveExactSelectorsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveExactSelectorsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        return data;
    }
}

export interface IResolveExactSelectorsModel {
    qualificationModuleID?: string | undefined;
}

export class CalculationRunSummaryModel implements ICalculationRunSummaryModel {
    assignmentsProcessed?: number;
    studentsProcessed?: number;
    createdResults?: number;
    updatedResults?: number;
    deletedResults?: number;
    unchangedResults?: number;
    skippedManualResults?: number;
    skippedFinalizedResults?: number;
    succeeded?: boolean;
    saved?: boolean;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: ICalculationRunSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentsProcessed = _data["assignmentsProcessed"];
            this.studentsProcessed = _data["studentsProcessed"];
            this.createdResults = _data["createdResults"];
            this.updatedResults = _data["updatedResults"];
            this.deletedResults = _data["deletedResults"];
            this.unchangedResults = _data["unchangedResults"];
            this.skippedManualResults = _data["skippedManualResults"];
            this.skippedFinalizedResults = _data["skippedFinalizedResults"];
            this.succeeded = _data["succeeded"];
            this.saved = _data["saved"];
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationRunSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationRunSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignmentsProcessed"] = this.assignmentsProcessed;
        data["studentsProcessed"] = this.studentsProcessed;
        data["createdResults"] = this.createdResults;
        data["updatedResults"] = this.updatedResults;
        data["deletedResults"] = this.deletedResults;
        data["unchangedResults"] = this.unchangedResults;
        data["skippedManualResults"] = this.skippedManualResults;
        data["skippedFinalizedResults"] = this.skippedFinalizedResults;
        data["succeeded"] = this.succeeded;
        data["saved"] = this.saved;
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalculationRunSummaryModel {
    assignmentsProcessed?: number;
    studentsProcessed?: number;
    createdResults?: number;
    updatedResults?: number;
    deletedResults?: number;
    unchangedResults?: number;
    skippedManualResults?: number;
    skippedFinalizedResults?: number;
    succeeded?: boolean;
    saved?: boolean;
    findings?: CalculationFinding[] | undefined;
}

export class ScopedCalculationRequest implements IScopedCalculationRequest {
    scopes?: CalculationScopeModel[] | undefined;
    options?: CalculationRunOptionsModel | undefined;

    constructor(data?: IScopedCalculationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(CalculationScopeModel.fromJS(item));
            }
            this.options = _data["options"] ? CalculationRunOptionsModel.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScopedCalculationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScopedCalculationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item.toJSON());
        }
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScopedCalculationRequest {
    scopes?: CalculationScopeModel[] | undefined;
    options?: CalculationRunOptionsModel | undefined;
}

export class CalculationScopeModel implements ICalculationScopeModel {
    kind?: string | undefined;
    iDs?: string[] | undefined;
    includeDescendants?: boolean;
    qualificationProgramLevelID?: string | undefined;
    assessmentCycleID?: string | undefined;

    constructor(data?: ICalculationScopeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            if (Array.isArray(_data["iDs"])) {
                this.iDs = [] as any;
                for (let item of _data["iDs"])
                    this.iDs!.push(item);
            }
            this.includeDescendants = _data["includeDescendants"];
            this.qualificationProgramLevelID = _data["qualificationProgramLevelID"];
            this.assessmentCycleID = _data["assessmentCycleID"];
        }
    }

    static fromJS(data: any): CalculationScopeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationScopeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        if (Array.isArray(this.iDs)) {
            data["iDs"] = [];
            for (let item of this.iDs)
                data["iDs"].push(item);
        }
        data["includeDescendants"] = this.includeDescendants;
        data["qualificationProgramLevelID"] = this.qualificationProgramLevelID;
        data["assessmentCycleID"] = this.assessmentCycleID;
        return data;
    }
}

export interface ICalculationScopeModel {
    kind?: string | undefined;
    iDs?: string[] | undefined;
    includeDescendants?: boolean;
    qualificationProgramLevelID?: string | undefined;
    assessmentCycleID?: string | undefined;
}

export class CalculationRunOptionsModel implements ICalculationRunOptionsModel {
    saveResults?: boolean | undefined;
    overrideManualMarks?: boolean | undefined;

    constructor(data?: ICalculationRunOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saveResults = _data["saveResults"];
            this.overrideManualMarks = _data["overrideManualMarks"];
        }
    }

    static fromJS(data: any): CalculationRunOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationRunOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saveResults"] = this.saveResults;
        data["overrideManualMarks"] = this.overrideManualMarks;
        return data;
    }
}

export interface ICalculationRunOptionsModel {
    saveResults?: boolean | undefined;
    overrideManualMarks?: boolean | undefined;
}

export class CalculationPreviewPageModel implements ICalculationPreviewPageModel {
    page?: number;
    pageSize?: number;
    totalCount?: number;
    rows?: CalculationPreviewRowModel[] | undefined;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: ICalculationPreviewPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CalculationPreviewRowModel.fromJS(item));
            }
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationPreviewPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationPreviewPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalculationPreviewPageModel {
    page?: number;
    pageSize?: number;
    totalCount?: number;
    rows?: CalculationPreviewRowModel[] | undefined;
    findings?: CalculationFinding[] | undefined;
}

export class CalculationPreviewRowModel implements ICalculationPreviewRowModel {
    assignmentID?: string | undefined;
    studentID?: string | undefined;
    studentName?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    targetName?: string | undefined;
    markTypeID?: string | undefined;
    markTypeName?: string | undefined;
    currentResult?: number | undefined;
    currentTotal?: number | undefined;
    currentOrigin?: string | undefined;
    finalizationStatus?: string | undefined;
    proposedResult?: number | undefined;
    proposedTotal?: number | undefined;
    action?: string | undefined;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: ICalculationPreviewRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentID = _data["assignmentID"];
            this.studentID = _data["studentID"];
            this.studentName = _data["studentName"];
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.targetName = _data["targetName"];
            this.markTypeID = _data["markTypeID"];
            this.markTypeName = _data["markTypeName"];
            this.currentResult = _data["currentResult"];
            this.currentTotal = _data["currentTotal"];
            this.currentOrigin = _data["currentOrigin"];
            this.finalizationStatus = _data["finalizationStatus"];
            this.proposedResult = _data["proposedResult"];
            this.proposedTotal = _data["proposedTotal"];
            this.action = _data["action"];
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationPreviewRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationPreviewRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignmentID"] = this.assignmentID;
        data["studentID"] = this.studentID;
        data["studentName"] = this.studentName;
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["targetName"] = this.targetName;
        data["markTypeID"] = this.markTypeID;
        data["markTypeName"] = this.markTypeName;
        data["currentResult"] = this.currentResult;
        data["currentTotal"] = this.currentTotal;
        data["currentOrigin"] = this.currentOrigin;
        data["finalizationStatus"] = this.finalizationStatus;
        data["proposedResult"] = this.proposedResult;
        data["proposedTotal"] = this.proposedTotal;
        data["action"] = this.action;
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalculationPreviewRowModel {
    assignmentID?: string | undefined;
    studentID?: string | undefined;
    studentName?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    targetName?: string | undefined;
    markTypeID?: string | undefined;
    markTypeName?: string | undefined;
    currentResult?: number | undefined;
    currentTotal?: number | undefined;
    currentOrigin?: string | undefined;
    finalizationStatus?: string | undefined;
    proposedResult?: number | undefined;
    proposedTotal?: number | undefined;
    action?: string | undefined;
    findings?: CalculationFinding[] | undefined;
}

export class CalculationPreviewPageRequest extends ScopedCalculationRequest implements ICalculationPreviewPageRequest {
    page?: number;
    pageSize?: number;

    constructor(data?: ICalculationPreviewPageRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static override fromJS(data: any): CalculationPreviewPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationPreviewPageRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface ICalculationPreviewPageRequest extends IScopedCalculationRequest {
    page?: number;
    pageSize?: number;
}

export class ProcedureAssignmentListItemModel implements IProcedureAssignmentListItemModel {
    id?: string | undefined;
    qualificationModuleID?: string | undefined;
    qualificationModuleName?: string | undefined;
    procedureID?: string | undefined;
    procedureName?: string | undefined;
    procedureVersionID?: string | undefined;
    versionNumber?: number | undefined;
    isActive?: boolean;
    generatedEdges?: number;

    constructor(data?: IProcedureAssignmentListItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.qualificationModuleName = _data["qualificationModuleName"];
            this.procedureID = _data["procedureID"];
            this.procedureName = _data["procedureName"];
            this.procedureVersionID = _data["procedureVersionID"];
            this.versionNumber = _data["versionNumber"];
            this.isActive = _data["isActive"];
            this.generatedEdges = _data["generatedEdges"];
        }
    }

    static fromJS(data: any): ProcedureAssignmentListItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureAssignmentListItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["qualificationModuleName"] = this.qualificationModuleName;
        data["procedureID"] = this.procedureID;
        data["procedureName"] = this.procedureName;
        data["procedureVersionID"] = this.procedureVersionID;
        data["versionNumber"] = this.versionNumber;
        data["isActive"] = this.isActive;
        data["generatedEdges"] = this.generatedEdges;
        return data;
    }
}

export interface IProcedureAssignmentListItemModel {
    id?: string | undefined;
    qualificationModuleID?: string | undefined;
    qualificationModuleName?: string | undefined;
    procedureID?: string | undefined;
    procedureName?: string | undefined;
    procedureVersionID?: string | undefined;
    versionNumber?: number | undefined;
    isActive?: boolean;
    generatedEdges?: number;
}

export class AssignmentGenerationModel implements IAssignmentGenerationModel {
    assignment?: ProcedureAssignmentModel | undefined;
    generatedEdges?: number;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: IAssignmentGenerationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignment = _data["assignment"] ? ProcedureAssignmentModel.fromJS(_data["assignment"]) : <any>undefined;
            this.generatedEdges = _data["generatedEdges"];
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignmentGenerationModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentGenerationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignment"] = this.assignment ? this.assignment.toJSON() : <any>undefined;
        data["generatedEdges"] = this.generatedEdges;
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssignmentGenerationModel {
    assignment?: ProcedureAssignmentModel | undefined;
    generatedEdges?: number;
    findings?: CalculationFinding[] | undefined;
}

export class ProcedureAssignmentModel implements IProcedureAssignmentModel {
    id?: string | undefined;
    qualificationModuleID?: string | undefined;
    procedureVersionID?: string | undefined;
    isActive?: boolean;

    constructor(data?: IProcedureAssignmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.procedureVersionID = _data["procedureVersionID"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProcedureAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureAssignmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["procedureVersionID"] = this.procedureVersionID;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IProcedureAssignmentModel {
    id?: string | undefined;
    qualificationModuleID?: string | undefined;
    procedureVersionID?: string | undefined;
    isActive?: boolean;
}

export class CreateProcedureAssignmentModel implements ICreateProcedureAssignmentModel {
    qualificationModuleID?: string | undefined;
    procedureVersionID?: string | undefined;

    constructor(data?: ICreateProcedureAssignmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.procedureVersionID = _data["procedureVersionID"];
        }
    }

    static fromJS(data: any): CreateProcedureAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcedureAssignmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["procedureVersionID"] = this.procedureVersionID;
        return data;
    }
}

export interface ICreateProcedureAssignmentModel {
    qualificationModuleID?: string | undefined;
    procedureVersionID?: string | undefined;
}

export class UpgradeProcedureAssignmentModel implements IUpgradeProcedureAssignmentModel {
    procedureVersionID?: string | undefined;

    constructor(data?: IUpgradeProcedureAssignmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.procedureVersionID = _data["procedureVersionID"];
        }
    }

    static fromJS(data: any): UpgradeProcedureAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpgradeProcedureAssignmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["procedureVersionID"] = this.procedureVersionID;
        return data;
    }
}

export interface IUpgradeProcedureAssignmentModel {
    procedureVersionID?: string | undefined;
}

export class CalculationPreviewModel implements ICalculationPreviewModel {
    assignment?: ProcedureAssignmentModel | undefined;
    outcomes?: CalculationPreviewOutcomeModel[] | undefined;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: ICalculationPreviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignment = _data["assignment"] ? ProcedureAssignmentModel.fromJS(_data["assignment"]) : <any>undefined;
            if (Array.isArray(_data["outcomes"])) {
                this.outcomes = [] as any;
                for (let item of _data["outcomes"])
                    this.outcomes!.push(CalculationPreviewOutcomeModel.fromJS(item));
            }
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationPreviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationPreviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignment"] = this.assignment ? this.assignment.toJSON() : <any>undefined;
        if (Array.isArray(this.outcomes)) {
            data["outcomes"] = [];
            for (let item of this.outcomes)
                data["outcomes"].push(item.toJSON());
        }
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalculationPreviewModel {
    assignment?: ProcedureAssignmentModel | undefined;
    outcomes?: CalculationPreviewOutcomeModel[] | undefined;
    findings?: CalculationFinding[] | undefined;
}

export class CalculationPreviewOutcomeModel implements ICalculationPreviewOutcomeModel {
    studentID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    targetMarkTypeID?: string | undefined;
    result?: number;
    total?: number;
    inputs?: CalculationPreviewInputModel[] | undefined;

    constructor(data?: ICalculationPreviewOutcomeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.targetMarkTypeID = _data["targetMarkTypeID"];
            this.result = _data["result"];
            this.total = _data["total"];
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(CalculationPreviewInputModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationPreviewOutcomeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationPreviewOutcomeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["targetMarkTypeID"] = this.targetMarkTypeID;
        data["result"] = this.result;
        data["total"] = this.total;
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalculationPreviewOutcomeModel {
    studentID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    targetMarkTypeID?: string | undefined;
    result?: number;
    total?: number;
    inputs?: CalculationPreviewInputModel[] | undefined;
}

export class CalculationPreviewInputModel implements ICalculationPreviewInputModel {
    ruleID?: string | undefined;
    entityType?: string | undefined;
    entityID?: string | undefined;
    markTypeID?: string | undefined;
    result?: number | undefined;
    effectiveTotal?: number | undefined;
    weight?: number;
    included?: boolean;
    finalizationStatus?: string | undefined;

    constructor(data?: ICalculationPreviewInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleID = _data["ruleID"];
            this.entityType = _data["entityType"];
            this.entityID = _data["entityID"];
            this.markTypeID = _data["markTypeID"];
            this.result = _data["result"];
            this.effectiveTotal = _data["effectiveTotal"];
            this.weight = _data["weight"];
            this.included = _data["included"];
            this.finalizationStatus = _data["finalizationStatus"];
        }
    }

    static fromJS(data: any): CalculationPreviewInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationPreviewInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleID"] = this.ruleID;
        data["entityType"] = this.entityType;
        data["entityID"] = this.entityID;
        data["markTypeID"] = this.markTypeID;
        data["result"] = this.result;
        data["effectiveTotal"] = this.effectiveTotal;
        data["weight"] = this.weight;
        data["included"] = this.included;
        data["finalizationStatus"] = this.finalizationStatus;
        return data;
    }
}

export interface ICalculationPreviewInputModel {
    ruleID?: string | undefined;
    entityType?: string | undefined;
    entityID?: string | undefined;
    markTypeID?: string | undefined;
    result?: number | undefined;
    effectiveTotal?: number | undefined;
    weight?: number;
    included?: boolean;
    finalizationStatus?: string | undefined;
}

export class CalculationExecutionModel implements ICalculationExecutionModel {
    preview?: CalculationPreviewModel | undefined;
    created?: number;
    updated?: number;
    deleted?: number;

    constructor(data?: ICalculationExecutionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preview = _data["preview"] ? CalculationPreviewModel.fromJS(_data["preview"]) : <any>undefined;
            this.created = _data["created"];
            this.updated = _data["updated"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): CalculationExecutionModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationExecutionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preview"] = this.preview ? this.preview.toJSON() : <any>undefined;
        data["created"] = this.created;
        data["updated"] = this.updated;
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface ICalculationExecutionModel {
    preview?: CalculationPreviewModel | undefined;
    created?: number;
    updated?: number;
    deleted?: number;
}

export class CalculationRunModel implements ICalculationRunModel {
    options?: CalculationRunOptionsModel | undefined;
    studentIDs?: string[] | undefined;
    targetEntityKeys?: string[] | undefined;
    canOverrideManualMarks?: boolean;
    canOverrideFinalizedManualMarks?: boolean;
    actorID?: string | undefined;

    constructor(data?: ICalculationRunModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.options = _data["options"] ? CalculationRunOptionsModel.fromJS(_data["options"]) : <any>undefined;
            if (Array.isArray(_data["studentIDs"])) {
                this.studentIDs = [] as any;
                for (let item of _data["studentIDs"])
                    this.studentIDs!.push(item);
            }
            if (Array.isArray(_data["targetEntityKeys"])) {
                this.targetEntityKeys = [] as any;
                for (let item of _data["targetEntityKeys"])
                    this.targetEntityKeys!.push(item);
            }
            this.canOverrideManualMarks = _data["canOverrideManualMarks"];
            this.canOverrideFinalizedManualMarks = _data["canOverrideFinalizedManualMarks"];
            this.actorID = _data["actorID"];
        }
    }

    static fromJS(data: any): CalculationRunModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationRunModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        if (Array.isArray(this.studentIDs)) {
            data["studentIDs"] = [];
            for (let item of this.studentIDs)
                data["studentIDs"].push(item);
        }
        if (Array.isArray(this.targetEntityKeys)) {
            data["targetEntityKeys"] = [];
            for (let item of this.targetEntityKeys)
                data["targetEntityKeys"].push(item);
        }
        data["canOverrideManualMarks"] = this.canOverrideManualMarks;
        data["canOverrideFinalizedManualMarks"] = this.canOverrideFinalizedManualMarks;
        data["actorID"] = this.actorID;
        return data;
    }
}

export interface ICalculationRunModel {
    options?: CalculationRunOptionsModel | undefined;
    studentIDs?: string[] | undefined;
    targetEntityKeys?: string[] | undefined;
    canOverrideManualMarks?: boolean;
    canOverrideFinalizedManualMarks?: boolean;
    actorID?: string | undefined;
}

export class CalculationGraphExecutionModel implements ICalculationGraphExecutionModel {
    layers?: string[][] | undefined;
    assignmentResults?: CalculationExecutionModel[] | undefined;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: ICalculationGraphExecutionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["layers"])) {
                this.layers = [] as any;
                for (let item of _data["layers"])
                    this.layers!.push(item);
            }
            if (Array.isArray(_data["assignmentResults"])) {
                this.assignmentResults = [] as any;
                for (let item of _data["assignmentResults"])
                    this.assignmentResults!.push(CalculationExecutionModel.fromJS(item));
            }
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationGraphExecutionModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationGraphExecutionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.layers)) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item);
        }
        if (Array.isArray(this.assignmentResults)) {
            data["assignmentResults"] = [];
            for (let item of this.assignmentResults)
                data["assignmentResults"].push(item.toJSON());
        }
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalculationGraphExecutionModel {
    layers?: string[][] | undefined;
    assignmentResults?: CalculationExecutionModel[] | undefined;
    findings?: CalculationFinding[] | undefined;
}

export class CalculationGraphRunModel implements ICalculationGraphRunModel {
    assignmentIDs?: string[] | undefined;
    options?: CalculationRunOptionsModel | undefined;
    studentIDs?: string[] | undefined;
    targetEntityKeys?: string[] | undefined;
    includeDownstream?: boolean;
    canOverrideManualMarks?: boolean;
    canOverrideFinalizedManualMarks?: boolean;
    actorID?: string | undefined;

    constructor(data?: ICalculationGraphRunModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignmentIDs"])) {
                this.assignmentIDs = [] as any;
                for (let item of _data["assignmentIDs"])
                    this.assignmentIDs!.push(item);
            }
            this.options = _data["options"] ? CalculationRunOptionsModel.fromJS(_data["options"]) : <any>undefined;
            if (Array.isArray(_data["studentIDs"])) {
                this.studentIDs = [] as any;
                for (let item of _data["studentIDs"])
                    this.studentIDs!.push(item);
            }
            if (Array.isArray(_data["targetEntityKeys"])) {
                this.targetEntityKeys = [] as any;
                for (let item of _data["targetEntityKeys"])
                    this.targetEntityKeys!.push(item);
            }
            this.includeDownstream = _data["includeDownstream"];
            this.canOverrideManualMarks = _data["canOverrideManualMarks"];
            this.canOverrideFinalizedManualMarks = _data["canOverrideFinalizedManualMarks"];
            this.actorID = _data["actorID"];
        }
    }

    static fromJS(data: any): CalculationGraphRunModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationGraphRunModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignmentIDs)) {
            data["assignmentIDs"] = [];
            for (let item of this.assignmentIDs)
                data["assignmentIDs"].push(item);
        }
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        if (Array.isArray(this.studentIDs)) {
            data["studentIDs"] = [];
            for (let item of this.studentIDs)
                data["studentIDs"].push(item);
        }
        if (Array.isArray(this.targetEntityKeys)) {
            data["targetEntityKeys"] = [];
            for (let item of this.targetEntityKeys)
                data["targetEntityKeys"].push(item);
        }
        data["includeDownstream"] = this.includeDownstream;
        data["canOverrideManualMarks"] = this.canOverrideManualMarks;
        data["canOverrideFinalizedManualMarks"] = this.canOverrideFinalizedManualMarks;
        data["actorID"] = this.actorID;
        return data;
    }
}

export interface ICalculationGraphRunModel {
    assignmentIDs?: string[] | undefined;
    options?: CalculationRunOptionsModel | undefined;
    studentIDs?: string[] | undefined;
    targetEntityKeys?: string[] | undefined;
    includeDownstream?: boolean;
    canOverrideManualMarks?: boolean;
    canOverrideFinalizedManualMarks?: boolean;
    actorID?: string | undefined;
}

export class TypedResponseOfAssessmentCycleAPIModel extends DefaultResponse implements ITypedResponseOfAssessmentCycleAPIModel {
    value?: AssessmentCycleAPIModel | undefined;

    constructor(data?: ITypedResponseOfAssessmentCycleAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? AssessmentCycleAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfAssessmentCycleAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfAssessmentCycleAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfAssessmentCycleAPIModel extends IDefaultResponse {
    value?: AssessmentCycleAPIModel | undefined;
}

export class TypedResponseOfIEnumerableOfAssessmentCycleAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfAssessmentCycleAPIModel {
    value?: AssessmentCycleAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfAssessmentCycleAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AssessmentCycleAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfAssessmentCycleAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfAssessmentCycleAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfAssessmentCycleAPIModel extends IDefaultResponse {
    value?: AssessmentCycleAPIModel[] | undefined;
}

export class CreateAssessmentCycleRequest implements ICreateAssessmentCycleRequest {
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    rank?: number;
    academicYearID?: string | undefined;

    constructor(data?: ICreateAssessmentCycleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.rank = _data["rank"];
            this.academicYearID = _data["academicYearID"];
        }
    }

    static fromJS(data: any): CreateAssessmentCycleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssessmentCycleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["rank"] = this.rank;
        data["academicYearID"] = this.academicYearID;
        return data;
    }
}

export interface ICreateAssessmentCycleRequest {
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    rank?: number;
    academicYearID?: string | undefined;
}

export class UpdateAssessmentCycleRequest implements IUpdateAssessmentCycleRequest {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    rank?: number;
    academicYearID?: string | undefined;

    constructor(data?: IUpdateAssessmentCycleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.rank = _data["rank"];
            this.academicYearID = _data["academicYearID"];
        }
    }

    static fromJS(data: any): UpdateAssessmentCycleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssessmentCycleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["rank"] = this.rank;
        data["academicYearID"] = this.academicYearID;
        return data;
    }
}

export interface IUpdateAssessmentCycleRequest {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    rank?: number;
    academicYearID?: string | undefined;
}

export class TypedResponseOfAcademicProgramAPIModel extends DefaultResponse implements ITypedResponseOfAcademicProgramAPIModel {
    value?: AcademicProgramAPIModel | undefined;

    constructor(data?: ITypedResponseOfAcademicProgramAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? AcademicProgramAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfAcademicProgramAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfAcademicProgramAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfAcademicProgramAPIModel extends IDefaultResponse {
    value?: AcademicProgramAPIModel | undefined;
}

export class TypedResponseOfIEnumerableOfAcademicProgramAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfAcademicProgramAPIModel {
    value?: AcademicProgramAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfAcademicProgramAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AcademicProgramAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfAcademicProgramAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfAcademicProgramAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfAcademicProgramAPIModel extends IDefaultResponse {
    value?: AcademicProgramAPIModel[] | undefined;
}

export class CreateAcademicProgramRequest implements ICreateAcademicProgramRequest {
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: ICreateAcademicProgramRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateAcademicProgramRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAcademicProgramRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateAcademicProgramRequest {
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class UpdateAcademicProgramRequest implements IUpdateAcademicProgramRequest {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IUpdateAcademicProgramRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateAcademicProgramRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAcademicProgramRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateAcademicProgramRequest {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class TypedResponseOfAcademicYearAPIModel extends DefaultResponse implements ITypedResponseOfAcademicYearAPIModel {
    value?: AcademicYearAPIModel | undefined;

    constructor(data?: ITypedResponseOfAcademicYearAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? AcademicYearAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfAcademicYearAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfAcademicYearAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfAcademicYearAPIModel extends IDefaultResponse {
    value?: AcademicYearAPIModel | undefined;
}

export class TypedResponseOfIEnumerableOfAcademicYearAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfAcademicYearAPIModel {
    value?: AcademicYearAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfAcademicYearAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AcademicYearAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfAcademicYearAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfAcademicYearAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfAcademicYearAPIModel extends IDefaultResponse {
    value?: AcademicYearAPIModel[] | undefined;
}

export class CreateAcademicYearRequest implements ICreateAcademicYearRequest {
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: ICreateAcademicYearRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateAcademicYearRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAcademicYearRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateAcademicYearRequest {
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class UpdateAcademicYearRequest implements IUpdateAcademicYearRequest {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IUpdateAcademicYearRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateAcademicYearRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAcademicYearRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateAcademicYearRequest {
    id?: string | undefined;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class TypedResponseOfQualificationModuleAPIModel extends DefaultResponse implements ITypedResponseOfQualificationModuleAPIModel {
    value?: QualificationModuleAPIModel | undefined;

    constructor(data?: ITypedResponseOfQualificationModuleAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? QualificationModuleAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfQualificationModuleAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfQualificationModuleAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfQualificationModuleAPIModel extends IDefaultResponse {
    value?: QualificationModuleAPIModel | undefined;
}

export class TypedResponseOfIEnumerableOfQualificationModuleAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfQualificationModuleAPIModel {
    value?: QualificationModuleAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfQualificationModuleAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(QualificationModuleAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfQualificationModuleAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfQualificationModuleAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfQualificationModuleAPIModel extends IDefaultResponse {
    value?: QualificationModuleAPIModel[] | undefined;
}

export class CreateQualificationModuleRequest implements ICreateQualificationModuleRequest {
    qualificationProgramLevelID?: string | undefined;
    moduleID?: string | undefined;
    assessmentCycleID?: string | undefined;

    constructor(data?: ICreateQualificationModuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationProgramLevelID = _data["qualificationProgramLevelID"];
            this.moduleID = _data["moduleID"];
            this.assessmentCycleID = _data["assessmentCycleID"];
        }
    }

    static fromJS(data: any): CreateQualificationModuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQualificationModuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationProgramLevelID"] = this.qualificationProgramLevelID;
        data["moduleID"] = this.moduleID;
        data["assessmentCycleID"] = this.assessmentCycleID;
        return data;
    }
}

export interface ICreateQualificationModuleRequest {
    qualificationProgramLevelID?: string | undefined;
    moduleID?: string | undefined;
    assessmentCycleID?: string | undefined;
}

export class UpdateQualificationModuleRequest implements IUpdateQualificationModuleRequest {
    id?: string | undefined;
    qualificationProgramLevelID?: string | undefined;
    moduleID?: string | undefined;
    assessmentCycleID?: string | undefined;

    constructor(data?: IUpdateQualificationModuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationProgramLevelID = _data["qualificationProgramLevelID"];
            this.moduleID = _data["moduleID"];
            this.assessmentCycleID = _data["assessmentCycleID"];
        }
    }

    static fromJS(data: any): UpdateQualificationModuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQualificationModuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationProgramLevelID"] = this.qualificationProgramLevelID;
        data["moduleID"] = this.moduleID;
        data["assessmentCycleID"] = this.assessmentCycleID;
        return data;
    }
}

export interface IUpdateQualificationModuleRequest {
    id?: string | undefined;
    qualificationProgramLevelID?: string | undefined;
    moduleID?: string | undefined;
    assessmentCycleID?: string | undefined;
}

export class TypedResponseOfQualificationProgramLevelAPIModel extends DefaultResponse implements ITypedResponseOfQualificationProgramLevelAPIModel {
    value?: QualificationProgramLevelAPIModel | undefined;

    constructor(data?: ITypedResponseOfQualificationProgramLevelAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? QualificationProgramLevelAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfQualificationProgramLevelAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfQualificationProgramLevelAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfQualificationProgramLevelAPIModel extends IDefaultResponse {
    value?: QualificationProgramLevelAPIModel | undefined;
}

export class TypedResponseOfIEnumerableOfQualificationProgramLevelAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfQualificationProgramLevelAPIModel {
    value?: QualificationProgramLevelAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfQualificationProgramLevelAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(QualificationProgramLevelAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfQualificationProgramLevelAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfQualificationProgramLevelAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfQualificationProgramLevelAPIModel extends IDefaultResponse {
    value?: QualificationProgramLevelAPIModel[] | undefined;
}

export class CreateQualificationProgramLevelRequest implements ICreateQualificationProgramLevelRequest {
    qualificationID?: string | undefined;
    qualificationLevelID?: string | undefined;
    academicProgramID?: string | undefined;
    academicYearID?: string | undefined;

    constructor(data?: ICreateQualificationProgramLevelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationID = _data["qualificationID"];
            this.qualificationLevelID = _data["qualificationLevelID"];
            this.academicProgramID = _data["academicProgramID"];
            this.academicYearID = _data["academicYearID"];
        }
    }

    static fromJS(data: any): CreateQualificationProgramLevelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQualificationProgramLevelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationID"] = this.qualificationID;
        data["qualificationLevelID"] = this.qualificationLevelID;
        data["academicProgramID"] = this.academicProgramID;
        data["academicYearID"] = this.academicYearID;
        return data;
    }
}

export interface ICreateQualificationProgramLevelRequest {
    qualificationID?: string | undefined;
    qualificationLevelID?: string | undefined;
    academicProgramID?: string | undefined;
    academicYearID?: string | undefined;
}

export class UpdateQualificationProgramLevelRequest implements IUpdateQualificationProgramLevelRequest {
    id?: string | undefined;
    qualificationID?: string | undefined;
    qualificationLevelID?: string | undefined;
    academicProgramID?: string | undefined;
    academicYearID?: string | undefined;

    constructor(data?: IUpdateQualificationProgramLevelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationID = _data["qualificationID"];
            this.qualificationLevelID = _data["qualificationLevelID"];
            this.academicProgramID = _data["academicProgramID"];
            this.academicYearID = _data["academicYearID"];
        }
    }

    static fromJS(data: any): UpdateQualificationProgramLevelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQualificationProgramLevelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationID"] = this.qualificationID;
        data["qualificationLevelID"] = this.qualificationLevelID;
        data["academicProgramID"] = this.academicProgramID;
        data["academicYearID"] = this.academicYearID;
        return data;
    }
}

export interface IUpdateQualificationProgramLevelRequest {
    id?: string | undefined;
    qualificationID?: string | undefined;
    qualificationLevelID?: string | undefined;
    academicProgramID?: string | undefined;
    academicYearID?: string | undefined;
}

export class TypedResponseOfTeachingGroupAPIModel extends DefaultResponse implements ITypedResponseOfTeachingGroupAPIModel {
    value?: TeachingGroupAPIModel | undefined;

    constructor(data?: ITypedResponseOfTeachingGroupAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? TeachingGroupAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfTeachingGroupAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfTeachingGroupAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfTeachingGroupAPIModel extends IDefaultResponse {
    value?: TeachingGroupAPIModel | undefined;
}

export class TeachingGroupAPIModel implements ITeachingGroupAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    qualificationModuleID?: string | undefined;
    module?: QualificationModuleAPIModel | undefined;
    organizationID?: string | undefined;

    constructor(data?: ITeachingGroupAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.module = _data["module"] ? QualificationModuleAPIModel.fromJS(_data["module"]) : <any>undefined;
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): TeachingGroupAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeachingGroupAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface ITeachingGroupAPIModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    qualificationModuleID?: string | undefined;
    module?: QualificationModuleAPIModel | undefined;
    organizationID?: string | undefined;
}

export class TypedResponseOfIEnumerableOfTeachingGroupAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfTeachingGroupAPIModel {
    value?: TeachingGroupAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfTeachingGroupAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(TeachingGroupAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfTeachingGroupAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfTeachingGroupAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfTeachingGroupAPIModel extends IDefaultResponse {
    value?: TeachingGroupAPIModel[] | undefined;
}

export class CreateTeachingGroupRequest implements ICreateTeachingGroupRequest {
    name?: string | undefined;
    description?: string | undefined;
    qualificationModuleID?: string | undefined;

    constructor(data?: ICreateTeachingGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.qualificationModuleID = _data["qualificationModuleID"];
        }
    }

    static fromJS(data: any): CreateTeachingGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeachingGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["qualificationModuleID"] = this.qualificationModuleID;
        return data;
    }
}

export interface ICreateTeachingGroupRequest {
    name?: string | undefined;
    description?: string | undefined;
    qualificationModuleID?: string | undefined;
}

export class UpdateTeachingGroupRequest implements IUpdateTeachingGroupRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    qualificationModuleID?: string | undefined;

    constructor(data?: IUpdateTeachingGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.qualificationModuleID = _data["qualificationModuleID"];
        }
    }

    static fromJS(data: any): UpdateTeachingGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeachingGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["qualificationModuleID"] = this.qualificationModuleID;
        return data;
    }
}

export interface IUpdateTeachingGroupRequest {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    qualificationModuleID?: string | undefined;
}

export class GradeScaleModel implements IGradeScaleModel {
    id?: string;
    name?: string;
    evaluationMode?: GradeScaleEvaluationMode;
    isArchived?: boolean;
    bands?: GradeScaleBandModel[];

    constructor(data?: IGradeScaleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.evaluationMode = _data["evaluationMode"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["bands"])) {
                this.bands = [] as any;
                for (let item of _data["bands"])
                    this.bands!.push(GradeScaleBandModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GradeScaleModel {
        data = typeof data === 'object' ? data : {};
        let result = new GradeScaleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["evaluationMode"] = this.evaluationMode;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.bands)) {
            data["bands"] = [];
            for (let item of this.bands)
                data["bands"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGradeScaleModel {
    id?: string;
    name?: string;
    evaluationMode?: GradeScaleEvaluationMode;
    isArchived?: boolean;
    bands?: GradeScaleBandModel[];
}

export enum GradeScaleEvaluationMode {
    RawValue = 0,
    NormalizedValue = 1,
}

export class GradeScaleBandModel implements IGradeScaleBandModel {
    id?: string;
    minimumValue?: number;
    code?: string;
    name?: string;
    numericValue?: number | undefined;
    isPass?: boolean | undefined;

    constructor(data?: IGradeScaleBandModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minimumValue = _data["minimumValue"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.numericValue = _data["numericValue"];
            this.isPass = _data["isPass"];
        }
    }

    static fromJS(data: any): GradeScaleBandModel {
        data = typeof data === 'object' ? data : {};
        let result = new GradeScaleBandModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minimumValue"] = this.minimumValue;
        data["code"] = this.code;
        data["name"] = this.name;
        data["numericValue"] = this.numericValue;
        data["isPass"] = this.isPass;
        return data;
    }
}

export interface IGradeScaleBandModel {
    id?: string;
    minimumValue?: number;
    code?: string;
    name?: string;
    numericValue?: number | undefined;
    isPass?: boolean | undefined;
}

export class GradeScaleWriteModel implements IGradeScaleWriteModel {
    name!: string;
    evaluationMode?: GradeScaleEvaluationMode;
    bands?: GradeScaleBandWriteModel[];

    constructor(data?: IGradeScaleWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.evaluationMode = _data["evaluationMode"];
            if (Array.isArray(_data["bands"])) {
                this.bands = [] as any;
                for (let item of _data["bands"])
                    this.bands!.push(GradeScaleBandWriteModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GradeScaleWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new GradeScaleWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["evaluationMode"] = this.evaluationMode;
        if (Array.isArray(this.bands)) {
            data["bands"] = [];
            for (let item of this.bands)
                data["bands"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGradeScaleWriteModel {
    name: string;
    evaluationMode?: GradeScaleEvaluationMode;
    bands?: GradeScaleBandWriteModel[];
}

export class GradeScaleBandWriteModel implements IGradeScaleBandWriteModel {
    code!: string;
    name!: string;
    minimumValue?: number;
    numericValue?: number | undefined;
    isPass?: boolean | undefined;

    constructor(data?: IGradeScaleBandWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.minimumValue = _data["minimumValue"];
            this.numericValue = _data["numericValue"];
            this.isPass = _data["isPass"];
        }
    }

    static fromJS(data: any): GradeScaleBandWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new GradeScaleBandWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["minimumValue"] = this.minimumValue;
        data["numericValue"] = this.numericValue;
        data["isPass"] = this.isPass;
        return data;
    }
}

export interface IGradeScaleBandWriteModel {
    code: string;
    name: string;
    minimumValue?: number;
    numericValue?: number | undefined;
    isPass?: boolean | undefined;
}

export class SetMarkTypeGradeScaleModel implements ISetMarkTypeGradeScaleModel {
    gradeScaleID?: string | undefined;

    constructor(data?: ISetMarkTypeGradeScaleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gradeScaleID = _data["gradeScaleID"];
        }
    }

    static fromJS(data: any): SetMarkTypeGradeScaleModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetMarkTypeGradeScaleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gradeScaleID"] = this.gradeScaleID;
        return data;
    }
}

export interface ISetMarkTypeGradeScaleModel {
    gradeScaleID?: string | undefined;
}

export class GradeEvaluationModel implements IGradeEvaluationModel {
    gradeScaleID?: string;
    evaluatedValue?: number;
    band?: GradeScaleBandModel | undefined;

    constructor(data?: IGradeEvaluationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gradeScaleID = _data["gradeScaleID"];
            this.evaluatedValue = _data["evaluatedValue"];
            this.band = _data["band"] ? GradeScaleBandModel.fromJS(_data["band"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GradeEvaluationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GradeEvaluationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gradeScaleID"] = this.gradeScaleID;
        data["evaluatedValue"] = this.evaluatedValue;
        data["band"] = this.band ? this.band.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGradeEvaluationModel {
    gradeScaleID?: string;
    evaluatedValue?: number;
    band?: GradeScaleBandModel | undefined;
}

export class EvaluateGradeModel implements IEvaluateGradeModel {
    result?: number;
    total?: number;
    procedureVersionGradeScaleID?: string | undefined;
    markTypeID?: string | undefined;

    constructor(data?: IEvaluateGradeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.total = _data["total"];
            this.procedureVersionGradeScaleID = _data["procedureVersionGradeScaleID"];
            this.markTypeID = _data["markTypeID"];
        }
    }

    static fromJS(data: any): EvaluateGradeModel {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluateGradeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["total"] = this.total;
        data["procedureVersionGradeScaleID"] = this.procedureVersionGradeScaleID;
        data["markTypeID"] = this.markTypeID;
        return data;
    }
}

export interface IEvaluateGradeModel {
    result?: number;
    total?: number;
    procedureVersionGradeScaleID?: string | undefined;
    markTypeID?: string | undefined;
}

export class TypedResponseOfQualificationLevelEnrollmentAPIModel extends DefaultResponse implements ITypedResponseOfQualificationLevelEnrollmentAPIModel {
    value?: QualificationLevelEnrollmentAPIModel | undefined;

    constructor(data?: ITypedResponseOfQualificationLevelEnrollmentAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? QualificationLevelEnrollmentAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfQualificationLevelEnrollmentAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfQualificationLevelEnrollmentAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfQualificationLevelEnrollmentAPIModel extends IDefaultResponse {
    value?: QualificationLevelEnrollmentAPIModel | undefined;
}

export class QualificationLevelEnrollmentAPIModel implements IQualificationLevelEnrollmentAPIModel {
    id?: string | undefined;
    studentID?: string | undefined;
    enrollmentStatus?: EnrollmentStatus | undefined;
    qualificationProgramLevelID?: string | undefined;
    qualificationProgramLevel?: QualificationProgramLevelAPIModel | undefined;
    organizationID?: string | undefined;

    constructor(data?: IQualificationLevelEnrollmentAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentID = _data["studentID"];
            this.enrollmentStatus = _data["enrollmentStatus"] ? EnrollmentStatus.fromJS(_data["enrollmentStatus"]) : <any>undefined;
            this.qualificationProgramLevelID = _data["qualificationProgramLevelID"];
            this.qualificationProgramLevel = _data["qualificationProgramLevel"] ? QualificationProgramLevelAPIModel.fromJS(_data["qualificationProgramLevel"]) : <any>undefined;
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): QualificationLevelEnrollmentAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationLevelEnrollmentAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentID"] = this.studentID;
        data["enrollmentStatus"] = this.enrollmentStatus ? this.enrollmentStatus.toJSON() : <any>undefined;
        data["qualificationProgramLevelID"] = this.qualificationProgramLevelID;
        data["qualificationProgramLevel"] = this.qualificationProgramLevel ? this.qualificationProgramLevel.toJSON() : <any>undefined;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IQualificationLevelEnrollmentAPIModel {
    id?: string | undefined;
    studentID?: string | undefined;
    enrollmentStatus?: EnrollmentStatus | undefined;
    qualificationProgramLevelID?: string | undefined;
    qualificationProgramLevel?: QualificationProgramLevelAPIModel | undefined;
    organizationID?: string | undefined;
}

export class EnrollmentStatus extends Enumeration implements IEnrollmentStatus {

    constructor(data?: IEnrollmentStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): EnrollmentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEnrollmentStatus extends IEnumeration {
}

export class TypedResponseOfIEnumerableOfQualificationLevelEnrollmentAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfQualificationLevelEnrollmentAPIModel {
    value?: QualificationLevelEnrollmentAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfQualificationLevelEnrollmentAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(QualificationLevelEnrollmentAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfQualificationLevelEnrollmentAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfQualificationLevelEnrollmentAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfQualificationLevelEnrollmentAPIModel extends IDefaultResponse {
    value?: QualificationLevelEnrollmentAPIModel[] | undefined;
}

export class CreateQualificationLevelEnrollmentRequest implements ICreateQualificationLevelEnrollmentRequest {
    enrollmentStatus?: EnrollmentStatus | undefined;
    qualificationProgramLevelID?: string | undefined;
    studentID?: string | undefined;

    constructor(data?: ICreateQualificationLevelEnrollmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enrollmentStatus = _data["enrollmentStatus"] ? EnrollmentStatus.fromJS(_data["enrollmentStatus"]) : <any>undefined;
            this.qualificationProgramLevelID = _data["qualificationProgramLevelID"];
            this.studentID = _data["studentID"];
        }
    }

    static fromJS(data: any): CreateQualificationLevelEnrollmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQualificationLevelEnrollmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enrollmentStatus"] = this.enrollmentStatus ? this.enrollmentStatus.toJSON() : <any>undefined;
        data["qualificationProgramLevelID"] = this.qualificationProgramLevelID;
        data["studentID"] = this.studentID;
        return data;
    }
}

export interface ICreateQualificationLevelEnrollmentRequest {
    enrollmentStatus?: EnrollmentStatus | undefined;
    qualificationProgramLevelID?: string | undefined;
    studentID?: string | undefined;
}

export class UpdateQualificationLevelEnrollmentRequest implements IUpdateQualificationLevelEnrollmentRequest {
    id?: string | undefined;
    enrollmentStatus?: EnrollmentStatus | undefined;

    constructor(data?: IUpdateQualificationLevelEnrollmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enrollmentStatus = _data["enrollmentStatus"] ? EnrollmentStatus.fromJS(_data["enrollmentStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateQualificationLevelEnrollmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQualificationLevelEnrollmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enrollmentStatus"] = this.enrollmentStatus ? this.enrollmentStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateQualificationLevelEnrollmentRequest {
    id?: string | undefined;
    enrollmentStatus?: EnrollmentStatus | undefined;
}

export class TypedResponseOfStudentModuleEnrollmentAPIModel extends DefaultResponse implements ITypedResponseOfStudentModuleEnrollmentAPIModel {
    value?: StudentModuleEnrollmentAPIModel | undefined;

    constructor(data?: ITypedResponseOfStudentModuleEnrollmentAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? StudentModuleEnrollmentAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfStudentModuleEnrollmentAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfStudentModuleEnrollmentAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfStudentModuleEnrollmentAPIModel extends IDefaultResponse {
    value?: StudentModuleEnrollmentAPIModel | undefined;
}

export class StudentModuleEnrollmentAPIModel implements IStudentModuleEnrollmentAPIModel {
    id?: string | undefined;
    studentID?: string | undefined;
    enrollmentStatus?: EnrollmentStatus | undefined;
    qualificationModuleID?: string | undefined;
    qualificationModule?: QualificationModuleAPIModel | undefined;
    organizationID?: string | undefined;

    constructor(data?: IStudentModuleEnrollmentAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentID = _data["studentID"];
            this.enrollmentStatus = _data["enrollmentStatus"] ? EnrollmentStatus.fromJS(_data["enrollmentStatus"]) : <any>undefined;
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.qualificationModule = _data["qualificationModule"] ? QualificationModuleAPIModel.fromJS(_data["qualificationModule"]) : <any>undefined;
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): StudentModuleEnrollmentAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudentModuleEnrollmentAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentID"] = this.studentID;
        data["enrollmentStatus"] = this.enrollmentStatus ? this.enrollmentStatus.toJSON() : <any>undefined;
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["qualificationModule"] = this.qualificationModule ? this.qualificationModule.toJSON() : <any>undefined;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IStudentModuleEnrollmentAPIModel {
    id?: string | undefined;
    studentID?: string | undefined;
    enrollmentStatus?: EnrollmentStatus | undefined;
    qualificationModuleID?: string | undefined;
    qualificationModule?: QualificationModuleAPIModel | undefined;
    organizationID?: string | undefined;
}

export class TypedResponseOfIEnumerableOfStudentModuleEnrollmentAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfStudentModuleEnrollmentAPIModel {
    value?: StudentModuleEnrollmentAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfStudentModuleEnrollmentAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(StudentModuleEnrollmentAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfStudentModuleEnrollmentAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfStudentModuleEnrollmentAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfStudentModuleEnrollmentAPIModel extends IDefaultResponse {
    value?: StudentModuleEnrollmentAPIModel[] | undefined;
}

export class TypedResponseOfIEnumerableOfStudentModuleEnrollmentSyncModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfStudentModuleEnrollmentSyncModel {
    value?: StudentModuleEnrollmentSyncModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfStudentModuleEnrollmentSyncModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(StudentModuleEnrollmentSyncModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfStudentModuleEnrollmentSyncModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfStudentModuleEnrollmentSyncModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfStudentModuleEnrollmentSyncModel extends IDefaultResponse {
    value?: StudentModuleEnrollmentSyncModel[] | undefined;
}

export class StudentModuleEnrollmentSyncModel implements IStudentModuleEnrollmentSyncModel {
    id?: string | undefined;
    studentID?: string | undefined;
    enrollmentStatus?: string | undefined;
    qualificationModuleID?: string | undefined;
    moduleID?: string | undefined;
    moduleName?: string | undefined;
    assessmentCycleID?: string | undefined;
    qualificationProgramLevelID?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    organizationID?: string | undefined;

    constructor(data?: IStudentModuleEnrollmentSyncModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentID = _data["studentID"];
            this.enrollmentStatus = _data["enrollmentStatus"];
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.moduleID = _data["moduleID"];
            this.moduleName = _data["moduleName"];
            this.assessmentCycleID = _data["assessmentCycleID"];
            this.qualificationProgramLevelID = _data["qualificationProgramLevelID"];
            this.source = _data["source"];
            this.sourceID = _data["sourceID"];
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): StudentModuleEnrollmentSyncModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudentModuleEnrollmentSyncModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentID"] = this.studentID;
        data["enrollmentStatus"] = this.enrollmentStatus;
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["moduleID"] = this.moduleID;
        data["moduleName"] = this.moduleName;
        data["assessmentCycleID"] = this.assessmentCycleID;
        data["qualificationProgramLevelID"] = this.qualificationProgramLevelID;
        data["source"] = this.source;
        data["sourceID"] = this.sourceID;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IStudentModuleEnrollmentSyncModel {
    id?: string | undefined;
    studentID?: string | undefined;
    enrollmentStatus?: string | undefined;
    qualificationModuleID?: string | undefined;
    moduleID?: string | undefined;
    moduleName?: string | undefined;
    assessmentCycleID?: string | undefined;
    qualificationProgramLevelID?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    organizationID?: string | undefined;
}

export class EnrollmentSyncRequest implements IEnrollmentSyncRequest {
    organizationID?: string | undefined;
    userIDs?: string[] | undefined;
    moduleIDs?: string[] | undefined;
    skip?: number;
    take?: number;

    constructor(data?: IEnrollmentSyncRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationID = _data["organizationID"];
            if (Array.isArray(_data["userIDs"])) {
                this.userIDs = [] as any;
                for (let item of _data["userIDs"])
                    this.userIDs!.push(item);
            }
            if (Array.isArray(_data["moduleIDs"])) {
                this.moduleIDs = [] as any;
                for (let item of _data["moduleIDs"])
                    this.moduleIDs!.push(item);
            }
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): EnrollmentSyncRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentSyncRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationID"] = this.organizationID;
        if (Array.isArray(this.userIDs)) {
            data["userIDs"] = [];
            for (let item of this.userIDs)
                data["userIDs"].push(item);
        }
        if (Array.isArray(this.moduleIDs)) {
            data["moduleIDs"] = [];
            for (let item of this.moduleIDs)
                data["moduleIDs"].push(item);
        }
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IEnrollmentSyncRequest {
    organizationID?: string | undefined;
    userIDs?: string[] | undefined;
    moduleIDs?: string[] | undefined;
    skip?: number;
    take?: number;
}

export class TypedResponseOfString extends DefaultResponse implements ITypedResponseOfString {
    value?: string | undefined;

    constructor(data?: ITypedResponseOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): TypedResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfString extends IDefaultResponse {
    value?: string | undefined;
}

export class EnsureStudentModuleEnrollmentRequest implements IEnsureStudentModuleEnrollmentRequest {
    enrollmentStatus?: string | undefined;
    studentID?: string | undefined;
    qualificationModuleID?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;

    constructor(data?: IEnsureStudentModuleEnrollmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enrollmentStatus = _data["enrollmentStatus"];
            this.studentID = _data["studentID"];
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.source = _data["source"];
            this.sourceID = _data["sourceID"];
        }
    }

    static fromJS(data: any): EnsureStudentModuleEnrollmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnsureStudentModuleEnrollmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enrollmentStatus"] = this.enrollmentStatus;
        data["studentID"] = this.studentID;
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["source"] = this.source;
        data["sourceID"] = this.sourceID;
        return data;
    }
}

export interface IEnsureStudentModuleEnrollmentRequest {
    enrollmentStatus?: string | undefined;
    studentID?: string | undefined;
    qualificationModuleID?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
}

export class CreateStudentModuleEnrollmentRequest implements ICreateStudentModuleEnrollmentRequest {
    enrollmentStatus?: EnrollmentStatus | undefined;
    studentID?: string | undefined;
    qualificationModuleID?: string | undefined;

    constructor(data?: ICreateStudentModuleEnrollmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enrollmentStatus = _data["enrollmentStatus"] ? EnrollmentStatus.fromJS(_data["enrollmentStatus"]) : <any>undefined;
            this.studentID = _data["studentID"];
            this.qualificationModuleID = _data["qualificationModuleID"];
        }
    }

    static fromJS(data: any): CreateStudentModuleEnrollmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudentModuleEnrollmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enrollmentStatus"] = this.enrollmentStatus ? this.enrollmentStatus.toJSON() : <any>undefined;
        data["studentID"] = this.studentID;
        data["qualificationModuleID"] = this.qualificationModuleID;
        return data;
    }
}

export interface ICreateStudentModuleEnrollmentRequest {
    enrollmentStatus?: EnrollmentStatus | undefined;
    studentID?: string | undefined;
    qualificationModuleID?: string | undefined;
}

export class UpdateStudentModuleEnrollmentRequest implements IUpdateStudentModuleEnrollmentRequest {
    id?: string | undefined;
    enrollmentStatus?: EnrollmentStatus | undefined;

    constructor(data?: IUpdateStudentModuleEnrollmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enrollmentStatus = _data["enrollmentStatus"] ? EnrollmentStatus.fromJS(_data["enrollmentStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateStudentModuleEnrollmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentModuleEnrollmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enrollmentStatus"] = this.enrollmentStatus ? this.enrollmentStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateStudentModuleEnrollmentRequest {
    id?: string | undefined;
    enrollmentStatus?: EnrollmentStatus | undefined;
}

export class TypedResponseOfTeachingGroupEnrollmentAPIModel extends DefaultResponse implements ITypedResponseOfTeachingGroupEnrollmentAPIModel {
    value?: TeachingGroupEnrollmentAPIModel | undefined;

    constructor(data?: ITypedResponseOfTeachingGroupEnrollmentAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? TeachingGroupEnrollmentAPIModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TypedResponseOfTeachingGroupEnrollmentAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfTeachingGroupEnrollmentAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfTeachingGroupEnrollmentAPIModel extends IDefaultResponse {
    value?: TeachingGroupEnrollmentAPIModel | undefined;
}

export class TeachingGroupEnrollmentAPIModel implements ITeachingGroupEnrollmentAPIModel {
    id?: string | undefined;
    userID?: string | undefined;
    enrollmentType?: EnrollmentType | undefined;
    teachingGroupID?: string | undefined;
    teachingGroup?: TeachingGroupAPIModel | undefined;
    organizationID?: string | undefined;

    constructor(data?: ITeachingGroupEnrollmentAPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userID = _data["userID"];
            this.enrollmentType = _data["enrollmentType"] ? EnrollmentType.fromJS(_data["enrollmentType"]) : <any>undefined;
            this.teachingGroupID = _data["teachingGroupID"];
            this.teachingGroup = _data["teachingGroup"] ? TeachingGroupAPIModel.fromJS(_data["teachingGroup"]) : <any>undefined;
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): TeachingGroupEnrollmentAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeachingGroupEnrollmentAPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userID"] = this.userID;
        data["enrollmentType"] = this.enrollmentType ? this.enrollmentType.toJSON() : <any>undefined;
        data["teachingGroupID"] = this.teachingGroupID;
        data["teachingGroup"] = this.teachingGroup ? this.teachingGroup.toJSON() : <any>undefined;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface ITeachingGroupEnrollmentAPIModel {
    id?: string | undefined;
    userID?: string | undefined;
    enrollmentType?: EnrollmentType | undefined;
    teachingGroupID?: string | undefined;
    teachingGroup?: TeachingGroupAPIModel | undefined;
    organizationID?: string | undefined;
}

export class EnrollmentType extends Enumeration implements IEnrollmentType {

    constructor(data?: IEnrollmentType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): EnrollmentType {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEnrollmentType extends IEnumeration {
}

export class TypedResponseOfIEnumerableOfTeachingGroupEnrollmentAPIModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfTeachingGroupEnrollmentAPIModel {
    value?: TeachingGroupEnrollmentAPIModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfTeachingGroupEnrollmentAPIModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(TeachingGroupEnrollmentAPIModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfTeachingGroupEnrollmentAPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfTeachingGroupEnrollmentAPIModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfTeachingGroupEnrollmentAPIModel extends IDefaultResponse {
    value?: TeachingGroupEnrollmentAPIModel[] | undefined;
}

export class TypedResponseOfIEnumerableOfTeachingGroupEnrollmentSyncModel extends DefaultResponse implements ITypedResponseOfIEnumerableOfTeachingGroupEnrollmentSyncModel {
    value?: TeachingGroupEnrollmentSyncModel[] | undefined;

    constructor(data?: ITypedResponseOfIEnumerableOfTeachingGroupEnrollmentSyncModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(TeachingGroupEnrollmentSyncModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TypedResponseOfIEnumerableOfTeachingGroupEnrollmentSyncModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypedResponseOfIEnumerableOfTeachingGroupEnrollmentSyncModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypedResponseOfIEnumerableOfTeachingGroupEnrollmentSyncModel extends IDefaultResponse {
    value?: TeachingGroupEnrollmentSyncModel[] | undefined;
}

export class TeachingGroupEnrollmentSyncModel implements ITeachingGroupEnrollmentSyncModel {
    id?: string | undefined;
    userID?: string | undefined;
    enrollmentType?: string | undefined;
    teachingGroupID?: string | undefined;
    teachingGroupName?: string | undefined;
    qualificationModuleID?: string | undefined;
    moduleID?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    organizationID?: string | undefined;

    constructor(data?: ITeachingGroupEnrollmentSyncModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userID = _data["userID"];
            this.enrollmentType = _data["enrollmentType"];
            this.teachingGroupID = _data["teachingGroupID"];
            this.teachingGroupName = _data["teachingGroupName"];
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.moduleID = _data["moduleID"];
            this.source = _data["source"];
            this.sourceID = _data["sourceID"];
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): TeachingGroupEnrollmentSyncModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeachingGroupEnrollmentSyncModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userID"] = this.userID;
        data["enrollmentType"] = this.enrollmentType;
        data["teachingGroupID"] = this.teachingGroupID;
        data["teachingGroupName"] = this.teachingGroupName;
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["moduleID"] = this.moduleID;
        data["source"] = this.source;
        data["sourceID"] = this.sourceID;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface ITeachingGroupEnrollmentSyncModel {
    id?: string | undefined;
    userID?: string | undefined;
    enrollmentType?: string | undefined;
    teachingGroupID?: string | undefined;
    teachingGroupName?: string | undefined;
    qualificationModuleID?: string | undefined;
    moduleID?: string | undefined;
    source?: string | undefined;
    sourceID?: string | undefined;
    organizationID?: string | undefined;
}

export class CreateTeachingGroupEnrollmentRequest implements ICreateTeachingGroupEnrollmentRequest {
    enrollmentType?: EnrollmentType | undefined;
    teachingGroupID?: string | undefined;
    studentID?: string | undefined;

    constructor(data?: ICreateTeachingGroupEnrollmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enrollmentType = _data["enrollmentType"] ? EnrollmentType.fromJS(_data["enrollmentType"]) : <any>undefined;
            this.teachingGroupID = _data["teachingGroupID"];
            this.studentID = _data["studentID"];
        }
    }

    static fromJS(data: any): CreateTeachingGroupEnrollmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeachingGroupEnrollmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enrollmentType"] = this.enrollmentType ? this.enrollmentType.toJSON() : <any>undefined;
        data["teachingGroupID"] = this.teachingGroupID;
        data["studentID"] = this.studentID;
        return data;
    }
}

export interface ICreateTeachingGroupEnrollmentRequest {
    enrollmentType?: EnrollmentType | undefined;
    teachingGroupID?: string | undefined;
    studentID?: string | undefined;
}

export class SubjectChoice implements ISubjectChoice {
    moduleList?: string[] | undefined;

    constructor(data?: ISubjectChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["moduleList"])) {
                this.moduleList = [] as any;
                for (let item of _data["moduleList"])
                    this.moduleList!.push(item);
            }
        }
    }

    static fromJS(data: any): SubjectChoice {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectChoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.moduleList)) {
            data["moduleList"] = [];
            for (let item of this.moduleList)
                data["moduleList"].push(item);
        }
        return data;
    }
}

export interface ISubjectChoice {
    moduleList?: string[] | undefined;
}

export class SubjectChoiceRuleModel implements ISubjectChoiceRuleModel {
    id?: string | undefined;
    qualificationID?: string | undefined;
    qualificationLevelID?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    rank?: number;
    appliesToAllSubjects?: boolean;
    measure?: string | undefined;
    minimum?: number | undefined;
    maximum?: number | undefined;
    moduleIDs?: string[] | undefined;
    source?: string | undefined;

    constructor(data?: ISubjectChoiceRuleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationID = _data["qualificationID"];
            this.qualificationLevelID = _data["qualificationLevelID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.rank = _data["rank"];
            this.appliesToAllSubjects = _data["appliesToAllSubjects"];
            this.measure = _data["measure"];
            this.minimum = _data["minimum"];
            this.maximum = _data["maximum"];
            if (Array.isArray(_data["moduleIDs"])) {
                this.moduleIDs = [] as any;
                for (let item of _data["moduleIDs"])
                    this.moduleIDs!.push(item);
            }
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): SubjectChoiceRuleModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectChoiceRuleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationID"] = this.qualificationID;
        data["qualificationLevelID"] = this.qualificationLevelID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["rank"] = this.rank;
        data["appliesToAllSubjects"] = this.appliesToAllSubjects;
        data["measure"] = this.measure;
        data["minimum"] = this.minimum;
        data["maximum"] = this.maximum;
        if (Array.isArray(this.moduleIDs)) {
            data["moduleIDs"] = [];
            for (let item of this.moduleIDs)
                data["moduleIDs"].push(item);
        }
        data["source"] = this.source;
        return data;
    }
}

export interface ISubjectChoiceRuleModel {
    id?: string | undefined;
    qualificationID?: string | undefined;
    qualificationLevelID?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    rank?: number;
    appliesToAllSubjects?: boolean;
    measure?: string | undefined;
    minimum?: number | undefined;
    maximum?: number | undefined;
    moduleIDs?: string[] | undefined;
    source?: string | undefined;
}

export class SubjectChoiceRuleWriteModel implements ISubjectChoiceRuleWriteModel {
    qualificationID?: string | undefined;
    qualificationLevelID?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    appliesToAllSubjects?: boolean;
    measure?: string | undefined;
    minimum?: number | undefined;
    maximum?: number | undefined;
    moduleIDs?: string[] | undefined;

    constructor(data?: ISubjectChoiceRuleWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationID = _data["qualificationID"];
            this.qualificationLevelID = _data["qualificationLevelID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.appliesToAllSubjects = _data["appliesToAllSubjects"];
            this.measure = _data["measure"];
            this.minimum = _data["minimum"];
            this.maximum = _data["maximum"];
            if (Array.isArray(_data["moduleIDs"])) {
                this.moduleIDs = [] as any;
                for (let item of _data["moduleIDs"])
                    this.moduleIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): SubjectChoiceRuleWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectChoiceRuleWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationID"] = this.qualificationID;
        data["qualificationLevelID"] = this.qualificationLevelID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["appliesToAllSubjects"] = this.appliesToAllSubjects;
        data["measure"] = this.measure;
        data["minimum"] = this.minimum;
        data["maximum"] = this.maximum;
        if (Array.isArray(this.moduleIDs)) {
            data["moduleIDs"] = [];
            for (let item of this.moduleIDs)
                data["moduleIDs"].push(item);
        }
        return data;
    }
}

export interface ISubjectChoiceRuleWriteModel {
    qualificationID?: string | undefined;
    qualificationLevelID?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    appliesToAllSubjects?: boolean;
    measure?: string | undefined;
    minimum?: number | undefined;
    maximum?: number | undefined;
    moduleIDs?: string[] | undefined;
}

export class ReorderSubjectChoiceRulesModel implements IReorderSubjectChoiceRulesModel {
    ruleIDs?: string[] | undefined;

    constructor(data?: IReorderSubjectChoiceRulesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ruleIDs"])) {
                this.ruleIDs = [] as any;
                for (let item of _data["ruleIDs"])
                    this.ruleIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderSubjectChoiceRulesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderSubjectChoiceRulesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ruleIDs)) {
            data["ruleIDs"] = [];
            for (let item of this.ruleIDs)
                data["ruleIDs"].push(item);
        }
        return data;
    }
}

export interface IReorderSubjectChoiceRulesModel {
    ruleIDs?: string[] | undefined;
}

export class SubjectChoiceGridModel implements ISubjectChoiceGridModel {
    qualificationProgramLevelID?: string | undefined;
    subjects?: SubjectChoiceSubjectModel[] | undefined;
    students?: SubjectChoiceStudentModel[] | undefined;
    rules?: SubjectChoiceRuleModel[] | undefined;
    corequisites?: SubjectChoiceCorequisiteModel[] | undefined;
    gradeFindings?: SubjectChoiceFinding[] | undefined;

    constructor(data?: ISubjectChoiceGridModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationProgramLevelID = _data["qualificationProgramLevelID"];
            if (Array.isArray(_data["subjects"])) {
                this.subjects = [] as any;
                for (let item of _data["subjects"])
                    this.subjects!.push(SubjectChoiceSubjectModel.fromJS(item));
            }
            if (Array.isArray(_data["students"])) {
                this.students = [] as any;
                for (let item of _data["students"])
                    this.students!.push(SubjectChoiceStudentModel.fromJS(item));
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(SubjectChoiceRuleModel.fromJS(item));
            }
            if (Array.isArray(_data["corequisites"])) {
                this.corequisites = [] as any;
                for (let item of _data["corequisites"])
                    this.corequisites!.push(SubjectChoiceCorequisiteModel.fromJS(item));
            }
            if (Array.isArray(_data["gradeFindings"])) {
                this.gradeFindings = [] as any;
                for (let item of _data["gradeFindings"])
                    this.gradeFindings!.push(SubjectChoiceFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubjectChoiceGridModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectChoiceGridModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationProgramLevelID"] = this.qualificationProgramLevelID;
        if (Array.isArray(this.subjects)) {
            data["subjects"] = [];
            for (let item of this.subjects)
                data["subjects"].push(item.toJSON());
        }
        if (Array.isArray(this.students)) {
            data["students"] = [];
            for (let item of this.students)
                data["students"].push(item.toJSON());
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        if (Array.isArray(this.corequisites)) {
            data["corequisites"] = [];
            for (let item of this.corequisites)
                data["corequisites"].push(item.toJSON());
        }
        if (Array.isArray(this.gradeFindings)) {
            data["gradeFindings"] = [];
            for (let item of this.gradeFindings)
                data["gradeFindings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubjectChoiceGridModel {
    qualificationProgramLevelID?: string | undefined;
    subjects?: SubjectChoiceSubjectModel[] | undefined;
    students?: SubjectChoiceStudentModel[] | undefined;
    rules?: SubjectChoiceRuleModel[] | undefined;
    corequisites?: SubjectChoiceCorequisiteModel[] | undefined;
    gradeFindings?: SubjectChoiceFinding[] | undefined;
}

export class SubjectChoiceSubjectModel implements ISubjectChoiceSubjectModel {
    moduleID?: string | undefined;
    name?: string | undefined;
    termCount?: number;
    credits?: number | undefined;
    ruleIDs?: string[] | undefined;

    constructor(data?: ISubjectChoiceSubjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleID = _data["moduleID"];
            this.name = _data["name"];
            this.termCount = _data["termCount"];
            this.credits = _data["credits"];
            if (Array.isArray(_data["ruleIDs"])) {
                this.ruleIDs = [] as any;
                for (let item of _data["ruleIDs"])
                    this.ruleIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): SubjectChoiceSubjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectChoiceSubjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleID"] = this.moduleID;
        data["name"] = this.name;
        data["termCount"] = this.termCount;
        data["credits"] = this.credits;
        if (Array.isArray(this.ruleIDs)) {
            data["ruleIDs"] = [];
            for (let item of this.ruleIDs)
                data["ruleIDs"].push(item);
        }
        return data;
    }
}

export interface ISubjectChoiceSubjectModel {
    moduleID?: string | undefined;
    name?: string | undefined;
    termCount?: number;
    credits?: number | undefined;
    ruleIDs?: string[] | undefined;
}

export class SubjectChoiceStudentModel implements ISubjectChoiceStudentModel {
    studentID?: string | undefined;
    levelEnrollmentStatus?: string | undefined;
    moduleIDs?: string[] | undefined;
    completedModuleIDs?: string[] | undefined;
    findings?: SubjectChoiceFinding[] | undefined;

    constructor(data?: ISubjectChoiceStudentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            this.levelEnrollmentStatus = _data["levelEnrollmentStatus"];
            if (Array.isArray(_data["moduleIDs"])) {
                this.moduleIDs = [] as any;
                for (let item of _data["moduleIDs"])
                    this.moduleIDs!.push(item);
            }
            if (Array.isArray(_data["completedModuleIDs"])) {
                this.completedModuleIDs = [] as any;
                for (let item of _data["completedModuleIDs"])
                    this.completedModuleIDs!.push(item);
            }
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(SubjectChoiceFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubjectChoiceStudentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectChoiceStudentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        data["levelEnrollmentStatus"] = this.levelEnrollmentStatus;
        if (Array.isArray(this.moduleIDs)) {
            data["moduleIDs"] = [];
            for (let item of this.moduleIDs)
                data["moduleIDs"].push(item);
        }
        if (Array.isArray(this.completedModuleIDs)) {
            data["completedModuleIDs"] = [];
            for (let item of this.completedModuleIDs)
                data["completedModuleIDs"].push(item);
        }
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubjectChoiceStudentModel {
    studentID?: string | undefined;
    levelEnrollmentStatus?: string | undefined;
    moduleIDs?: string[] | undefined;
    completedModuleIDs?: string[] | undefined;
    findings?: SubjectChoiceFinding[] | undefined;
}

export class SubjectChoiceFinding implements ISubjectChoiceFinding {
    kind?: string | undefined;
    ruleID?: string | undefined;
    message?: string | undefined;

    constructor(data?: ISubjectChoiceFinding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.ruleID = _data["ruleID"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SubjectChoiceFinding {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectChoiceFinding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["ruleID"] = this.ruleID;
        data["message"] = this.message;
        return data;
    }
}

export interface ISubjectChoiceFinding {
    kind?: string | undefined;
    ruleID?: string | undefined;
    message?: string | undefined;
}

export class SubjectChoiceCorequisiteModel implements ISubjectChoiceCorequisiteModel {
    moduleID?: string | undefined;
    requiredModuleID?: string | undefined;

    constructor(data?: ISubjectChoiceCorequisiteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleID = _data["moduleID"];
            this.requiredModuleID = _data["requiredModuleID"];
        }
    }

    static fromJS(data: any): SubjectChoiceCorequisiteModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectChoiceCorequisiteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleID"] = this.moduleID;
        data["requiredModuleID"] = this.requiredModuleID;
        return data;
    }
}

export interface ISubjectChoiceCorequisiteModel {
    moduleID?: string | undefined;
    requiredModuleID?: string | undefined;
}

export class SubjectChoiceSaveResultModel implements ISubjectChoiceSaveResultModel {
    levelEnrollmentsCreated?: number;
    moduleEnrollmentsCreated?: number;
    moduleEnrollmentsReactivated?: number;
    moduleEnrollmentsDeactivated?: number;
    findings?: SubjectChoiceStudentFindingModel[] | undefined;

    constructor(data?: ISubjectChoiceSaveResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelEnrollmentsCreated = _data["levelEnrollmentsCreated"];
            this.moduleEnrollmentsCreated = _data["moduleEnrollmentsCreated"];
            this.moduleEnrollmentsReactivated = _data["moduleEnrollmentsReactivated"];
            this.moduleEnrollmentsDeactivated = _data["moduleEnrollmentsDeactivated"];
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(SubjectChoiceStudentFindingModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubjectChoiceSaveResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectChoiceSaveResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelEnrollmentsCreated"] = this.levelEnrollmentsCreated;
        data["moduleEnrollmentsCreated"] = this.moduleEnrollmentsCreated;
        data["moduleEnrollmentsReactivated"] = this.moduleEnrollmentsReactivated;
        data["moduleEnrollmentsDeactivated"] = this.moduleEnrollmentsDeactivated;
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubjectChoiceSaveResultModel {
    levelEnrollmentsCreated?: number;
    moduleEnrollmentsCreated?: number;
    moduleEnrollmentsReactivated?: number;
    moduleEnrollmentsDeactivated?: number;
    findings?: SubjectChoiceStudentFindingModel[] | undefined;
}

export class SubjectChoiceStudentFindingModel implements ISubjectChoiceStudentFindingModel {
    studentID?: string | undefined;
    kind?: string | undefined;
    ruleID?: string | undefined;
    message?: string | undefined;

    constructor(data?: ISubjectChoiceStudentFindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            this.kind = _data["kind"];
            this.ruleID = _data["ruleID"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SubjectChoiceStudentFindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectChoiceStudentFindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        data["kind"] = this.kind;
        data["ruleID"] = this.ruleID;
        data["message"] = this.message;
        return data;
    }
}

export interface ISubjectChoiceStudentFindingModel {
    studentID?: string | undefined;
    kind?: string | undefined;
    ruleID?: string | undefined;
    message?: string | undefined;
}

export class SaveSubjectChoicesModel implements ISaveSubjectChoicesModel {
    students?: StudentSubjectChoiceModel[] | undefined;

    constructor(data?: ISaveSubjectChoicesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["students"])) {
                this.students = [] as any;
                for (let item of _data["students"])
                    this.students!.push(StudentSubjectChoiceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveSubjectChoicesModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSubjectChoicesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.students)) {
            data["students"] = [];
            for (let item of this.students)
                data["students"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveSubjectChoicesModel {
    students?: StudentSubjectChoiceModel[] | undefined;
}

export class StudentSubjectChoiceModel implements IStudentSubjectChoiceModel {
    studentID?: string | undefined;
    moduleIDs?: string[] | undefined;

    constructor(data?: IStudentSubjectChoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            if (Array.isArray(_data["moduleIDs"])) {
                this.moduleIDs = [] as any;
                for (let item of _data["moduleIDs"])
                    this.moduleIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): StudentSubjectChoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudentSubjectChoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        if (Array.isArray(this.moduleIDs)) {
            data["moduleIDs"] = [];
            for (let item of this.moduleIDs)
                data["moduleIDs"].push(item);
        }
        return data;
    }
}

export interface IStudentSubjectChoiceModel {
    studentID?: string | undefined;
    moduleIDs?: string[] | undefined;
}

export class AssessmentStructureTreeModel implements IAssessmentStructureTreeModel {
    qualificationModuleID?: string | undefined;
    groups?: AssessmentGroupModel[] | undefined;
    assessments?: AssessmentModel[] | undefined;

    constructor(data?: IAssessmentStructureTreeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(AssessmentGroupModel.fromJS(item));
            }
            if (Array.isArray(_data["assessments"])) {
                this.assessments = [] as any;
                for (let item of _data["assessments"])
                    this.assessments!.push(AssessmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentStructureTreeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentStructureTreeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.assessments)) {
            data["assessments"] = [];
            for (let item of this.assessments)
                data["assessments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssessmentStructureTreeModel {
    qualificationModuleID?: string | undefined;
    groups?: AssessmentGroupModel[] | undefined;
    assessments?: AssessmentModel[] | undefined;
}

export class AssessmentGroupModel implements IAssessmentGroupModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    qualificationModuleID?: string | undefined;
    parentGroupID?: string | undefined;
    assessmentGroupTypeID?: string | undefined;
    assessmentGroupTypeName?: string | undefined;
    depth?: number;

    constructor(data?: IAssessmentGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.parentGroupID = _data["parentGroupID"];
            this.assessmentGroupTypeID = _data["assessmentGroupTypeID"];
            this.assessmentGroupTypeName = _data["assessmentGroupTypeName"];
            this.depth = _data["depth"];
        }
    }

    static fromJS(data: any): AssessmentGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["parentGroupID"] = this.parentGroupID;
        data["assessmentGroupTypeID"] = this.assessmentGroupTypeID;
        data["assessmentGroupTypeName"] = this.assessmentGroupTypeName;
        data["depth"] = this.depth;
        return data;
    }
}

export interface IAssessmentGroupModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    qualificationModuleID?: string | undefined;
    parentGroupID?: string | undefined;
    assessmentGroupTypeID?: string | undefined;
    assessmentGroupTypeName?: string | undefined;
    depth?: number;
}

export class AssessmentModel implements IAssessmentModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    groupID?: string | undefined;
    assessmentTypeID?: string | undefined;
    assessmentTypeName?: string | undefined;
    total?: number;

    constructor(data?: IAssessmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.groupID = _data["groupID"];
            this.assessmentTypeID = _data["assessmentTypeID"];
            this.assessmentTypeName = _data["assessmentTypeName"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): AssessmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["groupID"] = this.groupID;
        data["assessmentTypeID"] = this.assessmentTypeID;
        data["assessmentTypeName"] = this.assessmentTypeName;
        data["total"] = this.total;
        return data;
    }
}

export interface IAssessmentModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    groupID?: string | undefined;
    assessmentTypeID?: string | undefined;
    assessmentTypeName?: string | undefined;
    total?: number;
}

export class AssessmentGroupWriteModel implements IAssessmentGroupWriteModel {
    name?: string | undefined;
    description?: string | undefined;
    assessmentGroupTypeID?: string | undefined;
    qualificationModuleID?: string | undefined;
    parentGroupID?: string | undefined;

    constructor(data?: IAssessmentGroupWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.assessmentGroupTypeID = _data["assessmentGroupTypeID"];
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.parentGroupID = _data["parentGroupID"];
        }
    }

    static fromJS(data: any): AssessmentGroupWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentGroupWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["assessmentGroupTypeID"] = this.assessmentGroupTypeID;
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["parentGroupID"] = this.parentGroupID;
        return data;
    }
}

export interface IAssessmentGroupWriteModel {
    name?: string | undefined;
    description?: string | undefined;
    assessmentGroupTypeID?: string | undefined;
    qualificationModuleID?: string | undefined;
    parentGroupID?: string | undefined;
}

export class AssessmentGroupUpdateModel implements IAssessmentGroupUpdateModel {
    name?: string | undefined;
    description?: string | undefined;
    assessmentGroupTypeID?: string | undefined;

    constructor(data?: IAssessmentGroupUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.assessmentGroupTypeID = _data["assessmentGroupTypeID"];
        }
    }

    static fromJS(data: any): AssessmentGroupUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentGroupUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["assessmentGroupTypeID"] = this.assessmentGroupTypeID;
        return data;
    }
}

export interface IAssessmentGroupUpdateModel {
    name?: string | undefined;
    description?: string | undefined;
    assessmentGroupTypeID?: string | undefined;
}

export class MoveAssessmentGroupModel implements IMoveAssessmentGroupModel {
    parentGroupID?: string | undefined;

    constructor(data?: IMoveAssessmentGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentGroupID = _data["parentGroupID"];
        }
    }

    static fromJS(data: any): MoveAssessmentGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new MoveAssessmentGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentGroupID"] = this.parentGroupID;
        return data;
    }
}

export interface IMoveAssessmentGroupModel {
    parentGroupID?: string | undefined;
}

export class AssessmentWriteModel implements IAssessmentWriteModel {
    name?: string | undefined;
    description?: string | undefined;
    groupID?: string | undefined;
    assessmentTypeID?: string | undefined;
    total?: number;

    constructor(data?: IAssessmentWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.groupID = _data["groupID"];
            this.assessmentTypeID = _data["assessmentTypeID"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): AssessmentWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["groupID"] = this.groupID;
        data["assessmentTypeID"] = this.assessmentTypeID;
        data["total"] = this.total;
        return data;
    }
}

export interface IAssessmentWriteModel {
    name?: string | undefined;
    description?: string | undefined;
    groupID?: string | undefined;
    assessmentTypeID?: string | undefined;
    total?: number;
}

export class AssessmentTypeModel implements IAssessmentTypeModel {
    id?: string | undefined;
    name?: string | undefined;
    isArchived?: boolean;

    constructor(data?: IAssessmentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): AssessmentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IAssessmentTypeModel {
    id?: string | undefined;
    name?: string | undefined;
    isArchived?: boolean;
}

export class AssessmentTypeWriteModel implements IAssessmentTypeWriteModel {
    name?: string | undefined;

    constructor(data?: IAssessmentTypeWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AssessmentTypeWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentTypeWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IAssessmentTypeWriteModel {
    name?: string | undefined;
}

export class SetAssessmentTypeModel implements ISetAssessmentTypeModel {
    typeID?: string | undefined;

    constructor(data?: ISetAssessmentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeID = _data["typeID"];
        }
    }

    static fromJS(data: any): SetAssessmentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetAssessmentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeID"] = this.typeID;
        return data;
    }
}

export interface ISetAssessmentTypeModel {
    typeID?: string | undefined;
}

export class MarkTypeModel implements IMarkTypeModel {
    id?: string | undefined;
    name?: string | undefined;
    gradeScaleID?: string | undefined;
    gradeScaleName?: string | undefined;

    constructor(data?: IMarkTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.gradeScaleID = _data["gradeScaleID"];
            this.gradeScaleName = _data["gradeScaleName"];
        }
    }

    static fromJS(data: any): MarkTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["gradeScaleID"] = this.gradeScaleID;
        data["gradeScaleName"] = this.gradeScaleName;
        return data;
    }
}

export interface IMarkTypeModel {
    id?: string | undefined;
    name?: string | undefined;
    gradeScaleID?: string | undefined;
    gradeScaleName?: string | undefined;
}

export class MarkTypeWriteModel implements IMarkTypeWriteModel {
    name?: string | undefined;
    gradeScaleID?: string | undefined;

    constructor(data?: IMarkTypeWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.gradeScaleID = _data["gradeScaleID"];
        }
    }

    static fromJS(data: any): MarkTypeWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkTypeWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["gradeScaleID"] = this.gradeScaleID;
        return data;
    }
}

export interface IMarkTypeWriteModel {
    name?: string | undefined;
    gradeScaleID?: string | undefined;
}

export class CommentTypeModel implements ICommentTypeModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICommentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CommentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICommentTypeModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class CommentTypeWriteModel implements ICommentTypeWriteModel {
    name?: string | undefined;

    constructor(data?: ICommentTypeWriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CommentTypeWriteModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommentTypeWriteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICommentTypeWriteModel {
    name?: string | undefined;
}

export class CommentResultModel implements ICommentResultModel {
    id?: string | undefined;
    studentID?: string | undefined;
    result?: string | undefined;
    assessmentEntityType?: string | undefined;
    assessmentEntityID?: string | undefined;
    commentTypeID?: string | undefined;
    commentTypeName?: string | undefined;

    constructor(data?: ICommentResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentID = _data["studentID"];
            this.result = _data["result"];
            this.assessmentEntityType = _data["assessmentEntityType"];
            this.assessmentEntityID = _data["assessmentEntityID"];
            this.commentTypeID = _data["commentTypeID"];
            this.commentTypeName = _data["commentTypeName"];
        }
    }

    static fromJS(data: any): CommentResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommentResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentID"] = this.studentID;
        data["result"] = this.result;
        data["assessmentEntityType"] = this.assessmentEntityType;
        data["assessmentEntityID"] = this.assessmentEntityID;
        data["commentTypeID"] = this.commentTypeID;
        data["commentTypeName"] = this.commentTypeName;
        return data;
    }
}

export interface ICommentResultModel {
    id?: string | undefined;
    studentID?: string | undefined;
    result?: string | undefined;
    assessmentEntityType?: string | undefined;
    assessmentEntityID?: string | undefined;
    commentTypeID?: string | undefined;
    commentTypeName?: string | undefined;
}

export class CommentBatchModel implements ICommentBatchModel {
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    commentTypeID?: string | undefined;
    teachingGroupID?: string | undefined;
    entries?: CommentEntryModel[] | undefined;

    constructor(data?: ICommentBatchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.commentTypeID = _data["commentTypeID"];
            this.teachingGroupID = _data["teachingGroupID"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(CommentEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommentBatchModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommentBatchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["commentTypeID"] = this.commentTypeID;
        data["teachingGroupID"] = this.teachingGroupID;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommentBatchModel {
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    commentTypeID?: string | undefined;
    teachingGroupID?: string | undefined;
    entries?: CommentEntryModel[] | undefined;
}

export class CommentEntryModel implements ICommentEntryModel {
    studentID?: string | undefined;
    result?: string | undefined;

    constructor(data?: ICommentEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): CommentEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommentEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        data["result"] = this.result;
        return data;
    }
}

export interface ICommentEntryModel {
    studentID?: string | undefined;
    result?: string | undefined;
}

export class ManualMarkBatchResultModel implements IManualMarkBatchResultModel {
    results?: ManualMarkResultModel[] | undefined;
    recalculationFindings?: CalculationFinding[] | undefined;

    constructor(data?: IManualMarkBatchResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ManualMarkResultModel.fromJS(item));
            }
            if (Array.isArray(_data["recalculationFindings"])) {
                this.recalculationFindings = [] as any;
                for (let item of _data["recalculationFindings"])
                    this.recalculationFindings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManualMarkBatchResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManualMarkBatchResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.recalculationFindings)) {
            data["recalculationFindings"] = [];
            for (let item of this.recalculationFindings)
                data["recalculationFindings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManualMarkBatchResultModel {
    results?: ManualMarkResultModel[] | undefined;
    recalculationFindings?: CalculationFinding[] | undefined;
}

export class ManualMarkResultModel implements IManualMarkResultModel {
    id?: string | undefined;
    studentID?: string | undefined;
    result?: number;
    total?: number;

    constructor(data?: IManualMarkResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentID = _data["studentID"];
            this.result = _data["result"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ManualMarkResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManualMarkResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentID"] = this.studentID;
        data["result"] = this.result;
        data["total"] = this.total;
        return data;
    }
}

export interface IManualMarkResultModel {
    id?: string | undefined;
    studentID?: string | undefined;
    result?: number;
    total?: number;
}

export class ManualMarkBatchModel implements IManualMarkBatchModel {
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    markTypeID?: string | undefined;
    teachingGroupID?: string | undefined;
    entries?: ManualMarkEntryModel[] | undefined;

    constructor(data?: IManualMarkBatchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.markTypeID = _data["markTypeID"];
            this.teachingGroupID = _data["teachingGroupID"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(ManualMarkEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManualMarkBatchModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManualMarkBatchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["markTypeID"] = this.markTypeID;
        data["teachingGroupID"] = this.teachingGroupID;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManualMarkBatchModel {
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    markTypeID?: string | undefined;
    teachingGroupID?: string | undefined;
    entries?: ManualMarkEntryModel[] | undefined;
}

export class ManualMarkEntryModel implements IManualMarkEntryModel {
    studentID?: string | undefined;
    result?: number;
    total?: number | undefined;

    constructor(data?: IManualMarkEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            this.result = _data["result"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ManualMarkEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManualMarkEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        data["result"] = this.result;
        data["total"] = this.total;
        return data;
    }
}

export interface IManualMarkEntryModel {
    studentID?: string | undefined;
    result?: number;
    total?: number | undefined;
}

export class MarkExplanationModel implements IMarkExplanationModel {
    markResultID?: string | undefined;
    schemaVersion?: number;
    calculatedAt?: Date | undefined;
    assignmentID?: string | undefined;
    procedureVersionID?: string | undefined;
    procedureName?: string | undefined;
    versionNumber?: number | undefined;
    calculationMethod?: string | undefined;
    missingMarkPolicy?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    markTypeID?: string | undefined;
    result?: number | undefined;
    total?: number | undefined;
    inputs?: MarkExplanationInputModel[] | undefined;
    warnings?: MarkExplanationWarningModel[] | undefined;

    constructor(data?: IMarkExplanationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.markResultID = _data["markResultID"];
            this.schemaVersion = _data["schemaVersion"];
            this.calculatedAt = _data["calculatedAt"] ? new Date(_data["calculatedAt"].toString()) : <any>undefined;
            this.assignmentID = _data["assignmentID"];
            this.procedureVersionID = _data["procedureVersionID"];
            this.procedureName = _data["procedureName"];
            this.versionNumber = _data["versionNumber"];
            this.calculationMethod = _data["calculationMethod"];
            this.missingMarkPolicy = _data["missingMarkPolicy"];
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.markTypeID = _data["markTypeID"];
            this.result = _data["result"];
            this.total = _data["total"];
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(MarkExplanationInputModel.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(MarkExplanationWarningModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkExplanationModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkExplanationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["markResultID"] = this.markResultID;
        data["schemaVersion"] = this.schemaVersion;
        data["calculatedAt"] = this.calculatedAt ? this.calculatedAt.toISOString() : <any>undefined;
        data["assignmentID"] = this.assignmentID;
        data["procedureVersionID"] = this.procedureVersionID;
        data["procedureName"] = this.procedureName;
        data["versionNumber"] = this.versionNumber;
        data["calculationMethod"] = this.calculationMethod;
        data["missingMarkPolicy"] = this.missingMarkPolicy;
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["markTypeID"] = this.markTypeID;
        data["result"] = this.result;
        data["total"] = this.total;
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkExplanationModel {
    markResultID?: string | undefined;
    schemaVersion?: number;
    calculatedAt?: Date | undefined;
    assignmentID?: string | undefined;
    procedureVersionID?: string | undefined;
    procedureName?: string | undefined;
    versionNumber?: number | undefined;
    calculationMethod?: string | undefined;
    missingMarkPolicy?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    markTypeID?: string | undefined;
    result?: number | undefined;
    total?: number | undefined;
    inputs?: MarkExplanationInputModel[] | undefined;
    warnings?: MarkExplanationWarningModel[] | undefined;
}

export class MarkExplanationInputModel implements IMarkExplanationInputModel {
    ruleID?: string | undefined;
    entityType?: string | undefined;
    entityID?: string | undefined;
    name?: string | undefined;
    markTypeID?: string | undefined;
    result?: number | undefined;
    effectiveTotal?: number | undefined;
    weight?: number;
    included?: boolean;
    finalizationStatus?: string | undefined;

    constructor(data?: IMarkExplanationInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleID = _data["ruleID"];
            this.entityType = _data["entityType"];
            this.entityID = _data["entityID"];
            this.name = _data["name"];
            this.markTypeID = _data["markTypeID"];
            this.result = _data["result"];
            this.effectiveTotal = _data["effectiveTotal"];
            this.weight = _data["weight"];
            this.included = _data["included"];
            this.finalizationStatus = _data["finalizationStatus"];
        }
    }

    static fromJS(data: any): MarkExplanationInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkExplanationInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleID"] = this.ruleID;
        data["entityType"] = this.entityType;
        data["entityID"] = this.entityID;
        data["name"] = this.name;
        data["markTypeID"] = this.markTypeID;
        data["result"] = this.result;
        data["effectiveTotal"] = this.effectiveTotal;
        data["weight"] = this.weight;
        data["included"] = this.included;
        data["finalizationStatus"] = this.finalizationStatus;
        return data;
    }
}

export interface IMarkExplanationInputModel {
    ruleID?: string | undefined;
    entityType?: string | undefined;
    entityID?: string | undefined;
    name?: string | undefined;
    markTypeID?: string | undefined;
    result?: number | undefined;
    effectiveTotal?: number | undefined;
    weight?: number;
    included?: boolean;
    finalizationStatus?: string | undefined;
}

export class MarkExplanationWarningModel implements IMarkExplanationWarningModel {
    code?: string | undefined;
    severity?: string | undefined;
    message?: string | undefined;

    constructor(data?: IMarkExplanationWarningModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.severity = _data["severity"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): MarkExplanationWarningModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkExplanationWarningModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["severity"] = this.severity;
        data["message"] = this.message;
        return data;
    }
}

export interface IMarkExplanationWarningModel {
    code?: string | undefined;
    severity?: string | undefined;
    message?: string | undefined;
}

export class MarkEntrySheetModel implements IMarkEntrySheetModel {
    qualificationModuleID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    targetName?: string | undefined;
    markTypeID?: string | undefined;
    markTypeName?: string | undefined;
    totalIsFixed?: boolean;
    fixedTotal?: number | undefined;
    rows?: MarkEntrySheetRowModel[] | undefined;

    constructor(data?: IMarkEntrySheetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.targetName = _data["targetName"];
            this.markTypeID = _data["markTypeID"];
            this.markTypeName = _data["markTypeName"];
            this.totalIsFixed = _data["totalIsFixed"];
            this.fixedTotal = _data["fixedTotal"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MarkEntrySheetRowModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkEntrySheetModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkEntrySheetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["targetName"] = this.targetName;
        data["markTypeID"] = this.markTypeID;
        data["markTypeName"] = this.markTypeName;
        data["totalIsFixed"] = this.totalIsFixed;
        data["fixedTotal"] = this.fixedTotal;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkEntrySheetModel {
    qualificationModuleID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    targetName?: string | undefined;
    markTypeID?: string | undefined;
    markTypeName?: string | undefined;
    totalIsFixed?: boolean;
    fixedTotal?: number | undefined;
    rows?: MarkEntrySheetRowModel[] | undefined;
}

export class MarkEntrySheetRowModel implements IMarkEntrySheetRowModel {
    studentID?: string | undefined;
    enrollmentStatus?: string | undefined;
    markResultID?: string | undefined;
    result?: number | undefined;
    total?: number | undefined;
    resultOrigin?: string | undefined;
    finalizationStatus?: string | undefined;
    moderationStatus?: string | undefined;
    moderationComment?: string | undefined;
    gradeCode?: string | undefined;
    gradeName?: string | undefined;
    isEditable?: boolean;
    notEditableReason?: string | undefined;

    constructor(data?: IMarkEntrySheetRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            this.enrollmentStatus = _data["enrollmentStatus"];
            this.markResultID = _data["markResultID"];
            this.result = _data["result"];
            this.total = _data["total"];
            this.resultOrigin = _data["resultOrigin"];
            this.finalizationStatus = _data["finalizationStatus"];
            this.moderationStatus = _data["moderationStatus"];
            this.moderationComment = _data["moderationComment"];
            this.gradeCode = _data["gradeCode"];
            this.gradeName = _data["gradeName"];
            this.isEditable = _data["isEditable"];
            this.notEditableReason = _data["notEditableReason"];
        }
    }

    static fromJS(data: any): MarkEntrySheetRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkEntrySheetRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        data["enrollmentStatus"] = this.enrollmentStatus;
        data["markResultID"] = this.markResultID;
        data["result"] = this.result;
        data["total"] = this.total;
        data["resultOrigin"] = this.resultOrigin;
        data["finalizationStatus"] = this.finalizationStatus;
        data["moderationStatus"] = this.moderationStatus;
        data["moderationComment"] = this.moderationComment;
        data["gradeCode"] = this.gradeCode;
        data["gradeName"] = this.gradeName;
        data["isEditable"] = this.isEditable;
        data["notEditableReason"] = this.notEditableReason;
        return data;
    }
}

export interface IMarkEntrySheetRowModel {
    studentID?: string | undefined;
    enrollmentStatus?: string | undefined;
    markResultID?: string | undefined;
    result?: number | undefined;
    total?: number | undefined;
    resultOrigin?: string | undefined;
    finalizationStatus?: string | undefined;
    moderationStatus?: string | undefined;
    moderationComment?: string | undefined;
    gradeCode?: string | undefined;
    gradeName?: string | undefined;
    isEditable?: boolean;
    notEditableReason?: string | undefined;
}

export class MarkEntrySheetRequest implements IMarkEntrySheetRequest {
    qualificationModuleID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    markTypeID?: string | undefined;
    teachingGroupID?: string | undefined;
    includeInactive?: boolean;

    constructor(data?: IMarkEntrySheetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.markTypeID = _data["markTypeID"];
            this.teachingGroupID = _data["teachingGroupID"];
            this.includeInactive = _data["includeInactive"];
        }
    }

    static fromJS(data: any): MarkEntrySheetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkEntrySheetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["markTypeID"] = this.markTypeID;
        data["teachingGroupID"] = this.teachingGroupID;
        data["includeInactive"] = this.includeInactive;
        return data;
    }
}

export interface IMarkEntrySheetRequest {
    qualificationModuleID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    markTypeID?: string | undefined;
    teachingGroupID?: string | undefined;
    includeInactive?: boolean;
}

export class MarkGridDeletedModel implements IMarkGridDeletedModel {
    id?: string | undefined;
    removedMarks?: number;
    removedComments?: number;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: IMarkGridDeletedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.removedMarks = _data["removedMarks"];
            this.removedComments = _data["removedComments"];
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridDeletedModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridDeletedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["removedMarks"] = this.removedMarks;
        data["removedComments"] = this.removedComments;
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridDeletedModel {
    id?: string | undefined;
    removedMarks?: number;
    removedComments?: number;
    findings?: CalculationFinding[] | undefined;
}

export class MarkGridSubjectListModel implements IMarkGridSubjectListModel {
    scoped?: boolean;
    subjects?: MarkGridSubjectModel[] | undefined;

    constructor(data?: IMarkGridSubjectListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoped = _data["scoped"];
            if (Array.isArray(_data["subjects"])) {
                this.subjects = [] as any;
                for (let item of _data["subjects"])
                    this.subjects!.push(MarkGridSubjectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridSubjectListModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridSubjectListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scoped"] = this.scoped;
        if (Array.isArray(this.subjects)) {
            data["subjects"] = [];
            for (let item of this.subjects)
                data["subjects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridSubjectListModel {
    scoped?: boolean;
    subjects?: MarkGridSubjectModel[] | undefined;
}

export class MarkGridSubjectModel implements IMarkGridSubjectModel {
    moduleID?: string | undefined;
    qualificationProgramLevelID?: string | undefined;
    moduleName?: string | undefined;
    levelName?: string | undefined;
    currentQualificationModuleID?: string | undefined;
    terms?: MarkGridTermModel[] | undefined;

    constructor(data?: IMarkGridSubjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleID = _data["moduleID"];
            this.qualificationProgramLevelID = _data["qualificationProgramLevelID"];
            this.moduleName = _data["moduleName"];
            this.levelName = _data["levelName"];
            this.currentQualificationModuleID = _data["currentQualificationModuleID"];
            if (Array.isArray(_data["terms"])) {
                this.terms = [] as any;
                for (let item of _data["terms"])
                    this.terms!.push(MarkGridTermModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridSubjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridSubjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleID"] = this.moduleID;
        data["qualificationProgramLevelID"] = this.qualificationProgramLevelID;
        data["moduleName"] = this.moduleName;
        data["levelName"] = this.levelName;
        data["currentQualificationModuleID"] = this.currentQualificationModuleID;
        if (Array.isArray(this.terms)) {
            data["terms"] = [];
            for (let item of this.terms)
                data["terms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridSubjectModel {
    moduleID?: string | undefined;
    qualificationProgramLevelID?: string | undefined;
    moduleName?: string | undefined;
    levelName?: string | undefined;
    currentQualificationModuleID?: string | undefined;
    terms?: MarkGridTermModel[] | undefined;
}

export class MarkGridTermModel implements IMarkGridTermModel {
    qualificationModuleID?: string | undefined;
    cycleName?: string | undefined;
    cycleRank?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isCurrent?: boolean;
    studentCount?: number;
    myTeachingGroups?: MarkGridTeachingGroupModel[] | undefined;

    constructor(data?: IMarkGridTermModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.cycleName = _data["cycleName"];
            this.cycleRank = _data["cycleRank"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isCurrent = _data["isCurrent"];
            this.studentCount = _data["studentCount"];
            if (Array.isArray(_data["myTeachingGroups"])) {
                this.myTeachingGroups = [] as any;
                for (let item of _data["myTeachingGroups"])
                    this.myTeachingGroups!.push(MarkGridTeachingGroupModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridTermModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridTermModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["cycleName"] = this.cycleName;
        data["cycleRank"] = this.cycleRank;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isCurrent"] = this.isCurrent;
        data["studentCount"] = this.studentCount;
        if (Array.isArray(this.myTeachingGroups)) {
            data["myTeachingGroups"] = [];
            for (let item of this.myTeachingGroups)
                data["myTeachingGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridTermModel {
    qualificationModuleID?: string | undefined;
    cycleName?: string | undefined;
    cycleRank?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isCurrent?: boolean;
    studentCount?: number;
    myTeachingGroups?: MarkGridTeachingGroupModel[] | undefined;
}

export class MarkGridTeachingGroupModel implements IMarkGridTeachingGroupModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IMarkGridTeachingGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MarkGridTeachingGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridTeachingGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMarkGridTeachingGroupModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class MarkGridCommentsModel implements IMarkGridCommentsModel {
    qualificationModuleID?: string | undefined;
    maxLength?: number;
    commentTypes?: MarkGridCommentTypeModel[] | undefined;
    rows?: MarkGridCommentRowModel[] | undefined;

    constructor(data?: IMarkGridCommentsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.maxLength = _data["maxLength"];
            if (Array.isArray(_data["commentTypes"])) {
                this.commentTypes = [] as any;
                for (let item of _data["commentTypes"])
                    this.commentTypes!.push(MarkGridCommentTypeModel.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MarkGridCommentRowModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridCommentsModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridCommentsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["maxLength"] = this.maxLength;
        if (Array.isArray(this.commentTypes)) {
            data["commentTypes"] = [];
            for (let item of this.commentTypes)
                data["commentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridCommentsModel {
    qualificationModuleID?: string | undefined;
    maxLength?: number;
    commentTypes?: MarkGridCommentTypeModel[] | undefined;
    rows?: MarkGridCommentRowModel[] | undefined;
}

export class MarkGridCommentTypeModel implements IMarkGridCommentTypeModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IMarkGridCommentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MarkGridCommentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridCommentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMarkGridCommentTypeModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class MarkGridCommentRowModel implements IMarkGridCommentRowModel {
    studentID?: string | undefined;
    enrollmentStatus?: string | undefined;
    comments?: { [key: string]: string; } | undefined;

    constructor(data?: IMarkGridCommentRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            this.enrollmentStatus = _data["enrollmentStatus"];
            if (_data["comments"]) {
                this.comments = {} as any;
                for (let key in _data["comments"]) {
                    if (_data["comments"].hasOwnProperty(key))
                        (<any>this.comments)![key] = _data["comments"][key];
                }
            }
        }
    }

    static fromJS(data: any): MarkGridCommentRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridCommentRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        data["enrollmentStatus"] = this.enrollmentStatus;
        if (this.comments) {
            data["comments"] = {};
            for (let key in this.comments) {
                if (this.comments.hasOwnProperty(key))
                    (<any>data["comments"])[key] = (<any>this.comments)[key];
            }
        }
        return data;
    }
}

export interface IMarkGridCommentRowModel {
    studentID?: string | undefined;
    enrollmentStatus?: string | undefined;
    comments?: { [key: string]: string; } | undefined;
}

export class MarkGridCommentSaveResultModel implements IMarkGridCommentSaveResultModel {
    savedComments?: number;

    constructor(data?: IMarkGridCommentSaveResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.savedComments = _data["savedComments"];
        }
    }

    static fromJS(data: any): MarkGridCommentSaveResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridCommentSaveResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["savedComments"] = this.savedComments;
        return data;
    }
}

export interface IMarkGridCommentSaveResultModel {
    savedComments?: number;
}

export class MarkGridCommentSaveRequest implements IMarkGridCommentSaveRequest {
    qualificationModuleID?: string | undefined;
    teachingGroupID?: string | undefined;
    columns?: MarkGridCommentColumnModel[] | undefined;

    constructor(data?: IMarkGridCommentSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.teachingGroupID = _data["teachingGroupID"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(MarkGridCommentColumnModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridCommentSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridCommentSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["teachingGroupID"] = this.teachingGroupID;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridCommentSaveRequest {
    qualificationModuleID?: string | undefined;
    teachingGroupID?: string | undefined;
    columns?: MarkGridCommentColumnModel[] | undefined;
}

export class MarkGridCommentColumnModel implements IMarkGridCommentColumnModel {
    commentTypeID?: string | undefined;
    entries?: CommentEntryModel[] | undefined;

    constructor(data?: IMarkGridCommentColumnModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentTypeID = _data["commentTypeID"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(CommentEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridCommentColumnModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridCommentColumnModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentTypeID"] = this.commentTypeID;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridCommentColumnModel {
    commentTypeID?: string | undefined;
    entries?: CommentEntryModel[] | undefined;
}

export class MarkGridOverviewModel implements IMarkGridOverviewModel {
    qualificationModuleID?: string | undefined;
    moduleName?: string | undefined;
    levelName?: string | undefined;
    cycleName?: string | undefined;
    groupID?: string | undefined;
    groupName?: string | undefined;
    path?: MarkGridPathModel[] | undefined;
    resultMarkTypeID?: string | undefined;
    resultMarkTypeName?: string | undefined;
    studentCount?: number;
    resultCount?: number;
    average?: number | undefined;
    standardDeviation?: number | undefined;
    passMark?: number | undefined;
    passMarkIsPercent?: boolean;
    passRate?: number | undefined;
    distribution?: number[] | undefined;
    children?: MarkGridNodeModel[] | undefined;
    terms?: MarkGridSiblingTermModel[] | undefined;

    constructor(data?: IMarkGridOverviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.moduleName = _data["moduleName"];
            this.levelName = _data["levelName"];
            this.cycleName = _data["cycleName"];
            this.groupID = _data["groupID"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(MarkGridPathModel.fromJS(item));
            }
            this.resultMarkTypeID = _data["resultMarkTypeID"];
            this.resultMarkTypeName = _data["resultMarkTypeName"];
            this.studentCount = _data["studentCount"];
            this.resultCount = _data["resultCount"];
            this.average = _data["average"];
            this.standardDeviation = _data["standardDeviation"];
            this.passMark = _data["passMark"];
            this.passMarkIsPercent = _data["passMarkIsPercent"];
            this.passRate = _data["passRate"];
            if (Array.isArray(_data["distribution"])) {
                this.distribution = [] as any;
                for (let item of _data["distribution"])
                    this.distribution!.push(item);
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(MarkGridNodeModel.fromJS(item));
            }
            if (Array.isArray(_data["terms"])) {
                this.terms = [] as any;
                for (let item of _data["terms"])
                    this.terms!.push(MarkGridSiblingTermModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridOverviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridOverviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["moduleName"] = this.moduleName;
        data["levelName"] = this.levelName;
        data["cycleName"] = this.cycleName;
        data["groupID"] = this.groupID;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item.toJSON());
        }
        data["resultMarkTypeID"] = this.resultMarkTypeID;
        data["resultMarkTypeName"] = this.resultMarkTypeName;
        data["studentCount"] = this.studentCount;
        data["resultCount"] = this.resultCount;
        data["average"] = this.average;
        data["standardDeviation"] = this.standardDeviation;
        data["passMark"] = this.passMark;
        data["passMarkIsPercent"] = this.passMarkIsPercent;
        data["passRate"] = this.passRate;
        if (Array.isArray(this.distribution)) {
            data["distribution"] = [];
            for (let item of this.distribution)
                data["distribution"].push(item);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.terms)) {
            data["terms"] = [];
            for (let item of this.terms)
                data["terms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridOverviewModel {
    qualificationModuleID?: string | undefined;
    moduleName?: string | undefined;
    levelName?: string | undefined;
    cycleName?: string | undefined;
    groupID?: string | undefined;
    groupName?: string | undefined;
    path?: MarkGridPathModel[] | undefined;
    resultMarkTypeID?: string | undefined;
    resultMarkTypeName?: string | undefined;
    studentCount?: number;
    resultCount?: number;
    average?: number | undefined;
    standardDeviation?: number | undefined;
    passMark?: number | undefined;
    passMarkIsPercent?: boolean;
    passRate?: number | undefined;
    distribution?: number[] | undefined;
    children?: MarkGridNodeModel[] | undefined;
    terms?: MarkGridSiblingTermModel[] | undefined;
}

export class MarkGridPathModel implements IMarkGridPathModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IMarkGridPathModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MarkGridPathModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridPathModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMarkGridPathModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class MarkGridNodeModel implements IMarkGridNodeModel {
    entityType?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    typeName?: string | undefined;
    total?: number | undefined;
    weightPercent?: number | undefined;
    counted?: boolean;
    assessmentCount?: number;
    groupCount?: number;
    resultCount?: number;
    average?: number | undefined;
    standardDeviation?: number | undefined;

    constructor(data?: IMarkGridNodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.typeName = _data["typeName"];
            this.total = _data["total"];
            this.weightPercent = _data["weightPercent"];
            this.counted = _data["counted"];
            this.assessmentCount = _data["assessmentCount"];
            this.groupCount = _data["groupCount"];
            this.resultCount = _data["resultCount"];
            this.average = _data["average"];
            this.standardDeviation = _data["standardDeviation"];
        }
    }

    static fromJS(data: any): MarkGridNodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridNodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["id"] = this.id;
        data["name"] = this.name;
        data["typeName"] = this.typeName;
        data["total"] = this.total;
        data["weightPercent"] = this.weightPercent;
        data["counted"] = this.counted;
        data["assessmentCount"] = this.assessmentCount;
        data["groupCount"] = this.groupCount;
        data["resultCount"] = this.resultCount;
        data["average"] = this.average;
        data["standardDeviation"] = this.standardDeviation;
        return data;
    }
}

export interface IMarkGridNodeModel {
    entityType?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    typeName?: string | undefined;
    total?: number | undefined;
    weightPercent?: number | undefined;
    counted?: boolean;
    assessmentCount?: number;
    groupCount?: number;
    resultCount?: number;
    average?: number | undefined;
    standardDeviation?: number | undefined;
}

export class MarkGridSiblingTermModel implements IMarkGridSiblingTermModel {
    qualificationModuleID?: string | undefined;
    cycleName?: string | undefined;
    cycleRank?: number | undefined;
    isCurrent?: boolean;
    isViewing?: boolean;
    groupID?: string | undefined;
    teachingGroupID?: string | undefined;

    constructor(data?: IMarkGridSiblingTermModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.cycleName = _data["cycleName"];
            this.cycleRank = _data["cycleRank"];
            this.isCurrent = _data["isCurrent"];
            this.isViewing = _data["isViewing"];
            this.groupID = _data["groupID"];
            this.teachingGroupID = _data["teachingGroupID"];
        }
    }

    static fromJS(data: any): MarkGridSiblingTermModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridSiblingTermModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["cycleName"] = this.cycleName;
        data["cycleRank"] = this.cycleRank;
        data["isCurrent"] = this.isCurrent;
        data["isViewing"] = this.isViewing;
        data["groupID"] = this.groupID;
        data["teachingGroupID"] = this.teachingGroupID;
        return data;
    }
}

export interface IMarkGridSiblingTermModel {
    qualificationModuleID?: string | undefined;
    cycleName?: string | undefined;
    cycleRank?: number | undefined;
    isCurrent?: boolean;
    isViewing?: boolean;
    groupID?: string | undefined;
    teachingGroupID?: string | undefined;
}

export class MarkGridGroupTypeCoverageModel implements IMarkGridGroupTypeCoverageModel {
    assessmentGroupTypeID?: string | undefined;
    name?: string | undefined;
    counted?: boolean;

    constructor(data?: IMarkGridGroupTypeCoverageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentGroupTypeID = _data["assessmentGroupTypeID"];
            this.name = _data["name"];
            this.counted = _data["counted"];
        }
    }

    static fromJS(data: any): MarkGridGroupTypeCoverageModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridGroupTypeCoverageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentGroupTypeID"] = this.assessmentGroupTypeID;
        data["name"] = this.name;
        data["counted"] = this.counted;
        return data;
    }
}

export interface IMarkGridGroupTypeCoverageModel {
    assessmentGroupTypeID?: string | undefined;
    name?: string | undefined;
    counted?: boolean;
}

export class MarkGridSheetModel implements IMarkGridSheetModel {
    qualificationModuleID?: string | undefined;
    moduleName?: string | undefined;
    cycleName?: string | undefined;
    groupID?: string | undefined;
    groupName?: string | undefined;
    path?: MarkGridPathModel[] | undefined;
    entryMarkTypeID?: string | undefined;
    entryMarkTypeName?: string | undefined;
    markTypes?: MarkGridMarkTypeModel[] | undefined;
    columns?: MarkGridColumnModel[] | undefined;
    rows?: MarkGridRowModel[] | undefined;
    terms?: MarkGridSiblingTermModel[] | undefined;

    constructor(data?: IMarkGridSheetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.moduleName = _data["moduleName"];
            this.cycleName = _data["cycleName"];
            this.groupID = _data["groupID"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(MarkGridPathModel.fromJS(item));
            }
            this.entryMarkTypeID = _data["entryMarkTypeID"];
            this.entryMarkTypeName = _data["entryMarkTypeName"];
            if (Array.isArray(_data["markTypes"])) {
                this.markTypes = [] as any;
                for (let item of _data["markTypes"])
                    this.markTypes!.push(MarkGridMarkTypeModel.fromJS(item));
            }
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(MarkGridColumnModel.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MarkGridRowModel.fromJS(item));
            }
            if (Array.isArray(_data["terms"])) {
                this.terms = [] as any;
                for (let item of _data["terms"])
                    this.terms!.push(MarkGridSiblingTermModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridSheetModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridSheetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["moduleName"] = this.moduleName;
        data["cycleName"] = this.cycleName;
        data["groupID"] = this.groupID;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item.toJSON());
        }
        data["entryMarkTypeID"] = this.entryMarkTypeID;
        data["entryMarkTypeName"] = this.entryMarkTypeName;
        if (Array.isArray(this.markTypes)) {
            data["markTypes"] = [];
            for (let item of this.markTypes)
                data["markTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        if (Array.isArray(this.terms)) {
            data["terms"] = [];
            for (let item of this.terms)
                data["terms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridSheetModel {
    qualificationModuleID?: string | undefined;
    moduleName?: string | undefined;
    cycleName?: string | undefined;
    groupID?: string | undefined;
    groupName?: string | undefined;
    path?: MarkGridPathModel[] | undefined;
    entryMarkTypeID?: string | undefined;
    entryMarkTypeName?: string | undefined;
    markTypes?: MarkGridMarkTypeModel[] | undefined;
    columns?: MarkGridColumnModel[] | undefined;
    rows?: MarkGridRowModel[] | undefined;
    terms?: MarkGridSiblingTermModel[] | undefined;
}

export class MarkGridMarkTypeModel implements IMarkGridMarkTypeModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IMarkGridMarkTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MarkGridMarkTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridMarkTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMarkGridMarkTypeModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class MarkGridColumnModel implements IMarkGridColumnModel {
    key?: string | undefined;
    kind?: string | undefined;
    entityType?: string | undefined;
    entityID?: string | undefined;
    name?: string | undefined;
    groupName?: string | undefined;
    total?: number | undefined;
    weightPercent?: number | undefined;
    markTypeID?: string | undefined;
    markTypeName?: string | undefined;
    isEditable?: boolean;

    constructor(data?: IMarkGridColumnModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.kind = _data["kind"];
            this.entityType = _data["entityType"];
            this.entityID = _data["entityID"];
            this.name = _data["name"];
            this.groupName = _data["groupName"];
            this.total = _data["total"];
            this.weightPercent = _data["weightPercent"];
            this.markTypeID = _data["markTypeID"];
            this.markTypeName = _data["markTypeName"];
            this.isEditable = _data["isEditable"];
        }
    }

    static fromJS(data: any): MarkGridColumnModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridColumnModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["kind"] = this.kind;
        data["entityType"] = this.entityType;
        data["entityID"] = this.entityID;
        data["name"] = this.name;
        data["groupName"] = this.groupName;
        data["total"] = this.total;
        data["weightPercent"] = this.weightPercent;
        data["markTypeID"] = this.markTypeID;
        data["markTypeName"] = this.markTypeName;
        data["isEditable"] = this.isEditable;
        return data;
    }
}

export interface IMarkGridColumnModel {
    key?: string | undefined;
    kind?: string | undefined;
    entityType?: string | undefined;
    entityID?: string | undefined;
    name?: string | undefined;
    groupName?: string | undefined;
    total?: number | undefined;
    weightPercent?: number | undefined;
    markTypeID?: string | undefined;
    markTypeName?: string | undefined;
    isEditable?: boolean;
}

export class MarkGridRowModel implements IMarkGridRowModel {
    studentID?: string | undefined;
    enrollmentStatus?: string | undefined;
    cells?: { [key: string]: MarkGridCellModel; } | undefined;

    constructor(data?: IMarkGridRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            this.enrollmentStatus = _data["enrollmentStatus"];
            if (_data["cells"]) {
                this.cells = {} as any;
                for (let key in _data["cells"]) {
                    if (_data["cells"].hasOwnProperty(key))
                        (<any>this.cells)![key] = _data["cells"][key] ? MarkGridCellModel.fromJS(_data["cells"][key]) : new MarkGridCellModel();
                }
            }
        }
    }

    static fromJS(data: any): MarkGridRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        data["enrollmentStatus"] = this.enrollmentStatus;
        if (this.cells) {
            data["cells"] = {};
            for (let key in this.cells) {
                if (this.cells.hasOwnProperty(key))
                    (<any>data["cells"])[key] = this.cells[key] ? this.cells[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IMarkGridRowModel {
    studentID?: string | undefined;
    enrollmentStatus?: string | undefined;
    cells?: { [key: string]: MarkGridCellModel; } | undefined;
}

export class MarkGridCellModel implements IMarkGridCellModel {
    markResultID?: string | undefined;
    result?: number | undefined;
    total?: number | undefined;
    resultOrigin?: string | undefined;
    finalizationStatus?: string | undefined;
    moderationStatus?: string | undefined;
    moderationComment?: string | undefined;
    gradeCode?: string | undefined;
    gradeName?: string | undefined;
    isEditable?: boolean;
    notEditableReason?: string | undefined;

    constructor(data?: IMarkGridCellModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.markResultID = _data["markResultID"];
            this.result = _data["result"];
            this.total = _data["total"];
            this.resultOrigin = _data["resultOrigin"];
            this.finalizationStatus = _data["finalizationStatus"];
            this.moderationStatus = _data["moderationStatus"];
            this.moderationComment = _data["moderationComment"];
            this.gradeCode = _data["gradeCode"];
            this.gradeName = _data["gradeName"];
            this.isEditable = _data["isEditable"];
            this.notEditableReason = _data["notEditableReason"];
        }
    }

    static fromJS(data: any): MarkGridCellModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridCellModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["markResultID"] = this.markResultID;
        data["result"] = this.result;
        data["total"] = this.total;
        data["resultOrigin"] = this.resultOrigin;
        data["finalizationStatus"] = this.finalizationStatus;
        data["moderationStatus"] = this.moderationStatus;
        data["moderationComment"] = this.moderationComment;
        data["gradeCode"] = this.gradeCode;
        data["gradeName"] = this.gradeName;
        data["isEditable"] = this.isEditable;
        data["notEditableReason"] = this.notEditableReason;
        return data;
    }
}

export interface IMarkGridCellModel {
    markResultID?: string | undefined;
    result?: number | undefined;
    total?: number | undefined;
    resultOrigin?: string | undefined;
    finalizationStatus?: string | undefined;
    moderationStatus?: string | undefined;
    moderationComment?: string | undefined;
    gradeCode?: string | undefined;
    gradeName?: string | undefined;
    isEditable?: boolean;
    notEditableReason?: string | undefined;
}

export class MarkGridSheetRequest implements IMarkGridSheetRequest {
    qualificationModuleID?: string | undefined;
    groupID?: string | undefined;
    teachingGroupID?: string | undefined;
    includeInactive?: boolean;
    entryMarkTypeID?: string | undefined;

    constructor(data?: IMarkGridSheetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationModuleID = _data["qualificationModuleID"];
            this.groupID = _data["groupID"];
            this.teachingGroupID = _data["teachingGroupID"];
            this.includeInactive = _data["includeInactive"];
            this.entryMarkTypeID = _data["entryMarkTypeID"];
        }
    }

    static fromJS(data: any): MarkGridSheetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridSheetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationModuleID"] = this.qualificationModuleID;
        data["groupID"] = this.groupID;
        data["teachingGroupID"] = this.teachingGroupID;
        data["includeInactive"] = this.includeInactive;
        data["entryMarkTypeID"] = this.entryMarkTypeID;
        return data;
    }
}

export interface IMarkGridSheetRequest {
    qualificationModuleID?: string | undefined;
    groupID?: string | undefined;
    teachingGroupID?: string | undefined;
    includeInactive?: boolean;
    entryMarkTypeID?: string | undefined;
}

export class MarkGridSaveResultModel implements IMarkGridSaveResultModel {
    savedMarks?: number;
    recalculationFindings?: CalculationFinding[] | undefined;

    constructor(data?: IMarkGridSaveResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.savedMarks = _data["savedMarks"];
            if (Array.isArray(_data["recalculationFindings"])) {
                this.recalculationFindings = [] as any;
                for (let item of _data["recalculationFindings"])
                    this.recalculationFindings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridSaveResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridSaveResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["savedMarks"] = this.savedMarks;
        if (Array.isArray(this.recalculationFindings)) {
            data["recalculationFindings"] = [];
            for (let item of this.recalculationFindings)
                data["recalculationFindings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridSaveResultModel {
    savedMarks?: number;
    recalculationFindings?: CalculationFinding[] | undefined;
}

export class MarkGridSaveRequest implements IMarkGridSaveRequest {
    teachingGroupID?: string | undefined;
    columns?: MarkGridColumnEntriesModel[] | undefined;

    constructor(data?: IMarkGridSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teachingGroupID = _data["teachingGroupID"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(MarkGridColumnEntriesModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teachingGroupID"] = this.teachingGroupID;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridSaveRequest {
    teachingGroupID?: string | undefined;
    columns?: MarkGridColumnEntriesModel[] | undefined;
}

export class MarkGridColumnEntriesModel implements IMarkGridColumnEntriesModel {
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    markTypeID?: string | undefined;
    entries?: ManualMarkEntryModel[] | undefined;

    constructor(data?: IMarkGridColumnEntriesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.markTypeID = _data["markTypeID"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(ManualMarkEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridColumnEntriesModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridColumnEntriesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["markTypeID"] = this.markTypeID;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridColumnEntriesModel {
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    markTypeID?: string | undefined;
    entries?: ManualMarkEntryModel[] | undefined;
}

export class MarkGridCreatedModel implements IMarkGridCreatedModel {
    entityType?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    counted?: boolean;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: IMarkGridCreatedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.counted = _data["counted"];
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkGridCreatedModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkGridCreatedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["id"] = this.id;
        data["name"] = this.name;
        data["counted"] = this.counted;
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkGridCreatedModel {
    entityType?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    counted?: boolean;
    findings?: CalculationFinding[] | undefined;
}

export class MarkRemovalResultModel implements IMarkRemovalResultModel {
    studentID?: string | undefined;
    applied?: boolean;
    marksRemoved?: number;
    commentsRemoved?: number;
    finalizedPreserved?: number;
    marks?: MarkRemovalRowModel[] | undefined;
    comments?: MarkRemovalCommentRowModel[] | undefined;
    recalculationFindings?: CalculationFinding[] | undefined;

    constructor(data?: IMarkRemovalResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            this.applied = _data["applied"];
            this.marksRemoved = _data["marksRemoved"];
            this.commentsRemoved = _data["commentsRemoved"];
            this.finalizedPreserved = _data["finalizedPreserved"];
            if (Array.isArray(_data["marks"])) {
                this.marks = [] as any;
                for (let item of _data["marks"])
                    this.marks!.push(MarkRemovalRowModel.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(MarkRemovalCommentRowModel.fromJS(item));
            }
            if (Array.isArray(_data["recalculationFindings"])) {
                this.recalculationFindings = [] as any;
                for (let item of _data["recalculationFindings"])
                    this.recalculationFindings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkRemovalResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkRemovalResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        data["applied"] = this.applied;
        data["marksRemoved"] = this.marksRemoved;
        data["commentsRemoved"] = this.commentsRemoved;
        data["finalizedPreserved"] = this.finalizedPreserved;
        if (Array.isArray(this.marks)) {
            data["marks"] = [];
            for (let item of this.marks)
                data["marks"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.recalculationFindings)) {
            data["recalculationFindings"] = [];
            for (let item of this.recalculationFindings)
                data["recalculationFindings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkRemovalResultModel {
    studentID?: string | undefined;
    applied?: boolean;
    marksRemoved?: number;
    commentsRemoved?: number;
    finalizedPreserved?: number;
    marks?: MarkRemovalRowModel[] | undefined;
    comments?: MarkRemovalCommentRowModel[] | undefined;
    recalculationFindings?: CalculationFinding[] | undefined;
}

export class MarkRemovalRowModel implements IMarkRemovalRowModel {
    markResultID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    targetName?: string | undefined;
    markTypeID?: string | undefined;
    markTypeName?: string | undefined;
    result?: number;
    total?: number;
    resultOrigin?: string | undefined;
    finalizationStatus?: string | undefined;
    moderationStatus?: string | undefined;

    constructor(data?: IMarkRemovalRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.markResultID = _data["markResultID"];
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.targetName = _data["targetName"];
            this.markTypeID = _data["markTypeID"];
            this.markTypeName = _data["markTypeName"];
            this.result = _data["result"];
            this.total = _data["total"];
            this.resultOrigin = _data["resultOrigin"];
            this.finalizationStatus = _data["finalizationStatus"];
            this.moderationStatus = _data["moderationStatus"];
        }
    }

    static fromJS(data: any): MarkRemovalRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkRemovalRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["markResultID"] = this.markResultID;
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["targetName"] = this.targetName;
        data["markTypeID"] = this.markTypeID;
        data["markTypeName"] = this.markTypeName;
        data["result"] = this.result;
        data["total"] = this.total;
        data["resultOrigin"] = this.resultOrigin;
        data["finalizationStatus"] = this.finalizationStatus;
        data["moderationStatus"] = this.moderationStatus;
        return data;
    }
}

export interface IMarkRemovalRowModel {
    markResultID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    targetName?: string | undefined;
    markTypeID?: string | undefined;
    markTypeName?: string | undefined;
    result?: number;
    total?: number;
    resultOrigin?: string | undefined;
    finalizationStatus?: string | undefined;
    moderationStatus?: string | undefined;
}

export class MarkRemovalCommentRowModel implements IMarkRemovalCommentRowModel {
    commentResultID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    targetName?: string | undefined;
    commentTypeID?: string | undefined;
    commentTypeName?: string | undefined;

    constructor(data?: IMarkRemovalCommentRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentResultID = _data["commentResultID"];
            this.targetEntityType = _data["targetEntityType"];
            this.targetEntityID = _data["targetEntityID"];
            this.targetName = _data["targetName"];
            this.commentTypeID = _data["commentTypeID"];
            this.commentTypeName = _data["commentTypeName"];
        }
    }

    static fromJS(data: any): MarkRemovalCommentRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkRemovalCommentRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentResultID"] = this.commentResultID;
        data["targetEntityType"] = this.targetEntityType;
        data["targetEntityID"] = this.targetEntityID;
        data["targetName"] = this.targetName;
        data["commentTypeID"] = this.commentTypeID;
        data["commentTypeName"] = this.commentTypeName;
        return data;
    }
}

export interface IMarkRemovalCommentRowModel {
    commentResultID?: string | undefined;
    targetEntityType?: string | undefined;
    targetEntityID?: string | undefined;
    targetName?: string | undefined;
    commentTypeID?: string | undefined;
    commentTypeName?: string | undefined;
}

export class MarkRemovalRequest implements IMarkRemovalRequest {
    studentID?: string | undefined;
    qualificationModuleID?: string | undefined;
    markResultIDs?: string[] | undefined;
    includeFinalized?: boolean;
    includeComments?: boolean;
    reason?: string | undefined;

    constructor(data?: IMarkRemovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentID = _data["studentID"];
            this.qualificationModuleID = _data["qualificationModuleID"];
            if (Array.isArray(_data["markResultIDs"])) {
                this.markResultIDs = [] as any;
                for (let item of _data["markResultIDs"])
                    this.markResultIDs!.push(item);
            }
            this.includeFinalized = _data["includeFinalized"];
            this.includeComments = _data["includeComments"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): MarkRemovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkRemovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentID"] = this.studentID;
        data["qualificationModuleID"] = this.qualificationModuleID;
        if (Array.isArray(this.markResultIDs)) {
            data["markResultIDs"] = [];
            for (let item of this.markResultIDs)
                data["markResultIDs"].push(item);
        }
        data["includeFinalized"] = this.includeFinalized;
        data["includeComments"] = this.includeComments;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IMarkRemovalRequest {
    studentID?: string | undefined;
    qualificationModuleID?: string | undefined;
    markResultIDs?: string[] | undefined;
    includeFinalized?: boolean;
    includeComments?: boolean;
    reason?: string | undefined;
}

export class MarkWorkflowResultModel implements IMarkWorkflowResultModel {
    action?: string | undefined;
    affectedResults?: number;
    markResultIDs?: string[] | undefined;
    findings?: CalculationFinding[] | undefined;

    constructor(data?: IMarkWorkflowResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.affectedResults = _data["affectedResults"];
            if (Array.isArray(_data["markResultIDs"])) {
                this.markResultIDs = [] as any;
                for (let item of _data["markResultIDs"])
                    this.markResultIDs!.push(item);
            }
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(CalculationFinding.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkWorkflowResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkWorkflowResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["affectedResults"] = this.affectedResults;
        if (Array.isArray(this.markResultIDs)) {
            data["markResultIDs"] = [];
            for (let item of this.markResultIDs)
                data["markResultIDs"].push(item);
        }
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkWorkflowResultModel {
    action?: string | undefined;
    affectedResults?: number;
    markResultIDs?: string[] | undefined;
    findings?: CalculationFinding[] | undefined;
}

export class MarkWorkflowRequest implements IMarkWorkflowRequest {
    action?: string | undefined;
    scopes?: CalculationScopeModel[] | undefined;
    comment?: string | undefined;

    constructor(data?: IMarkWorkflowRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(CalculationScopeModel.fromJS(item));
            }
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): MarkWorkflowRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkWorkflowRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        return data;
    }
}

export interface IMarkWorkflowRequest {
    action?: string | undefined;
    scopes?: CalculationScopeModel[] | undefined;
    comment?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
